import * as i0 from '@angular/core';
import { EventEmitter, Component, Optional, Input, Injectable, ChangeDetectionStrategy, QueryList, ContentChildren, Output, ContentChild, ViewChild, Directive, HostListener, NgModule } from '@angular/core';
import * as i5 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import * as i1 from '@mobilize/angularclient';
import { NotifyChange, WMConstants, WebMapModule } from '@mobilize/angularclient';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '@progress/kendo-angular-layout';
import * as i7 from '@progress/kendo-angular-grid';
import { GridComponent as GridComponent$1, GridModule, ExcelModule, PDFModule } from '@progress/kendo-angular-grid';
import * as i6$1 from '@progress/kendo-angular-inputs';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as i2 from '@mobilize/winforms-components';
import { ControlComponent, BaseValidatorService, MainTabOrderService, TabNode, PanelComponent, ContainerTabOrderService, GridComponent, ContainerInteractionService, MarkForCheck, ControlContainerComponent, AjaxInteractionBaseService, TextBoxComponent, WebMapKendoModule, DatesUtils } from '@mobilize/winforms-components';
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { MenusModule, MenuModule } from '@progress/kendo-angular-menu';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import * as i8 from '@progress/kendo-angular-tooltip';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import * as i6 from '@progress/kendo-angular-dropdowns';
import { DropDownsModule, DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { LabelModule } from '@progress/kendo-angular-label';
import { PopupModule } from '@progress/kendo-angular-popup';
import * as i3 from '@mobilize/base-components';
import { EventData, serverEvent, dataTransfer, ContainerComponent, BaseComponentsModule } from '@mobilize/base-components';
import { __decorate } from 'tslib';
import { ExceptionHandlerClass, ErrorCodes } from '@mobilize/webmap-core';
import { Subject } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import * as i5$1 from '@progress/kendo-angular-dateinputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';

var AlinkComponent_1;
/**
 * Angular Component for the Alink Control.
 *
 * @export
 * @class AlinkComponent
 * @extends {ControlComponent}
 */
let AlinkComponent = AlinkComponent_1 = class AlinkComponent extends ControlComponent {
    /**
     * NewPageChange Extractor.
     *
     * @static
     * @param {*} event
     * @param {AlinkComponent} component
     * @return {*}  {*}
     * @memberof AlinkComponent
     */
    static NewPageEventArgsExtractor(event, component) {
        return [
            null,
            { PageType: event.args.pageTarget, MapperId: 'NewPageChangeEventArgs' }
        ];
    }
    /**
     * Creates an instance of AlinkComponent.
     *
     * @param {WebMapService} wmService
     * @param {ChangeDetectorRef} refChange
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @memberof AlinkComponent
     */
    constructor(wmService, refChange, render2, elem, webComponents, bringTopServ1) {
        super(refChange, render2, elem, webComponents, bringTopServ1);
        this.wmService = wmService;
        this.refChange = refChange;
        this.render2 = render2;
        this.elem = elem;
        this.bringTopServ1 = bringTopServ1;
        /**
         * Sets the target.
         *
         * @memberof AlinkComponent
         */
        this.Target = '';
        /**
         * PageChange event emitter.
         *
         * @type {EventEmitter<EventData>}
         * @memberof AlinkComponent
         */
        this.PageChange = new EventEmitter();
    }
    /**
     * Handler for the a tag click.
     *
     * @memberof AlinkComponent
     */
    clickHandler() {
        const eventData = new EventData('NewPageChange', this.id);
        eventData.args = { pageTarget: this.Target };
        this.triggerPageChange(eventData);
    }
    /**
     * Triggers the PageChange emitter.
     *
     * @param {*} event
     * @memberof AlinkComponent
     */
    triggerPageChange(event) {
        this.PageChange.emit(new EventData(event, this.id));
    }
};
AlinkComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AlinkComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
AlinkComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: AlinkComponent, selector: "wm-alink", inputs: { model: "model", Target: "Target" }, usesInheritance: true, ngImport: i0, template: "<a href=\"javascript:void(0)\" (click)=\"clickHandler()\" [ngClass]=\"class\" wmControls [hostComponent]=\"this\">\r\n    <ng-content></ng-content>\r\n</a>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.ControlsDirective, selector: "[wmControls]" }] });
__decorate([
    serverEvent('NewPageChange', AlinkComponent_1.NewPageEventArgsExtractor)
], AlinkComponent.prototype, "triggerPageChange", null);
AlinkComponent = AlinkComponent_1 = __decorate([
    dataTransfer(['alnk']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], AlinkComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AlinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-alink', inputs: ['model'], template: "<a href=\"javascript:void(0)\" (click)=\"clickHandler()\" [ngClass]=\"class\" wmControls [hostComponent]=\"this\">\r\n    <ng-content></ng-content>\r\n</a>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { Target: [{
                type: Input
            }], triggerPageChange: [] } });

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Service to render pages.
 *
 * @export
 * @class PagesRendererService
 */
class PagesRendererService {
    /**
     * Creates an instance of PagesRendererService.
     *
     * @param {WebMapService} wmService
     * @memberof PagesRendererService
     */
    constructor(wmService) {
        this.wmService = wmService;
        /**
         * Collection of pages IDs.
         *
         * @private
         * @type {string[]}
         * @memberof PagesRendererService
         */
        this.idsCollection = [];
    }
    /**
     * Collects all the pages that need to be rendered.
     *
     * @param {*} model
     * @memberof PagesRendererService
     */
    pagesCollector(model) {
        /* c8 ignore else */
        if (model?.UniqueID) {
            this.idsCollection.push(model.UniqueID);
            if (model.Parent) {
                const masterChildModel = this.wmService.core.getModel(model.Parent);
                this.pagesCollector(masterChildModel);
            }
        }
    }
    /**
     * Renders the direct child page of the MasterPage component.
     *
     * @param {ContainerComponent} container
     * @param {MasterPageComponent} component
     * @memberof PagesRendererService
     */
    loadPages(container, component) {
        /* c8 ignore else */
        if (container && component) {
            /* c8 ignore else */
            if (!component.model.references?.Master) {
                this.idsCollection = [];
                this.pagesCollector(component.model);
            }
            const obj = {};
            const currentComponentId = this.idsCollection.indexOf(component.id);
            /* c8 ignore else */
            if (currentComponentId >= 0 &&
                currentComponentId + 1 <= this.idsCollection.length) {
                const childIdToLoad = this.idsCollection[currentComponentId + 1];
                obj[childIdToLoad] = true;
                container.controls = obj;
                setTimeout(() => {
                    this.setInitializers(container, component);
                }, 0);
            }
        }
    }
    /**
     * Sets the initialization for the MasterPage component.
     *
     * @private
     * @param {ContainerComponent} container
     * @param {MasterPageComponent} component
     * @memberof PagesRendererService
     */
    setInitializers(container, component) {
        const openedComponents = container.openedComponents;
        const key = Object.keys(openedComponents)[0];
        const componentPage = openedComponents[key]?.instance;
        componentPage?.initializeEvent.subscribe((p) => {
            component.initializeContainers(p);
        });
    }
}
PagesRendererService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PagesRendererService, deps: [{ token: i1.WebMapService }], target: i0.ɵɵFactoryTarget.Injectable });
PagesRendererService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PagesRendererService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PagesRendererService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }]; } });

/****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Display behavior of error messages in validation controls
 *
 * @export
 * @enum {number}
 */
var ValidatorDisplay;
(function (ValidatorDisplay) {
    /**
     * Validator content dynamically added to the page when validation fails
     */
    ValidatorDisplay[ValidatorDisplay["Dynamic"] = 2] = "Dynamic";
    /**
     * Validator content never displayed inline.
     */
    ValidatorDisplay[ValidatorDisplay["None"] = 0] = "None";
    /**
     * Validator content physically part of the page layout.
     */
    ValidatorDisplay[ValidatorDisplay["Static"] = 1] = "Static";
})(ValidatorDisplay || (ValidatorDisplay = {}));

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
class WebFormsBaseValidatorService extends BaseValidatorService {
    /**
     * Base constructor of the service
     *
     * @memberof WebFormsBaseValidatorService
     */
    constructor() {
        super();
        /**
         * Property with the validators registered.
         *
         * @memberof WebFormsBaseValidatorService
         */
        this.validators = new Map();
        /**
         * Property with the validators registered.
         *
         * @memberof WebFormsBaseValidatorService
         */
        this.validationSummaries = [];
    }
    /**
     * Removes a validator from the service.
     *
     * @param controlToValidate
     * @memberof WebFormsBaseValidatorService
     */
    removeValidator(validator) {
        const validatorArray = this.validators.get(validator.controlToValidate);
        if (validatorArray != undefined) {
            const validatorIndex = validatorArray.indexOf(validator);
            if (validatorIndex > -1) {
                validatorArray.splice(validatorIndex, 1);
                if (validatorArray.length === 0) {
                    this.validators.delete(validator.controlToValidate);
                }
            }
        }
    }
    /**
     * Adds a validator to the service
     *
     * @param validator
     * @memberof WebFormsBaseValidatorService
     */
    addValidator(validator) {
        const validatorArray = this.validators.get(validator.controlToValidate);
        if (validatorArray != undefined) {
            validatorArray.push(validator);
        }
        else {
            this.validators.set(validator.controlToValidate, [validator]);
        }
    }
    /**
     * Adds a validation summary to the service
     * @param summary
     * @memberof WebFormsBaseValidatorService
     */
    addValidationSummary(summary) {
        this.validationSummaries.push(summary);
    }
    /**
     * Adds a compate validator to the service
     *
     * @param elementToCompare
     * @param validator
     * @memberof WebFormsBaseValidatorService
     */
    addCompareValidator(elementToCompare, validator) {
        const validatedArray = this.validators.get(validator.controlToValidate);
        const comparatedArray = this.validators.get(elementToCompare);
        if (validatedArray != undefined) {
            validatedArray.push(validator);
        }
        else {
            this.validators.set(validator.controlToValidate, [validator]);
        }
        if (comparatedArray != undefined) {
            comparatedArray.push(validator);
        }
        else {
            this.validators.set(elementToCompare, [validator]);
        }
    }
    /**
     * Calls to the validation method of the validators attached to a control.
     *
     * @param controlToValidate
     * @param expressionToValidate
     * @memberof WebFormsBaseValidatorService
     * @returns if none of the validations failed.
     */
    validate(controlToValidate, expressionToValidate) {
        let passed = true;
        const validatorArray = this.validators.get(controlToValidate);
        if (validatorArray != undefined) {
            validatorArray.forEach((validator) => {
                if (!validator.validateControl(controlToValidate, expressionToValidate) &&
                    passed) {
                    passed = false;
                }
            });
        }
        return passed;
    }
    /**
     * Checks the state of the validators to see if the inputs are valid.
     * If the validation failed, show them.
     * @memberof WebFormsBaseValidatorService
     * @returns if the page validations are right
     */
    checkValidators(validationGroup) {
        let valid = true;
        this.validators.forEach((value) => {
            value.forEach((validator) => {
                const element = document.querySelector(`#${validator.name}`);
                if (element &&
                    validator.validationGroup === validationGroup &&
                    !validator.validationSuccess) {
                    if (validator.Display !== ValidatorDisplay.None) {
                        validator.hidden = false;
                    }
                    else {
                        validator.hidden = true;
                    }
                    valid = false;
                }
            });
        });
        !valid
            ? this.showValidationSumaries(validationGroup)
            : this.hideValidationSumaries(validationGroup);
        return valid;
    }
    /**
     * Shows the validation summaries with the given validation group
     *
     * @param validationGroup
     * @memberof WebFormsBaseValidatorService
     */
    showValidationSumaries(validationGroup) {
        this.validationSummaries.forEach((summary) => {
            if (summary.validationGroup === validationGroup) {
                summary.updateErrorMessages();
                summary.visible = true;
            }
        });
    }
    /**
     * Hide the validation summaries with the given validation group
     *
     * @param validationGroup
     * @memberof WebFormsBaseValidatorService
     */
    hideValidationSumaries(validationGroup) {
        this.validationSummaries.forEach((summary) => {
            if (summary.validationGroup === validationGroup) {
                summary.visible = false;
            }
        });
    }
    /**
     * Retrieve the error messages of the validators with a given validationGroup.
     *
     * @param validationGroup The validation group of the validators.
     * @memberof WebFormsBaseValidatorService
     * @returns An array of strings with the error messages.
     */
    getActiveErrorMessages(validationGroup) {
        const errorMessages = [];
        const currentValidators = new Set();
        this.validators.forEach((value) => {
            value.forEach((validator) => {
                const element = document.querySelector(`#${validator.name}`);
                if (element &&
                    !validator.validationSuccess &&
                    validator.validationGroup === validationGroup) {
                    if (!currentValidators.has(validator.id)) {
                        errorMessages.push(validator.errorMessage);
                        currentValidators.add(validator.id);
                    }
                }
            });
        });
        return errorMessages;
    }
}
WebFormsBaseValidatorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebFormsBaseValidatorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
WebFormsBaseValidatorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebFormsBaseValidatorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebFormsBaseValidatorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Service to handle internal events between a Control and its internal controls.
 *
 * @export
 * @class InternalEventHandlerService
 */
class InternalEventHandlerService {
    constructor() {
        /**
         * OnButtonClick action property.
         *
         * @private
         * @type {Subject<any>}
         * @memberof InternalEventHandlerService
         */
        this.onButtonClickAction = new Subject();
    }
    /**
     * Gets the onButtonClick action.
     *
     * @readonly
     * @type {Observable<any>}
     * @memberof InternalEventHandlerService
     */
    get onButtonClick() {
        return this.onButtonClickAction.asObservable();
    }
    /**
     * Emits the onButtonClick action.
     *
     * @param {*} event
     * @memberof InternalEventHandlerService
     */
    onButtonClickEmit(event) {
        this.onButtonClickAction.next(event);
    }
}
InternalEventHandlerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: InternalEventHandlerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
InternalEventHandlerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: InternalEventHandlerService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: InternalEventHandlerService, decorators: [{
            type: Injectable
        }] });

/**
 * Service to handle DefaultButton events between a Control and its internal controls.
 *
 * @export
 * @class DefaultButtonService
 */
class DefaultButtonService {
    constructor() {
        /**
         * The click emitted subject
         *
         * @private
         * @type {Subject<EventData>}
         * @memberof AjaxInteractionService
         */
        this.clickEmitted = new Subject();
    }
    /**
     * Gets the notification for the click emit
     *
     * @readonly
     * @type {Observable<EventData>}
     * @memberof AjaxInteractionService
     */
    get ClickEmittedNotification() {
        return this.clickEmitted.asObservable();
    }
    /**
     * Notifies the click to the subscribed control
     *
     * @param {EventData} event
     * @memberof AjaxInteractionService
     */
    notifyClick(event) {
        this.clickEmitted.next(event);
    }
}
DefaultButtonService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DefaultButtonService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
DefaultButtonService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DefaultButtonService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DefaultButtonService, decorators: [{
            type: Injectable
        }] });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
class WebFormsMainTabOrderService extends MainTabOrderService {
    /**
     * Register a component instance into the service component list
     * this method overrides the method of the MainTabOrderService because dont need
     * the containerParentInstance validation since WebForms does not allow
     * to change the parent of a component dynamically.
     * @param componentInstance
     */
    registerInstance(componentInstance) {
        const nodeInstance = new TabNode(componentInstance);
        if (componentInstance instanceof ControlComponent &&
            nodeInstance.tabOrder > -1) {
            this.insertSort(nodeInstance);
            componentInstance.tabNodeReference = nodeInstance;
            this.nodesInstances.add(componentInstance.model.id, nodeInstance);
        }
    }
    /**
     * Determines whether a node instance is valid.
     * Adds a new validation to know if the instance is valid
     *
     * @param tabNodeReference The tabNode
     * @param isTabNodeReferenceRadioButton Determines if the tabbed control is a radiobutton
     * @param selectedRadioButton Contains the selected radioButton for the current container
     * @returns true if valid tab node
     * @memberof WebFormsMainTabOrderService
     */
    isValidTabNode(tabNodeReference, isTabNodeReferenceRadioButton, selectedRadioButton) {
        return (super.isValidTabNode(tabNodeReference, isTabNodeReferenceRadioButton, selectedRadioButton) && tabNodeReference.currentInstance.getStyleDisplay() != 'none');
    }
}
WebFormsMainTabOrderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebFormsMainTabOrderService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
WebFormsMainTabOrderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebFormsMainTabOrderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebFormsMainTabOrderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Angular Component for the DropdownList Control.
 *
 * @export
 * @class AspPanelComponent
 * @extends {PanelComponent}
 */
let AspPanelComponent = class AspPanelComponent extends PanelComponent {
    /**
     * Creates an instance of AspPanelComponent.
     * @param {WebMapService} serviceRef
     * @param {ChangeDetectorRef} changeDetectorRef
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @param {DefaultButtonService} defaultButtonService
     * @memberof AspPanelComponent
     */
    constructor(serviceRef, changeDetectorRef, render2, elem, webComponents, bringTopServ1, defaultButtonService) {
        super(changeDetectorRef, render2, elem, serviceRef, webComponents, bringTopServ1);
        this.changeDetectorRef = changeDetectorRef;
        this.render2 = render2;
        this.elem = elem;
        this.bringTopServ1 = bringTopServ1;
        this.defaultButtonService = defaultButtonService;
        /**
         *default variable to set groupingTextInternal in empty in case GroupingText doesn't exists in model
         *
         * @type {string}
         * @memberof AspPanelComponent
         */
        this.groupingTextInternal = '';
    }
    /**
     * Optional input parameter to specify groupingText property setter and getter.
     *
     * @memberof AspPanelComponent
     */
    set groupingText(groupingText) {
        this.groupingTextInternal = groupingText;
    }
    get groupingText() {
        return this.model.GroupingText ?? this.groupingTextInternal;
    }
    /**
     * get property to indicate if enable grouping text function.
     *
     * @memberof AspPanelComponent
     */
    get enableGroupingText() {
        return this.groupingText.length > 0;
    }
    /**
     * Key down handler
     * @param event
     */
    onKeydownEnter(event) {
        /* c8 ignore start */
        if (this.model.DefaultButton) {
            event.args = this.model.DefaultButton;
            this.defaultButtonService.notifyClick(event);
            event.stopPropagation();
            event.preventDefault();
        } /* c8 ignore stop */
    }
};
AspPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AspPanelComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: DefaultButtonService }], target: i0.ɵɵFactoryTarget.Component });
AspPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: AspPanelComponent, selector: "wm-asp-panel", inputs: { model: "model", groupingText: "groupingText" }, providers: [ContainerTabOrderService, DefaultButtonService], usesInheritance: true, ngImport: i0, template: "<fieldset [ngStyle]=\"setMyStyle()\" #displayElement *ngIf=\"model && visible\" [disabled]=\"disabled\"  class=\"wm-asp-panel\"\r\n  [ngClass]=\"class\" wmControls [hostComponent]=\"this\" (keydown.enter)=\"onKeydownEnter($event)\">\r\n  <wm-formscontainer [parentId]=\"id\"></wm-formscontainer>\r\n  <div id=\"grouping\" *ngIf=\"enableGroupingText;else nogrouping\">\r\n    <fieldset>\r\n      <legend>{{groupingText}}</legend>\r\n        <ng-content *ngTemplateOutlet=\"nogrouping\">\r\n        </ng-content>\r\n      </fieldset>\r\n  </div>\r\n\r\n  <ng-template #nogrouping>\r\n    <ng-content>\r\n    </ng-content>\r\n  </ng-template>\r\n\r\n  <wm-custom-control-container [windowModel]=\"windowModel\" (RemoveControl)=\"removeControlHandler($event)\"\r\n  [controls]=\"getControlObjects(model)\">\r\n  </wm-custom-control-container>\r\n\r\n</fieldset>\r\n", styles: ["wm-formscontainer{position:absolute;width:100%;height:100%;top:0;left:0;overflow:hidden}fieldset{border-style:none}fieldset>div>fieldset{margin:15px;border-width:2px;border-style:solid;border-color:#afadad}\n"], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i4.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i2.CustomControlContainerComponent, selector: "wm-custom-control-container", inputs: ["controls", "containerParent", "windowModel", "controlType"] }, { kind: "directive", type: i2.ControlsDirective, selector: "[wmControls]" }, { kind: "component", type: i3.FormsContainerComponent, selector: "wm-formscontainer", inputs: ["parentId"], outputs: ["Loaded"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
AspPanelComponent = __decorate([
    dataTransfer(['pnl']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], AspPanelComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AspPanelComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-asp-panel', inputs: ['model'], providers: [ContainerTabOrderService, DefaultButtonService], template: "<fieldset [ngStyle]=\"setMyStyle()\" #displayElement *ngIf=\"model && visible\" [disabled]=\"disabled\"  class=\"wm-asp-panel\"\r\n  [ngClass]=\"class\" wmControls [hostComponent]=\"this\" (keydown.enter)=\"onKeydownEnter($event)\">\r\n  <wm-formscontainer [parentId]=\"id\"></wm-formscontainer>\r\n  <div id=\"grouping\" *ngIf=\"enableGroupingText;else nogrouping\">\r\n    <fieldset>\r\n      <legend>{{groupingText}}</legend>\r\n        <ng-content *ngTemplateOutlet=\"nogrouping\">\r\n        </ng-content>\r\n      </fieldset>\r\n  </div>\r\n\r\n  <ng-template #nogrouping>\r\n    <ng-content>\r\n    </ng-content>\r\n  </ng-template>\r\n\r\n  <wm-custom-control-container [windowModel]=\"windowModel\" (RemoveControl)=\"removeControlHandler($event)\"\r\n  [controls]=\"getControlObjects(model)\">\r\n  </wm-custom-control-container>\r\n\r\n</fieldset>\r\n", styles: ["wm-formscontainer{position:absolute;width:100%;height:100%;top:0;left:0;overflow:hidden}fieldset{border-style:none}fieldset>div>fieldset{margin:15px;border-width:2px;border-style:solid;border-color:#afadad}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: DefaultButtonService }]; }, propDecorators: { groupingText: [{
                type: Input
            }] } });

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Angular Component for the DataControlField Control.
 *
 * @export
 * @class DataControlFieldComponent
 * @extends {ControlComponent}
 */
class DataControlFieldComponent extends ControlComponent {
    /**
     * Creates an instance of DataControlFieldComponent.
     *
     * @param {ChangeDetectorRef} refCh
     * @param {Renderer2} renderer2
     * @param {ElementRef} element
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ
     * @memberof DataControlFieldComponent
     */
    constructor(refCh, renderer2, element, webComponents, bringTopServ) {
        super(refCh, renderer2, element, webComponents, bringTopServ);
        this.refCh = refCh;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        /**
         * Property to save the headerText value.
         *
         * @private
         * @memberof DataControlFieldComponent
         */
        this.headerTextInternal = '';
        /**
         * Property to save the sortExpression value.
         *
         * @private
         * @memberof DataControlFieldComponent
         */
        this.sortExpressionInternal = '';
        /**
         * Property to save the visible value.
         *
         * @private
         * @memberof DataControlFieldComponent
         */
        this.visibleInternal = true;
    }
    /**
     * Gets/sets the headerText property.
     *
     * @memberof DataControlFieldComponent
     */
    set headerText(value) {
        this.headerTextInternal = value;
    }
    get headerText() {
        return this.model?.HeaderText ?? this.headerTextInternal;
    }
    /**
     * Gets/sets the sortExpression property.
     *
     * @memberof DataControlFieldComponent
     */
    set sortExpression(value) {
        this.sortExpressionInternal = value;
    }
    get sortExpression() {
        return this.model?.SortExpression ?? this.sortExpressionInternal;
    }
    /**
     * Gets the headerStyle property.
     *
     * @readonly
     * @type {*}
     * @memberof DataControlFieldComponent
     */
    get headerStyle() {
        return this.model?.HeaderStyle;
    }
    /**
     * Gets the itemStyle property.
     *
     * @readonly
     * @type {*}
     * @memberof DataControlFieldComponent
     */
    get itemStyle() {
        return this.model?.ItemStyle;
    }
    /**
     * Gets/sets the visible property.
     *
     * @memberof DataControlFieldComponent
     */
    set visible(value) {
        this.visibleInternal = value;
    }
    get visible() {
        return this.model?.Visible ?? this.visibleInternal;
    }
    /**
     * Gets the id from the model of the data control field
     *
     * @readonly
     * @type {*}
     * @memberof DataControlFieldComponent
     */
    get id() {
        return this.model?.Id;
    }
    /**
     * Override the isBindedEvent to get the event from the Field model
     *
     * @param {string} event
     * @return {*}  {boolean}
     * @memberof DataControlFieldComponent
     */
    isBindedEvent(event) {
        return (this.model?.EventChanges != null && this.model.EventChanges[event] != null);
    }
}
DataControlFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DataControlFieldComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DataControlFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: DataControlFieldComponent, selector: "ng-component", inputs: { headerText: "headerText", sortExpression: "sortExpression", visible: "visible" }, usesInheritance: true, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DataControlFieldComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { headerText: [{
                type: Input
            }], sortExpression: [{
                type: Input
            }], visible: [{
                type: Input
            }] } });

var BoundFieldComponent_1;
/**
 * Angular Component for the BoundField Control.
 *
 * @export
 * @class BoundFieldComponent
 * @extends {ControlComponent}
 */
let BoundFieldComponent = BoundFieldComponent_1 = class BoundFieldComponent extends DataControlFieldComponent {
    /**
     * Creates an instance of BoundFieldComponent.
     *
     * @param {ChangeDetectorRef} refChange
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @memberof BoundFieldComponent
     */
    constructor(refChange, render2, elem, webComponents, bringTopServ1) {
        super(refChange, render2, elem, webComponents, bringTopServ1);
        this.refChange = refChange;
        this.render2 = render2;
        this.elem = elem;
        this.bringTopServ1 = bringTopServ1;
        /**
         * Property to save the dataField value.
         *
         * @private
         * @memberof BoundFieldComponent
         */
        this.dataFieldInternal = '';
        /**
         * Property to save the dataFormatString value.
         *
         * @private
         * @memberof BoundFieldComponent
         */
        this.dataFormatStringInternal = '';
    }
    /**
     * Gets/sets the dataField property.
     *
     * @memberof BoundFieldComponent
     */
    set dataField(value) {
        this.dataFieldInternal = value;
    }
    get dataField() {
        return this.model?.DataField ?? this.dataFieldInternal;
    }
    /**
     * Gets/sets the dataFormat property.
     *
     * @memberof BoundFieldComponent
     */
    set dataFormatString(value) {
        this.dataFormatStringInternal = value;
    }
    get dataFormatString() {
        return this.model?.DataFormatString ?? this.dataFormatStringInternal;
    }
};
BoundFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BoundFieldComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
BoundFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BoundFieldComponent, selector: "wm-bound-field", inputs: { model: "model", dataField: "dataField", dataFormatString: "dataFormatString" }, providers: [
        { provide: DataControlFieldComponent, useExisting: BoundFieldComponent_1 }
    ], usesInheritance: true, ngImport: i0, template: "<div></div>", styles: [""], changeDetection: i0.ChangeDetectionStrategy.OnPush });
BoundFieldComponent = BoundFieldComponent_1 = __decorate([
    dataTransfer(['bndfld']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], BoundFieldComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BoundFieldComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-bound-field', providers: [
                        { provide: DataControlFieldComponent, useExisting: BoundFieldComponent }
                    ], inputs: ['model'], template: "<div></div>" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { dataField: [{
                type: Input
            }], dataFormatString: [{
                type: Input
            }] } });

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Specifies the unit of measurement.
 *
 * @export
 * @enum {number}
 */
var UnitType;
(function (UnitType) {
    /**
     * Measurement is in pixels.
     */
    UnitType[UnitType["Pixel"] = 1] = "Pixel";
    /**
     * Measurement is in points. A point represents 1/72 of an inch.
     */
    UnitType[UnitType["Point"] = 2] = "Point";
    /**
     * Measurement is in picas. A pica represents 12 points.
     */
    UnitType[UnitType["Pica"] = 3] = "Pica";
    /**
     * Measurement is in inches.
     */
    UnitType[UnitType["Inch"] = 4] = "Inch";
    /**
     * Measurement is in millimeters.
     */
    UnitType[UnitType["Mm"] = 5] = "Mm";
    /**
     * Measurement is in centimeters.
     */
    UnitType[UnitType["Cm"] = 6] = "Cm";
    /**
     * Measurement is a percentage relative to the parent element.
     */
    UnitType[UnitType["Percentage"] = 7] = "Percentage";
    /**
     * Measurement is relative to the height of the parent element's font.
     */
    UnitType[UnitType["Em"] = 8] = "Em";
    /**
     * Measurement is relative to the height of the lowercase letter x of the parent element's font.
     */
    UnitType[UnitType["Ex"] = 9] = "Ex";
})(UnitType || (UnitType = {}));

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Specifies the gridline styles for controls that display items in a table structure.
 *
 * @export
 * @enum {number}
 */
var GridLines;
(function (GridLines) {
    /**
     * Both horizontal and vertical gridlines are rendered.
     */
    GridLines[GridLines["Both"] = 3] = "Both";
    /**
     * Only horizontal gridlines are rendered.
     */
    GridLines[GridLines["Horizontal"] = 1] = "Horizontal";
    /**
     * No gridlines are rendered.
     */
    GridLines[GridLines["None"] = 0] = "None";
    /**
     * Only vertical gridlines are rendered.
     */
    GridLines[GridLines["Vertical"] = 2] = "Vertical";
})(GridLines || (GridLines = {}));

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Vertical Align enum for the Pager of GridView
 *
 * @export
 * @enum {number}
 */
var PagerVerticalAlign;
(function (PagerVerticalAlign) {
    /**
     * Aligns the pager to the bottom verticaly
     */
    PagerVerticalAlign[PagerVerticalAlign["Bottom"] = 2] = "Bottom";
    /**
     * Aligns the pager to the center verticaly
     */
    PagerVerticalAlign[PagerVerticalAlign["Center"] = 1] = "Center";
    /**
     * Aligns the pager to stretch verticaly
     */
    PagerVerticalAlign[PagerVerticalAlign["Stretch"] = 3] = "Stretch";
    /**
     * Aligns the pager to the top verticaly
     */
    PagerVerticalAlign[PagerVerticalAlign["Top"] = 0] = "Top";
})(PagerVerticalAlign || (PagerVerticalAlign = {}));

/****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Specifies the display mode in the Validation Summary.
 *
 * @export
 * @enum {number}
 */
var ValidationSummaryDisplayMode;
(function (ValidationSummaryDisplayMode) {
    /**
     * Displayed in a list.
     */
    ValidationSummaryDisplayMode[ValidationSummaryDisplayMode["List"] = 0] = "List";
    /**
     * Displayed in a bulleted list.
     */
    ValidationSummaryDisplayMode[ValidationSummaryDisplayMode["BulletList"] = 1] = "BulletList";
    /**
     * Displayed in a single paragraph.
     */
    ValidationSummaryDisplayMode[ValidationSummaryDisplayMode["SingleParagraph"] = 2] = "SingleParagraph";
})(ValidationSummaryDisplayMode || (ValidationSummaryDisplayMode = {}));

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Angular Component for the GridView Columns Control.
 *
 * @export
 * @class GridViewColumnsComponent
 */
class GridViewColumnsComponent {
    constructor() {
        /**
         * List of DataControlField components.
         *
         * @type {QueryList<DataControlFieldComponent>}
         * @memberof GridViewColumnsComponent
         */
        this.controlFieldChildren = new QueryList();
    }
}
GridViewColumnsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GridViewColumnsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
GridViewColumnsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: GridViewColumnsComponent, selector: "wm-gridview-columns", queries: [{ propertyName: "controlFieldChildren", predicate: DataControlFieldComponent }], ngImport: i0, template: "<ng-content></ng-content>", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GridViewColumnsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-gridview-columns', template: "<ng-content></ng-content>" }]
        }], propDecorators: { controlFieldChildren: [{
                type: ContentChildren,
                args: [DataControlFieldComponent]
            }] } });

var HyperlinkFieldComponent_1;
/**
 * Angular Component for the HyperLinkField Control.
 *
 * @export
 * @class HyperlinkFieldComponent
 * @extends {DataControlFieldComponent}
 */
let HyperlinkFieldComponent = HyperlinkFieldComponent_1 = class HyperlinkFieldComponent extends DataControlFieldComponent {
    /**
     * NavigateToPage Extractor.
     *
     * @static
     * @param {*} event
     * @param {HyperlinkFieldComponent} component
     * @return {*}  {*}
     * @memberof HyperlinkFieldComponent
     */
    static NavigateToPageEventArgsExtractor(event, component) {
        return [
            {
                Id: event.Id,
                MapperId: event.mapperId
            },
            {
                RowIndex: event.args.rowIndex,
                MapperId: 'NavigateToPageEventArgs'
            }
        ];
    }
    /**
     * Creates an instance of HyperlinkFieldComponent.
     *
     * @param {ChangeDetectorRef} refChange
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @memberof HyperlinkFieldComponent
     */
    constructor(refChange, render2, elem, webComponents, bringTopServ1) {
        super(refChange, render2, elem, webComponents, bringTopServ1);
        this.refChange = refChange;
        this.render2 = render2;
        this.elem = elem;
        this.bringTopServ1 = bringTopServ1;
        /**
         * Property to save the text value.
         *
         * @private
         * @memberof HyperlinkFieldComponent
         */
        this.textInternal = '';
        /**
         * Property to save the dataTextField value.
         *
         * @private
         * @memberof HyperlinkFieldComponent
         */
        this.dataTextFieldInternal = '';
        /**
         * Property to save the dataNavigateUrlFields array value.
         *
         * @private
         * @type {string[]}
         * @memberof HyperlinkFieldComponent
         */
        this.dataNavigateUrlFieldsInternal = [];
        /**
         * Property to save the dataNavigateUrlFormatString value.
         *
         * @private
         * @memberof HyperlinkFieldComponent
         */
        this.dataNavigateUrlFormatStringInternal = '';
        /**
         * Emitter for the NavigateToPage event.
         *
         * @type {EventEmitter<EventData>}
         * @memberof HyperlinkFieldComponent
         */
        this.NavigateToPage = new EventEmitter();
    }
    /**
     * Gets/sets the text property
     *
     * @memberof HyperlinkFieldComponent
     */
    set text(value) {
        this.textInternal = value;
    }
    get text() {
        return this.model.Text ?? this.textInternal;
    }
    /**
     * Gets/sets the dataTextField property.
     *
     * @memberof HyperlinkFieldComponent
     */
    set dataTextField(value) {
        this.dataTextFieldInternal = value;
    }
    get dataTextField() {
        return this.model.DataTextField ?? this.dataTextFieldInternal;
    }
    /**
     * Sets the dataNavigateUrlFields property.
     *
     * @memberof HyperlinkFieldComponent
     */
    set dataNavigateUrlFields(value) {
        const array = value.split(',');
        this.dataNavigateUrlFieldsInternal = array.map((item) => item.trim());
    }
    /**
     * Gets the dataNavigateUrlFields property value.
     *
     * @readonly
     * @type {string[]}
     * @memberof HyperlinkFieldComponent
     */
    get dataNavigateUrlFieldsValue() {
        return (this.model.DataNavigateUrlFields ?? this.dataNavigateUrlFieldsInternal);
    }
    /**
     * Gets/sets the dataNavigateUrlFormatString property.
     *
     * @memberof HyperlinkFieldComponent
     */
    set dataNavigateUrlFormatString(value) {
        this.dataNavigateUrlFormatStringInternal = value;
    }
    get dataNavigateUrlFormatString() {
        return (this.model.DataNavigateUrlFormatString ??
            this.dataNavigateUrlFormatStringInternal);
    }
    /**
     * Returns the target page with the correct format/params.
     *
     * @param {*} dataItem
     * @return {*}  {string}
     * @memberof HyperlinkFieldComponent
     */
    getTarget(dataItem) {
        const StringFormat = (str, args) => str.replace(/{(\d+)}/g, (match, index) => args[index] || '');
        const values = [];
        for (const field of this.dataNavigateUrlFieldsValue) {
            const itemValue = dataItem[field];
            values.push(itemValue);
        }
        return StringFormat(this.dataNavigateUrlFormatString, values);
    }
    /**
     * Returns the parameters in the target URL.
     *
     * @param {string} target
     * @return {*}  {*}
     * @memberof HyperlinkFieldComponent
     */
    getTargetParams(target) {
        const params = new URLSearchParams(target.substring(target.indexOf('?') + 1));
        const result = {};
        params.forEach((value, key) => {
            result[key] = value;
        });
        return result;
    }
    /**
     * Handler for the HyperLinkField click.
     *
     * @param {*} dataItem
     * @memberof HyperlinkFieldComponent
     */
    clickHandler(dataItem, rowIndex) {
        const eventData = new EventData('NavigateToPage', this.id);
        eventData.mapperId = 'hprlnkfld';
        eventData.args = { rowIndex: rowIndex };
        this.triggerNavigateToPage(eventData);
    }
    /**
     * Triggers the NavigateToPage event.
     *
     * @param {*} event
     * @memberof HyperlinkFieldComponent
     */
    triggerNavigateToPage(event) {
        this.NavigateToPage.emit(new EventData(event, this.id));
    }
};
HyperlinkFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HyperlinkFieldComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
HyperlinkFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: HyperlinkFieldComponent, selector: "wm-hyperlink-field", inputs: { model: "model", text: "text", dataTextField: "dataTextField", dataNavigateUrlFields: "dataNavigateUrlFields", dataNavigateUrlFormatString: "dataNavigateUrlFormatString" }, outputs: { NavigateToPage: "NavigateToPage" }, providers: [
        { provide: DataControlFieldComponent, useExisting: HyperlinkFieldComponent_1 }
    ], usesInheritance: true, ngImport: i0, template: "<div></div>\r\n", styles: [""], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    serverEvent('NavigateToPage', HyperlinkFieldComponent_1.NavigateToPageEventArgsExtractor)
], HyperlinkFieldComponent.prototype, "triggerNavigateToPage", null);
HyperlinkFieldComponent = HyperlinkFieldComponent_1 = __decorate([
    dataTransfer(['hyprlnkfld']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], HyperlinkFieldComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HyperlinkFieldComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-hyperlink-field', providers: [
                        { provide: DataControlFieldComponent, useExisting: HyperlinkFieldComponent }
                    ], inputs: ['model'], template: "<div></div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { NavigateToPage: [{
                type: Output
            }], text: [{
                type: Input
            }], dataTextField: [{
                type: Input
            }], dataNavigateUrlFields: [{
                type: Input
            }], dataNavigateUrlFormatString: [{
                type: Input
            }], triggerNavigateToPage: [] } });

var TemplateFieldComponent_1;
/**
 * Angular Component for the TemplateField Control.
 *
 * @export
 * @class TemplateFieldComponent
 * @extends {DataControlFieldComponent}
 */
let TemplateFieldComponent = TemplateFieldComponent_1 = class TemplateFieldComponent extends DataControlFieldComponent {
    /**
     * Creates an instance of TemplateFieldComponent.
     *
     * @param {WebMapService} wmService
     * @param {ChangeDetectorRef} refChange
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @memberof TemplateFieldComponent
     */
    constructor(wmService, refChange, render2, elem, webComponents, bringTopServ1) {
        super(refChange, render2, elem, webComponents, bringTopServ1);
        this.wmService = wmService;
        this.refChange = refChange;
        this.render2 = render2;
        this.elem = elem;
        this.bringTopServ1 = bringTopServ1;
        /**
         * ItemTemplate children models.
         *
         * @type {any[]}
         * @memberof TemplateFieldComponent
         */
        this.itemTemplateModels = [];
    }
    /**
     * Resolves and sets the models for each child item in the ItemTemplate.
     *
     * @param {any[]} controlsIds. Collection of {"name": "id"} objects to resolve the models.
     * @memberof TemplateFieldComponent
     */
    setItemTemplateModels(controlsIds) {
        this.itemTemplateModels = [];
        controlsIds.forEach((iteration) => {
            const iterationKeys = Object.keys(iteration);
            const iterationModels = {};
            iterationKeys.forEach((controlName) => {
                iterationModels[controlName] = this.wmService.core.getModel(iteration[controlName]);
            });
            this.itemTemplateModels.push(iterationModels);
        });
    }
};
TemplateFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TemplateFieldComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
TemplateFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TemplateFieldComponent, selector: "wm-template-field", inputs: { model: "model" }, providers: [
        { provide: DataControlFieldComponent, useExisting: TemplateFieldComponent_1 }
    ], queries: [{ propertyName: "itemTemplate", first: true, predicate: ["ItemTemplate"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-content></ng-content>", styles: [""] });
TemplateFieldComponent = TemplateFieldComponent_1 = __decorate([
    dataTransfer(['tmpltfld']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], TemplateFieldComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TemplateFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-template-field', providers: [
                        { provide: DataControlFieldComponent, useExisting: TemplateFieldComponent }
                    ], inputs: ['model'], template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { itemTemplate: [{
                type: ContentChild,
                args: ['ItemTemplate']
            }] } });

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Const used as key for the background color style property
 *  @type {*} */
const backColorString = 'background-color';
/**
 * Const used as key for the width style property
 *  @type {*} */
const widthString = 'width';
/**
 * ColumnStyle manager
 *
 * This class is used to set the GridView columns styles. Including headers, rows, cells, and footers
 *
 * @export
 * @class ColumnStyleManager
 */
class ColumnStyleManager {
    /**
     * Creates an instance of ColumnStyleManager.
     * @memberof ColumnStyleManager
     */
    constructor() {
        /**
         * Object used to set the Cell Style
         * @private
         * @memberof ColumnStyleManager
         */
        this.cellStyleObject = {
            'background-color': null,
            width: null
        };
    }
    /**
     * Gets the cell style object
     *
     * @readonly
     * @type {*}
     * @memberof ColumnStyleManager
     */
    get cellStyle() {
        return this.cellStyleObject;
    }
    /**
     * Applies the cell style
     *
     * This is because is needed to validate if applies the RowStyle props or the cell style of DataControlFields
     * @param {DataControlFieldComponent | any} columnControl the column control model
     * @param {*} rowStyle the row style object
     * @return {*}  {*}
     * @memberof ColumnStyleManager
     */
    applyCellStyle(columnControl, rowStyle) {
        const unitType = UnitType[columnControl.itemStyle?.Width?.Type];
        const itemStyleWidth = columnControl.itemStyle?.Width?.Value;
        /* c8 ignore next 2 */
        const itemStyleBackgroundColor = columnControl.itemStyle?.BackColor ?? rowStyle?.BackColor ?? null;
        if (itemStyleWidth) {
            const width = unitType === UnitType.Percentage
                ? `${itemStyleWidth}%`
                : `${itemStyleWidth}px`;
            this.cellStyleObject = this.applyPropToStyleObject(widthString, width, this.cellStyleObject);
        }
        this.applyPropToStyleObject(backColorString, itemStyleBackgroundColor, this.cellStyleObject);
        return this.cellStyleObject;
    }
    /**
     * Applies the property value to a given style object (cellStyleObjetc, headerStyleObject, etc)
     *
     * @param {string} prop The property to be applied
     * @param {string} value The value of the property
     * @param {*} styleObject the object to apply the property. This could be the HeaderStyle, rowStyle, etc
     * @return {*}  {*}
     * @memberof ColumnStyleManager
     */
    applyPropToStyleObject(prop, value, styleObject) {
        styleObject[prop] = value;
        return styleObject;
    }
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Pager style manager class
 *
 * This class provides the methods and build the style for a given pager of a gridview component
 *
 * @export
 * @class PagerStyleManager
 */
class PagerStyleManager {
    constructor(styleObject) {
        this.styleModel = styleObject;
        this.style = {};
    }
    /**
     * Gets the BackColor property
     *
     * @readonly
     * @type {*}
     * @memberof PagerStyleManager
     */
    get backgroundColor() {
        return this.styleModel?.BackColor ?? null;
    }
    /**
     * Gets the BorderColor property
     *
     * @readonly
     * @type {*}
     * @memberof PagerStyleManager
     */
    get borderColor() {
        return this.styleModel?.BorderColor ?? null;
    }
    /**
     * Gets the BorderWidth property
     *
     * @readonly
     * @type {*}
     * @memberof PagerStyleManager
     */
    get borderWidth() {
        return this.styleModel?.BorderWidth ?? null;
    }
    /**
     * Gets the ForeColor property
     *
     * @readonly
     * @type {*}
     * @memberof PagerStyleManager
     */
    get color() {
        return this.styleModel?.ForeColor ?? null;
    }
    /**
     * Gets the Height property
     *
     * @readonly
     * @type {*}
     * @memberof PagerStyleManager
     */
    get height() {
        return this.styleModel?.Height ?? null;
    }
    /**
     * Gets the Width property
     *
     * @readonly
     * @type {*}
     * @memberof PagerStyleManager
     */
    get width() {
        return this.styleModel?.Width ?? '100%';
    }
    /**
     * Sets the background color property to style
     *
     * @memberof PagerStyleManager
     */
    setBackColor() {
        if (this.validateStyleModelProperty('BackColor')) {
            this.setStyleProperty(this.styleModel['BackColor'], 'background-color');
        }
    }
    /**
     * Sets the border color property to style
     *
     * @memberof PagerStyleManager
     */
    setBorderColor() {
        if (this.validateStyleModelProperty('BorderColor')) {
            this.setStyleProperty(this.styleModel['BorderColor'], 'border-color');
        }
    }
    /**
     * Sets the border width property to style
     *
     * @memberof PagerStyleManager
     */
    setBorderWidth() {
        if (this.validateStyleModelProperty('BorderWidth')) {
            this.setStyleProperty(this.styleModel['BorderWidth'], 'border-width');
        }
    }
    /**
     * Sets the color property to style
     *
     * @memberof PagerStyleManager
     */
    setFontColor() {
        if (this.validateStyleModelProperty('ForeColor')) {
            this.setStyleProperty(this.styleModel['ForeColor'], 'color');
        }
    }
    /**
     * Sets the heigth property to style
     *
     * @memberof PagerStyleManager
     */
    setHeight() {
        if (this.validateStyleModelProperty('Height')) {
            this.setStyleProperty(this.styleModel['Height'], 'height');
        }
    }
    /**
     * Sets the width property to style
     *
     * @memberof PagerStyleManager
     */
    setWidth() {
        if (this.validateStyleModelProperty('Width')) {
            this.setStyleProperty(this.styleModel['Width'], 'width');
        }
    }
    /**
     * Sets the top property to style
     *
     * @memberof PagerStyleManager
     */
    setTop() {
        if (this.validateStyleModelProperty('VerticalAlign')) {
            switch (this.styleModel['VerticalAlign']) {
                case PagerVerticalAlign.Center:
                    this.setStyleProperty('0%', 'top');
                    break;
                case PagerVerticalAlign.Bottom:
                    this.setStyleProperty('40%', 'top');
                    break;
                case PagerVerticalAlign.Top:
                    this.setStyleProperty('-40%', 'top');
                    break;
                default:
                    break;
            }
        }
        return this.style;
    }
    /**
     * Sets the pager style properties
     *
     * @return {*}  {*}
     * @memberof PagerStyleManager
     */
    setPagerStyle() {
        this.setBackColor();
        this.setBorderColor();
        this.setBorderWidth();
        this.setFontColor();
        this.setHeight();
        this.setWidth();
        this.setTop();
        return _.isEmpty(this.style) ? null : this.style;
    }
    /**
     * Sets the style property new value to the style object
     *
     * @param {propertyStyle} value
     * @param {keyof PagerStyle} property
     * @memberof PagerStyleManager
     */
    setStyleProperty(value, property) {
        /* c8 ignore else */
        if (value != null && value !== this.style[property]) {
            this.style[property] = value;
        }
    }
    /**
     * Validates if a property exists into the style model object
     *
     * @param {string} property
     * @return {*}  {boolean}
     * @memberof PagerStyleManager
     */
    validateStyleModelProperty(property) {
        return this.styleModel && this.styleModel[property] != null;
    }
}

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Horizontal align for the GridView pager
 *
 * @export
 * @enum {number}
 */
var PagerHorizontalAlign;
(function (PagerHorizontalAlign) {
    /**
     * Aligns the pager to the center horizontaly
     */
    PagerHorizontalAlign[PagerHorizontalAlign["Center"] = 2] = "Center";
    /**
     * Aligns the pager justified horizontaly
     */
    PagerHorizontalAlign[PagerHorizontalAlign["Justify"] = 4] = "Justify";
    /**
     * Aligns the pager to the left horizontaly
     */
    PagerHorizontalAlign[PagerHorizontalAlign["Left"] = 1] = "Left";
    /**
     * Doesn't specify an aligment
     */
    PagerHorizontalAlign[PagerHorizontalAlign["NotSet"] = 0] = "NotSet";
    /**
     * Aligns the pager to the right horizontaly
     */
    PagerHorizontalAlign[PagerHorizontalAlign["Right"] = 3] = "Right";
})(PagerHorizontalAlign || (PagerHorizontalAlign = {}));

var GridViewComponent_1;
/**
 * Angular Component for the GridView Control.
 *
 * @export
 * @ class GridViewComponent
 * @extends {GridComponent}
 * @implements {OnInit}
 * @implements {DoCheck}
 */
let GridViewComponent = GridViewComponent_1 = class GridViewComponent extends GridComponent {
    /**
     * Creates an array of elements with the arguments for the sort handler in the backend
     *
     * @param {*} event
     * @param {GridViewComponent} component
     * @memberof GridViewComponent
     * @returns the event args necessary for the sort event
     */
    static SortExtractor(event, component) {
        return [
            { Id: event.Id, MapperId: event.args.MapperId },
            {
                MapperId: GridViewComponent_1.sortMapperId,
                SortExpression: event.args.sortExpression,
                Direction: event.args.direction
            }
        ];
    }
    /**
     * SelectedIndexChanging Extractor
     *
     * @static
     * @param {*} event
     * @param {GridViewComponent} component
     * @return {*}  {*}
     * @memberof GridViewComponent
     */
    static SelectedIndexChangingArgsExtractor(event, component) {
        return [
            null,
            {
                NewSelectedRow: event.args.selectedRow,
                MapperId: GridViewComponent_1.selectedRowMapperId
            }
        ];
    }
    /**
     * PageIndexChanging extractor
     *
     * @static
     * @param {*} event
     * @param {GridViewComponent} component
     * @return {*}  {*}
     * @memberof GridViewComponent
     */
    static PageIndexChangingExtractor(event, component) {
        return [
            { Id: event.Id, MapperId: event.mapperId },
            {
                MapperId: 'grdvwpgvntrgs',
                NewPageIndex: event.args.newPageIndex
            }
        ];
    }
    /**
     * RowCommand extractor
     *
     * @static
     * @param {*} event
     * @param {GridViewComponent} component
     * @return {*}  {*}
     * @memberof GridViewComponent
     */
    static RowCommandExtractor(event, component) {
        return [
            { Id: event.Id, MapperId: event.mapperId },
            {
                MapperId: GridViewComponent_1.rowCommandMapperId,
                CommandName: event.args.CommandName,
                CommandArgument: event.args.CommandArgument,
                References: {
                    CommandSource: event.args.CommandSource
                }
            }
        ];
    }
    /**
     * Creates an instance of GridViewComponent.
     *
     * @param {WebMapService} wmService
     * @param {ChangeDetectorRef} refChange
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {FormBuilder} formBuilderRef
     * @param {InternalEventHandlerService} internalEventHandler
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @memberof GridViewComponent
     */
    constructor(wmService, refChange, render2, elem, formBuilderRef, internalEventHandler, webComponents, bringTopServ1) {
        super(wmService, refChange, render2, elem, formBuilderRef, webComponents, bringTopServ1);
        this.wmService = wmService;
        this.refChange = refChange;
        this.render2 = render2;
        this.elem = elem;
        this.formBuilderRef = formBuilderRef;
        this.internalEventHandler = internalEventHandler;
        this.bringTopServ1 = bringTopServ1;
        /**
         * Flag to remove the kendo alternative class only one time
         *
         * @type {boolean}
         * @memberof GridViewComponent
         */
        this.kendoAltClassRemoved = false;
        /**
         * Url base value.
         *
         * @memberof GridViewComponent
         */
        this.defaultDataUrl = 'api/gridview';
        /**
         * Emiter for the sorting event.
         *
         * @memberof GridViewComponent
         */
        this.Sorting = new EventEmitter();
        /**
         * Emitter for the page index changing event
         *
         * @type {EventEmitter<EventData>}
         * @memberof GridViewComponent
         */
        this.PageIndexChanging = new EventEmitter();
        /**
         * Emitter for the selected row changing event
         *
         * @type {EventEmitter<EventData>}
         * @memberof GridViewComponent
         */
        this.SelectedRowChange = new EventEmitter();
        /**
         * Emitter for double click row event
         *
         * @type {EventEmitter<EventData>}
         * @memberof GridViewComponent
         */
        this.DoubleClick = new EventEmitter();
        /**
         * Emitter for the onRowCommand Event.
         *
         * @type {EventEmitter<{ source: any; e: any }>}
         * @memberof GridViewComponent
         */
        this.OnRowCommand = new EventEmitter();
        /**
         * Url to get the Grid's Columns set.
         *
         * @memberof GridViewComponent
         */
        this.getColumnsUrl = `${this.defaultDataUrl}/GetColumns`;
        /**
         * Url to get the page data with specific index.
         *
         * @memberof GridViewComponent
         */
        this.getIndexPageUrl = `${this.defaultDataUrl}/GetIndexPage`;
        /**
         * Url to get the page data with specific range.
         *
         * @memberof GridViewComponent
         */
        this.getRangedPageUrl = `${this.defaultDataUrl}/GetRangedPage`;
        /**
         * Property to save the KendoGrid index.
         *
         * @memberof GridViewComponent
         */
        this.kendoCurrentPage = 0;
        /**
         * Property to save the allowPaging value.
         *
         * @memberof GridViewComponent
         */
        this.allowPagingInternal = false;
        /**
         * Property to save the allowSorting value.
         *
         * @private
         * @memberof GridViewComponent
         */
        this.allowSortingInternal = false;
        /**
         * Property to save the autoGenerateSelectButton value.
         *
         * @private
         * @memberof GridViewComponent
         */
        this.autoGenerateSelectButtonInternal = false;
        /**
         * Property to save the selectedIndex value.
         *
         * @private
         * @memberof GridViewComponent
         */
        this.selectedIndexInternal = -1;
        /**
         * Property to save the pageIndex value.
         *
         * @private
         * @memberof GridViewComponent
         */
        this.pageIndexInternal = 0;
        /**
         * Property to save the autoGenerateColumns value.
         *
         * @private
         * @memberof GridViewComponent
         */
        this.autoGenerateColumnsInternal = true;
        /**
         * Property to save the  hideHeader value.
         *
         * @private
         * @memberof GridViewComponent
         */
        this.hideHeaderInternal = false;
        /**
         * Property to know if the loadData has been called at least once.
         *
         * @private
         * @memberof GridViewComponent
         */
        this.isDataLoaded = false;
        /**
         * Flag to know if the component is rendered.
         *
         * @private
         * @memberof GridViewComponent
         */
        this.isRendered = false;
        /**
         * Flag to know if the columns are loaded.
         *
         * @private
         * @memberof GridViewComponent
         */
        this.areColumnsLoaded = false;
        /**
         * Flag to apply the gridLines if it comes by input
         *
         * @private
         * @memberof GridViewComponent
         */
        this.gridLinesInternal = GridLines.Both;
        /**
         * Property to save the gridview width value.
         *
         * @memberof GridViewComponent
         */
        this.gridWidthInternal = 'auto';
        /**
         * Flag to know if apply autofitcolumns.
         *
         * @memberof GridViewComponent
         */
        this.autoFitGridViewInternal = false;
        /**
         * Property to save the columns controls.
         *
         * @type {any[]}
         * @memberof GridViewComponent
         */
        this.columnsControls = [];
        /**
         * Property to save selectedRow element.
         *
         * @type {any}
         * @memberof GridViewComponent
         */
        this.rowElement = undefined;
        /**
         * Controls in the gridview
         *
         * @type {any[]}
         * @memberof GridViewComponent
         */
        this.controls = [];
        /**
         * SelectedIndexChanging event emitter.
         *
         * @type {EventEmitter<EventData>}
         * @memberof GridViewComponent
         */
        this.SelectedIndexChanging = new EventEmitter();
        /**
         * List of DataControlField components.
         *
         * @type {QueryList<DataControlFieldComponent>}
         * @memberof GridViewComponent
         */
        this.controlFieldChildren = new QueryList();
        /**
         * Applies the css row class
         *
         * @param {RowClassArgs} context
         * @return {*}
         * @memberof GridViewComponent
         */
        this.getRowClass = (context) => {
            const className = {};
            if (this.alternatingRowClass && context.index % 2 !== 0) {
                className[this.alternatingRowClass] = true;
                return className;
            }
            className[this.rowClass] = true;
            return className;
        };
        this.getRowClass.bind(this);
    }
    /**
     * OnInit lifecycle hook.
     *
     * @memberof GridViewComponent
     */
    ngOnInit() {
        this.setSelectableSettings();
        this.loadColumns();
        this.loadData();
        this.internalClickHandler();
    }
    /**
     * AfterViewInit lifecycle hook.
     *
     * @memberof GridViewComponent
     */
    ngAfterViewInit() {
        if (this.columnsChild?.controlFieldChildren) {
            this.controlFieldChildren = this.columnsChild.controlFieldChildren;
        }
        this.isRendered = true;
        this.setColumnControlFields();
    }
    /**
     * Gets/sets the allowPaging.
     *
     * @memberof GridViewComponent
     */
    set allowPaging(value) {
        this.allowPagingInternal = value;
    }
    get allowPaging() {
        return ((this.model.AllowPaging ?? this.allowPagingInternal) &&
            !this.isGridViewEmpty());
    }
    /**
     * Gets/sets the autofit GridView.
     *
     * @memberof GridViewComponent
     */
    set autoFitGridView(value) {
        this.autoFitGridViewInternal = value;
    }
    get autoFitGridView() {
        return this.autoFitGridViewInternal;
    }
    /**
     * Gets/sets the hideHeader GridView property.
     *
     * @memberof GridViewComponent
     */
    set hideHeader(value) {
        this.hideHeaderInternal = value;
    }
    get hideHeader() {
        return ((this.model.ShowHeader != undefined
            ? !this.model.ShowHeader
            : this.hideHeaderInternal) || this.isGridViewEmpty());
    }
    /**
     * Check total of items in the gridVew
     *nn
     * @return {boolean}
     */
    isGridViewEmpty() {
        return this.gridView?.total === 0;
    }
    /**
     * Gets/sets the pageSize.
     *
     * @memberof GridViewComponent
     */
    set pageSize(value) {
        /* c8 ignore else*/
        if (this.allowPaging) {
            this.pageSizeInternal = value;
        }
    }
    get pageSize() {
        if (this.allowPaging) {
            return this.model.PageSize ?? this.pageSizeInternal ?? 10;
        }
        return 100;
    }
    /**
     * Gets/sets the allowSorting.
     *
     * @memberof GridViewComponent
     */
    set allowSorting(value) {
        this.allowSortingInternal = value;
    }
    get allowSorting() {
        return this.model.AllowSorting ?? this.allowSortingInternal;
    }
    /**
     * Gets/sets the autoGenerateSelectButton.
     *
     * @memberof GridViewComponent
     */
    set autoGenerateSelectButton(value) {
        this.autoGenerateSelectButtonInternal = value;
    }
    get autoGenerateSelectButton() {
        return (this.model.AutoGenerateSelectButton ??
            this.autoGenerateSelectButtonInternal);
    }
    /**
     * Gets/sets the pageIndex.
     *
     * @memberof GridViewComponent
     */
    set pageIndex(value) {
        this.pageIndexInternal = value;
    }
    get pageIndex() {
        return this.model?.PageIndex ?? this.pageIndexInternal ?? 0;
    }
    /**
     * Gets/sets the selectedIndex.
     *
     * @memberof GridViewComponent
     */
    set selectedIndex(value) {
        this.selectedIndexInternal = value;
    }
    get selectedIndex() {
        let result;
        if (this.allowPaging) {
            if (this.model.SelectedIndex && this.model.SelectedIndex >= 0) {
                result = this.model.SelectedIndex + this.skip;
            }
            else if (this.selectedIndexInternal >= 0) {
                result = this.selectedIndexInternal + this.skip;
            }
            else {
                result = this.selectedIndexInternal;
            }
        }
        else {
            result =
                this.model.SelectedIndex && this.model.SelectedIndex >= 0
                    ? this.model.SelectedIndex
                    : this.selectedIndexInternal;
        }
        return result;
    }
    /**
     * Gets/sets the autoGenerateColumns property.
     *
     * @memberof GridViewComponent
     */
    set autoGenerateColumns(value) {
        this.autoGenerateColumnsInternal = value;
    }
    get autoGenerateColumns() {
        return this.model.AutoGenerateColumns ?? this.autoGenerateColumnsInternal;
    }
    /**
     * GridLines property from model or input if exists
     *
     * @readonly
     * @type {string}
     * @memberof GridViewComponent
     */
    set gridLines(value) {
        this.gridLinesInternal = value;
    }
    get gridLines() {
        return (this.model && this.model.GridLines) ?? this.gridLinesInternal;
    }
    /**
     *
     * Get the row css class from the model
     * @readonly
     * @type {string}
     * @memberof GridViewComponent
     */
    get rowClass() {
        return this.model?.RowStyle?.CssClass ?? '';
    }
    /**
     * Gets the row style object from model
     *
     * @readonly
     * @type {*}
     * @memberof GridViewComponent
     */
    get rowStyle() {
        return this.model?.RowStyle;
    }
    /**
     * Gets the alternating row style object from model
     *
     * @readonly
     * @type {*}
     * @memberof GridViewComponent
     */
    get alternatingRowStyle() {
        return this.model?.AlternatingRowStyle;
    }
    /**
     * Gets the alternating row class from the model
     *
     * @readonly
     * @type {*}
     * @memberof GridViewComponent
     */
    get alternatingRowClass() {
        return this.alternatingRowStyle?.CssClass;
    }
    /**
     * Get the text to display encase the gridview is empty
     *
     * @type {string}
     * @readonly
     * @memberof GridViewComponent
     */
    get emptyDataText() {
        return this.model?.EmptyDataText;
    }
    /* GridView width property
     *
     * @return {*}  {string}
     * @memberof GridViewComponent
     */
    gridWidth() {
        return this.gridWidthInternal;
    }
    /**
     * Gets the pager style object from the model
     *
     * @readonly
     * @type {*}
     * @memberof GridViewComponent
     */
    get pagerStyle() {
        return this.model?.PagerStyle;
    }
    /**
     * Returns the scroll mode.
     *
     * @return {*}  {string}
     * @memberof GridViewComponent
     */
    scrollMode() {
        return this.allowPaging ? 'none' : 'virtual';
    }
    /**
     * Gets the rowHeight.
     *
     * @return {*}  {number}
     * @memberof GridViewComponent
     */
    getRowHeight() {
        return this.allowPaging ? 0 : this.rowHeight;
    }
    /**
     * Handles the pageChange event.
     *
     * @param {PageChangeEvent} event
     * @memberof GridViewComponent
     */
    pageChange(event) {
        this.pageSize = event.take;
        this.skip = event.skip;
        this.kendoCurrentPage =
            Math.ceil((event.skip + event.take) / event.take) - 1;
        const eventData = new EventData(event, this.id, 'grdvw');
        eventData['args'] = {
            newPageIndex: this.kendoCurrentPage + 1
        };
        this.pageIndexChanging(eventData);
    }
    /**
     * Loads the grid's columns.
     *
     * @memberof GridViewComponent
     */
    loadColumns() {
        this.wmService.fetch(this.getColumnsUrl, this.id).subscribe((data) => {
            this.columns = data.Cols;
            this.refChange.detectChanges();
            this.areColumnsLoaded = true;
            this.setColumnControlFields();
        });
    }
    /**
     * Returns a valid column name for the grid.
     *
     * @param {*} column
     * @return {*}  {string}
     * @memberof GridViewComponent
     */
    getColumnFieldName(column) {
        let name = '';
        if (column.name) {
            name = column.name;
        }
        else if (column.caption) {
            /* c8 ignore else */
            name = column.caption.replace(/\s/g, '');
        }
        return name;
    }
    /**
     * Loads the grid's data.
     *
     * @memberof GridViewComponent
     */
    loadData() {
        this.loading = true;
        let params = new HttpParams();
        let dataUrl;
        if (this.allowPaging) {
            let newIndex;
            if (!this.isDataLoaded) {
                //first time is loaded
                newIndex = this.pageIndex;
            }
            else {
                newIndex = this.kendoCurrentPage;
            }
            params = params.set('newPageIndex', newIndex.toString());
            this.skip = newIndex * this.pageSize;
            dataUrl = this.getIndexPageUrl;
        }
        else {
            params = this.getPageParams();
            dataUrl = this.getRangedPageUrl;
        }
        setTimeout(() => {
            this.wmService.fetch(dataUrl, this.id, params).subscribe((data) => {
                this.items = data.Rows;
                this.itemsTypeFormatter();
                this.gridView = {
                    data: this.items,
                    total: data.Length
                };
                this.loading = false;
                this.setTemplateFieldItemsModels();
                this.detectChanges();
                this.refChange.detectChanges();
                /* c8 ignore else*/
                if (this.autoFitGridView) {
                    this.fitColumns();
                }
            });
        }, 25);
        /* c8 ignore else*/
        if (!this.isDataLoaded) {
            this.isDataLoaded = true;
        }
    }
    /**
     * Track-by function to improve performance.
     *
     * @param {number} index
     * @param {*} column
     * @return {*}  {string}
     * @memberof GridViewComponent
     */
    trackByColumn(index, column) {
        return this.getColumnFieldName(column);
    }
    /**
     * Returns the value to be shown in the cell.
     *
     * @param {*} value
     * @param {number} rowIndex
     * @param {number} colIndex
     * @return {*}  {string}
     * @memberof GridViewComponent
     */
    getDisplayValue(value, rowIndex, colIndex) {
        let formattedValue = value;
        const normalizedRowIndex = this.normalizeRowIndex(rowIndex);
        /* c8 ignore else*/
        if (colIndex < this.controlFieldChildren.length) {
            const text = this.items[normalizedRowIndex]?.DataControlFields[colIndex]?.Text;
            /* c8 ignore else*/
            if (text && text !== '') {
                formattedValue = text;
            }
        }
        return value === '' || value === null ? '&nbsp;' : formattedValue;
    }
    /**
     * Returns the value to be shown in the cell with HyperLinkField.
     *
     * @param {number} rowIndex
     * @param {number} colIndex
     * @return {*}  {string}
     * @memberof GridViewComponent
     */
    getHyperLinkDisplayValue(rowIndex, colIndex) {
        let formattedValue = '';
        const normalizedRowIndex = this.normalizeRowIndex(rowIndex);
        if (colIndex < this.controlFieldChildren.length &&
            this.isHyperLinkFieldComponent(this.controlFieldChildren.toArray()[colIndex])) {
            const text = this.items[normalizedRowIndex]?.DataControlFields[colIndex]?.Text;
            const dataTextField = this.controlFieldChildren.toArray()[colIndex].dataTextField;
            if (dataTextField && dataTextField !== '') {
                formattedValue = text;
            }
            else {
                formattedValue = this.controlFieldChildren.toArray()[colIndex].text;
            }
        }
        return !formattedValue ? '' : formattedValue;
    }
    /**
     * Handler for the HyperLinkField click.
     *
     * @param {*} dataItem
     * @param {number} columnIndex
     * @param rowIndex
     * @memberof GridViewComponent
     */
    hyperLinkFieldClickHandler(dataItem, columnIndex, rowIndex) {
        /* c8 ignore else*/
        if (columnIndex < this.controlFieldChildren.length &&
            this.isHyperLinkFieldComponent(this.controlFieldChildren.toArray()[columnIndex])) {
            const normalizedRowIndex = this.normalizeRowIndex(rowIndex);
            this.controlFieldChildren.toArray()[columnIndex].clickHandler(dataItem, normalizedRowIndex);
        }
    }
    /**
     * Verifies if the specified dataControlField in the column is a HyperLinkField.
     *
     * @return {*}  {boolean}
     * @memberof GridViewComponent
     * @param type
     */
    isHyperLinkColumn(type) {
        return type === 'HyperLinkField';
    }
    /**
     * Verifies if the specified dataControlField in the column is a TemplateField.
     *
     * @param {string} type
     * @return {*}  {boolean}
     * @memberof GridViewComponent
     */
    isTemplateColumn(type) {
        return type === 'TemplateField';
    }
    /**
     * Verifies if the specified daatControlField in the column is a default Column(BoundField or auto generated).
     *
     * @param {string} type
     * @return {*}  {boolean}
     * @memberof GridViewComponent
     */
    isDefaultColumn(type) {
        return !this.isHyperLinkColumn(type) && !this.isTemplateColumn(type);
    }
    /**
     * Returns the itemTemplate from a specified TemplateField column index.
     *
     * @param {number} columnIndex
     * @return {*}  {*}
     * @memberof GridViewComponent
     */
    getItemTemplate(columnIndex) {
        return this.controlFieldChildren.toArray()[columnIndex].itemTemplate;
    }
    /**
     * Returns the itemTemplate model for a specific TemplateField cell in the grid.
     *
     * @param {number} rowIndex
     * @param {number} columnIndex
     * @return {*}  {*}
     * @memberof GridViewComponent
     */
    getItemTemplateModel(rowIndex, columnIndex) {
        const normalizedRowIndex = this.normalizeRowIndex(rowIndex);
        const models = this.controlFieldChildren.toArray()[columnIndex].itemTemplateModels;
        return normalizedRowIndex < models.length
            ? models[normalizedRowIndex]
            : undefined;
    }
    /**
     * Verifies if the itemTemplate models for a specific TemplateField are loaded.
     *
     * @param {number} columnIndex
     * @return {*}  {boolean}
     * @memberof GridViewComponent
     */
    areItemTemplateModelsLoaded(columnIndex) {
        return (this.controlFieldChildren.toArray()[columnIndex].itemTemplateModels.length > 0 &&
            this.controlFieldChildren.toArray()[columnIndex].itemTemplate !== undefined);
    }
    /**
     * Verifies if the column is sortable.
     * This is assumed when the column name equals 'false' because it cannot be empty
     * or because it is a controlField and has a sortExpression.
     *
     * @param {string} columnName
     * @param columnIndex
     * @return {*}
     * @memberof GridViewComponent
     */
    isColumnSortable(columnName, columnIndex) {
        if (columnIndex < this.controlFieldChildren.length) {
            return (!!this.controlFieldChildren.toArray()[columnIndex].sortExpression ||
                columnName !== 'false');
        }
        return columnName !== 'false';
    }
    /**
     * Prepares the data for the server side request which order the gridview.
     *
     * @param {SortDescriptor} sort
     * @memberof GridViewComponent
     */
    sortChange(sort) {
        /* c8 ignore else */
        if (sort) {
            this.sort = sort;
            const eventData = new EventData('Sorting', this.id);
            eventData.args = {
                direction: this.sort[0].dir,
                sortExpression: this.getSortField(sort),
                MapperId: GridViewComponent_1.sortMapperId
            };
            this.gridViewSortEventHandler(eventData);
        }
    }
    /**
     * Returns the sortField property needed to sort.
     *
     * @param {SortDescriptor} sort
     * @return {*}  {string}
     * @memberof GridViewComponent
     */
    getSortField(sort) {
        const controlField = this.getControlFieldBySort(sort[0]?.field);
        return controlField?.sortExpression && controlField.sortExpression !== ''
            ? controlField.sortExpression
            : sort[0]?.field;
    }
    /**
     * Returns the ControlField component that is sortable by the specified sortField.
     *
     * @param {string} sortField
     * @return {*}  {DataControlFieldComponent}
     * @memberof GridViewComponent
     */
    getControlFieldBySort(sortField) {
        return this.controlFieldChildren
            .toArray()
            .find((field) => (this.isBoundFieldComponent(field) &&
            field.dataField === sortField) ||
            (this.isHyperLinkFieldComponent(field) &&
                field.dataTextField === sortField));
    }
    /**
     * Triggers the sorting emitter.
     *
     * @param {EventData} eventData
     * @memberof GridViewComponent
     */
    gridViewSortEventHandler(eventData) {
        this.Sorting.emit(eventData);
    }
    /**
     * Sets the selectableSettings.
     *
     * @memberof GridViewComponent
     */
    setSelectableSettings() {
        /* c8 ignore else*/
        if (this.autoGenerateSelectButton) {
            this.selectableSettings = {
                checkboxOnly: false,
                mode: 'single'
            };
        }
    }
    /**
     * Handler for the cell click.
     *
     * @param {*} event
     * @memberof GridViewComponent
     */
    cellClickHandler(event) {
        let rowIndex;
        let selectorRowClass = '';
        if (this.allowPaging) {
            selectorRowClass = '.k-grid table';
            rowIndex =
                event.rowIndex >= this.pageSize
                    ? event.rowIndex - this.pageSize
                    : event.rowIndex;
        }
        else {
            selectorRowClass = '.k-grid-content';
            rowIndex = event.rowIndex;
        }
        this.selectedIndexChangingHandler(rowIndex);
        this.selectRowChangingHandler(event, selectorRowClass);
    }
    /**
     * Handler for select row change.
     *
     * @param {*} event
     * @param selectorClass
     * @memberof GridViewComponent
     */
    selectRowChangingHandler(event, selectorClass) {
        const kendoGrid = this.grid?.wrapper?.nativeElement;
        const nthChild = this.allowPaging ? event.rowIndex + 2 : event.rowIndex + 1;
        /* c8 ignore else*/
        if (kendoGrid) {
            this.rowElement = kendoGrid.querySelector(selectorClass + ` tr:nth-child(${nthChild}):not([kendogridgroupheader])`);
        }
        const eventData = new EventData('SelectedRow', this.id);
        eventData.args = {
            rowElement: this.rowElement,
            event,
            model: this.model
        };
        this.SelectedRowChange.emit(eventData);
    }
    /**
     * Handler for double cell click.
     *
     * @param {*} event
     * @memberof GridViewComponent
     */
    doubleClick(event) {
        // This is to wait for the click to be executed before doubleclick
        setTimeout(() => {
            const eventData = new EventData('DoubleClick', this.id);
            eventData.args = { rowElement: this.rowElement, event: event };
            this.DoubleClick.emit(eventData);
        }, 0);
    }
    /**
     * Handler for the selected row.
     *
     * @param {*} rowIndex
     * @memberof GridViewComponent
     */
    selectedIndexChangingHandler(rowIndex) {
        const eventData = new EventData('SelectedIndexChanging', this.id);
        eventData.args = { selectedRow: rowIndex };
        this.triggerSelectedIndexChanging(eventData);
    }
    /**
     * DoCheck lifecycle hook.
     *
     * @memberof GridViewComponent
     */
    ngDoCheck() {
        super.ngDoCheck();
        /* c8 ignore else*/
        if (this.model) {
            if (this.isDataLoaded &&
                this.model.PageIndex &&
                this.model.PageIndex !== this.kendoCurrentPage) {
                this.kendoCurrentPage = this.model.PageIndex;
                this.loadData();
            }
            if (this.refresh) {
                this.loadData();
                this.refresh = false;
            }
            this.refChange.detectChanges();
        }
        if (!this.kendoAltClassRemoved) {
            this.removeKendoAltRowClass();
        }
    }
    /**
     * Method to remove the k-alt class from the rows to be able to apply the custom classes to rows
     *
     * @memberof GridViewComponent
     */
    /* c8 ignore start */
    removeKendoAltRowClass() {
        const rowEls = this.elem?.nativeElement?.querySelectorAll('tr .k-alt');
        if (rowEls?.length > 0) {
            rowEls.forEach((el) => {
                this.render2.removeClass(el, 'k-alt');
            });
        }
        this.kendoAltClassRemoved = true;
    } /* c8 ignore stop */
    /**
     * Triggers the SelectedRow emitter.
     *
     * @param {EventData} eventData
     * @memberof GridViewComponent
     */
    triggerSelectedIndexChanging(eventData) {
        this.SelectedIndexChanging.emit(eventData);
    }
    /**
     * Returns the columns to be rendered by the KendoGrid.
     *
     * @return {*}  {any[]}
     * @memberof GridViewComponent
     */
    kendoColumns() {
        /* c8 ignore else*/
        if (this.autoGenerateColumns && this.columns) {
            return this.columnsControls.concat(this.columns.filter((col) => !col.ContainingField));
        }
        else if (this.columnsControls.length <= 0) {
            this.gridView = { data: [], total: 0 };
        }
        return this.columnsControls;
    }
    /**
     * Sets the custom controls to be renderer in the columns headers.
     *
     * @memberof GridViewComponent
     */
    setColumnControlFields() {
        if (this.isRendered && this.areColumnsLoaded) {
            this.setControlFieldsModels();
            this.setControlFieldsColumns();
        }
    }
    /**
     * Adjust width columns for setup as autofit columns
     * with width value NaN and recalculate width grid
     * based in new autofit
     * @memberof GridViewComponent
     */
    fitColumns() {
        const initialKendoColumns = this.grid?.columns?._results;
        /* c8 ignore else*/
        if (initialKendoColumns) {
            this.width = 0;
            const noSizedColumns = this.getNoSizeColumns(initialKendoColumns);
            noSizedColumns.forEach((column) => {
                this.grid.autoFitColumn(column);
            });
            initialKendoColumns.forEach((column) => {
                this.width = this.width + column.width;
            });
            this.gridWidthInternal = this.allowPaging
                ? String(this.width) + 'px'
                : String(this.width + 20) + 'px';
        }
    }
    /**
     *Return array with columns with NaN or undefined assigned in width property
     *
     * @param {*} columns
     * @return {*}  {*}
     * @memberof GridViewComponent
     */
    getNoSizeColumns(columns) {
        const noSizedColumns = [];
        columns.forEach((column) => {
            /*c8 ignore else */
            if (Number.isNaN(column.width) || column.width === undefined) {
                noSizedColumns.push(column);
            }
        });
        return noSizedColumns;
    }
    /**
     * Sets the controlsIds in each TemplateField column to load the Items models.
     *
     * @memberof GridViewComponent
     */
    setTemplateFieldItemsModels() {
        /* c8 ignore else */
        if (this.isDataLoaded && this.items.length > 0) {
            const templateFieldIndexes = this.getTemplateFieldsIndexes();
            templateFieldIndexes.forEach((index) => {
                /* c8 ignore else */
                if (this.isTemplateFieldComponent(this.controlFieldChildren.toArray()[index])) {
                    const controlsIds = this.getDataFieldControls(index);
                    this.controlFieldChildren.toArray()[index].setItemTemplateModels(controlsIds);
                }
            });
        }
    }
    /**
     * Returns the controls collection in each row for the specified column index.
     *
     * @param {number} columnIndex
     * @return {*}  {any[]}
     * @memberof GridViewComponent
     */
    getDataFieldControls(columnIndex) {
        const controlsIds = [];
        this.items.forEach((row) => {
            const rowControls = row.DataControlFields[columnIndex]?.Controls;
            /* c8 ignore else */
            if (rowControls) {
                controlsIds.push(rowControls);
            }
        });
        return controlsIds;
    }
    /**
     * Returns the columns indexes where the grid has TemplateField columns.
     *
     * @return {*}  {number[]}
     * @memberof GridViewComponent
     */
    getTemplateFieldsIndexes() {
        const indexes = [];
        /* c8 ignore else */
        if (this.isDataLoaded && this.controlFieldChildren.length > 0) {
            for (let i = 0; i < this.controlFieldChildren.length; i++) {
                if (this.isTemplateFieldComponent(this.controlFieldChildren.toArray()[i])) {
                    indexes.push(i);
                }
            }
        }
        return indexes;
    }
    /**
     * Sets the necessary properties for each DataControlField column.
     *
     * @memberof GridViewComponent
     */
    setControlFieldsColumns() {
        if (this.controlFieldChildren.length > 0) {
            for (const field of this.controlFieldChildren.toArray()) {
                const name = this.getControlFieldColumnName(field);
                const caption = this.getControlFieldColumnCaption(field);
                const styles = this.getControlFieldStyles(field);
                let col = {
                    name,
                    caption,
                    visible: field.visible
                };
                col = { ...col, ...styles };
                this.columnsControls.push(col);
            }
        }
    }
    /**
     * Returns the column name for a specific DataControlField.
     *
     * @param {DataControlFieldComponent} controlField
     * @return {*}  {string}
     * @memberof GridViewComponent
     */
    getControlFieldColumnName(controlField) {
        let name = '';
        if (this.isBoundFieldComponent(controlField)) {
            name = controlField.dataField;
        }
        else if (this.isHyperLinkFieldComponent(controlField)) {
            name =
                controlField.dataTextField === ''
                    ? 'false'
                    : controlField.dataTextField;
        }
        else {
            name = 'false';
        }
        if (name === 'false' && !!controlField?.sortExpression) {
            name = controlField.sortExpression;
        }
        return name;
    }
    /**
     * Returns the column caption for a specific DataControlField.
     *
     * @param {DataControlFieldComponent} controlField
     * @return {*}  {string}
     * @memberof GridViewComponent
     */
    getControlFieldColumnCaption(controlField) {
        return controlField.headerText;
    }
    /**
     * Returns styles for a specific DataControlField.
     *
     * @param {DataControlFieldComponent} controlField
     * @return {*}  {*}
     * @memberof GridViewComponent
     */
    getControlFieldStyles(controlField) {
        const unitType = UnitType[controlField.itemStyle?.Width?.Type];
        const itemStyleWidth = controlField.itemStyle?.Width?.Value;
        const width = unitType === UnitType.Pixel ? itemStyleWidth : Number.NaN;
        let headerStyle = {};
        headerStyle =
            unitType === UnitType.Percentage ? { width: `${itemStyleWidth}%` } : {};
        const style = new ColumnStyleManager().applyCellStyle(controlField, this.rowStyle);
        let dataFormat = '';
        if (this.isBoundFieldComponent(controlField)) {
            dataFormat = controlField.dataFormatString;
        }
        /* c8 ignore start */
        headerStyle['text-align'] =
            controlField?.headerStyle && controlField?.headerStyle?.HorizontalAlign
                ? controlField.headerStyle?.HorizontalAlign
                : this.getHeaderStylePropFromModel('HorizontalAlign');
        headerStyle['background-color'] =
            controlField?.headerStyle && controlField?.headerStyle?.BackColor
                ? controlField?.headerStyle?.BackColor
                : this.getHeaderStylePropFromModel('BackColor'); /* c8 ignore stop */
        const cssClass = controlField.headerStyle?.CssClass ?? null;
        return {
            cssClass,
            width,
            headerStyle,
            style,
            format: dataFormat
        };
    }
    /**
     * Returns the column width.
     *
     * @param {*} col
     * @return {*}  {number}
     * @memberof GridViewComponent
     */
    getColumnWidth(col) {
        return col.width ?? Number.NaN;
    }
    /**
     * Returns the column headerStyle.
     *
     * @param {*} col
     * @param colIndex
     * @return {*}  {*}
     * @memberof GridViewComponent
     */
    getHeaderStyle(col, colIndex) {
        const headerStyle = col.headerStyle ?? this.applyHeaderStylesFromModel();
        const style = this.setHeaderStyleSortable(this.getColumnFieldName(col), colIndex, headerStyle);
        return this.setGridLinesBorder(style);
    }
    /**
     * Gets the property from the headerStyle of the model of the GridView
     *
     * @param {string} property
     * @return {*}  {string}
     * @memberof GridViewComponent
     */
    getHeaderStylePropFromModel(property) {
        return this.model?.HeaderStyle && this.model?.HeaderStyle[property]
            ? this.model.HeaderStyle[property]
            : null;
    }
    /**
     * Returns the cell style based on the column.
     *
     * @param {*} col
     * @return {*}  {*}
     * @memberof GridViewComponent
     */
    getCellStyle(col) {
        const style = col.style ?? new ColumnStyleManager().applyCellStyle(col, this.rowStyle);
        return this.setGridLinesBorder(style);
    }
    /**
     * Applies item cell style
     *
     * @param {*} dataItem
     * @param {number} rowIndex
     * @param {*} cellEl
     * @param {number} columIndex
     * @return {*}  {*}
     * @memberof GridViewComponent
     */
    getBasicItemStyle(dataItem, rowIndex, cellEl, columIndex) {
        if (dataItem.RowId !== undefined) {
            const rowModel = this.wmService.core.getModel(dataItem.RowId);
            /* c8 ignore else*/
            if (rowModel?.Controls != undefined) {
                const cellModel = this.wmService.core.getModel(Object.keys(rowModel.Controls)[columIndex]);
                /* c8 ignore else*/
                if (this.isHyperLinkColumn(dataItem.DataControlFields[columIndex]?.ContainingFieldType)) {
                    //Apply enable/disable style to hyperlink
                    const cellHyperLink = cellEl.querySelector('span > a');
                    this.applyStylesHyperLinkCell(cellHyperLink, cellModel);
                }
                this.applyCommonStyles(cellEl, cellModel);
            }
        }
        //Call alternatingRowStyleFunction
        this.getAlternatingRowStyle(rowIndex, cellEl);
    }
    /**
     * Apply common styles to cells
     *
     * @param {*} element
     * @param {*} cellModel
     * @memberof GridViewComponent
     */
    applyCommonStyles(element, cellModel) {
        //Apply style based on common model properties
        /* c8 ignore else*/
        if (cellModel?.ForeColor !== undefined) {
            //Apply color style based in forecolor property
            const cellColor = cellModel.ForeColor !== '' ? cellModel.ForeColor : '0, 0, 0';
            this.render2.setStyle(element, 'color', 'rgb(' + cellColor + ')');
        }
    }
    /**
     * Apply styles to cells with colum type hyperlink
     *
     * @param {*} element
     * @param {*} cellModel
     * @memberof GridViewComponent
     */
    applyStylesHyperLinkCell(element, cellModel) {
        //Apply style based in enabled property
        /* c8 ignore else*/
        if (cellModel?.Enabled !== undefined) {
            if (cellModel.Enabled) {
                this.render2.setStyle(element, 'pointer-events', 'auto');
                this.render2.setStyle(element, 'color', 'blue');
                this.render2.setStyle(element, 'text-decoration', 'underline');
                this.render2.setStyle(element, 'cursor', 'pointer');
            }
            else {
                this.render2.setStyle(element, 'pointer-events', 'none');
                this.render2.setStyle(element, 'color', 'rgb(0, 0, 0)');
                this.render2.setStyle(element, 'text-decoration', 'none');
                this.render2.setStyle(element, 'cursor', 'not-allowed');
            }
        }
    }
    /**
     * Applies the alternating row style
     *
     * @param {number} rowIndex the rowIndex
     * @param {*} cellEl the html element
     * @return {*}  {*}
     * @memberof GridViewComponent
     */
    getAlternatingRowStyle(rowIndex, cellEl) {
        const tr = cellEl.closest('tr');
        /* c8 ignore start */
        if (this.alternatingRowStyle && rowIndex % 2 !== 0 && tr) {
            this.render2.setStyle(tr, 'background-color', this.alternatingRowStyle?.BackColor ?? null);
        } /* c8 ignore stop */
    }
    /**
     * Gets the row css class from the model
     *
     * @readonly
     * @type {string}
     * @memberof GridViewComponent
     */
    headerCssClass(column) {
        return column.cssClass ?? this.model?.HeaderStyle?.CssClass ?? '';
    }
    /**
     * Returns the column format.
     *
     * @param {*} col
     * @return {*}  {string}
     * @memberof GridViewComponent
     */
    getFormat(col) {
        return col.format ?? '';
    }
    /**
     * Sets the correct format for the data received from the API.
     *
     * @memberof GridViewComponent
     */
    itemsTypeFormatter() {
        const colsWithDataFormat = this.columnsControls.filter((item) => item.format !== '');
        for (const col of colsWithDataFormat) {
            this.items.forEach((item) => {
                /* c8 ignore else*/
                if (typeof item[col.name] === 'string') {
                    if (Number(item[col.name])) {
                        item[col.name] = Number(item[col.name]);
                    }
                    else {
                        const date = new Date(item[col.name]);
                        /* c8 ignore else*/
                        if (!isNaN(date.getTime())) {
                            item[col.name] = new Date(item.date);
                        }
                    }
                }
            });
        }
    }
    /**
     * Sets the model for each DataControlField component.
     *
     * @memberof GridViewComponent
     */
    setControlFieldsModels() {
        const models = [];
        for (const col of this.columns) {
            if (col.ContainingField) {
                models.push(col.ContainingField);
            }
        }
        if (models.length > 0 &&
            models.length === this.controlFieldChildren.length) {
            for (let i = 0; i < this.controlFieldChildren.length; i++) {
                this.controlFieldChildren.toArray()[i].model = models[i];
            }
        }
        this.columns = this.columns.filter((col) => !col.ContainingField);
        this.setVisibleToDefaultColumns();
    }
    /**
     * Sets the visible property to default columns (columns from API).
     *
     * @memberof GridViewComponent
     */
    setVisibleToDefaultColumns() {
        this.columns.forEach((col) => {
            col['visible'] = true;
        });
    }
    /**
     * Determines if the DataControlField is an instance of the HyperLinkField Component.
     *
     * @param {DataControlFieldComponent} field
     * @return {*}  {field is HyperlinkFieldComponent}
     * @memberof GridViewComponent
     */
    isHyperLinkFieldComponent(field) {
        return field instanceof HyperlinkFieldComponent;
    }
    /**
     * Determines if the DataControlField is an instance of the BoundField Component.
     *
     * @param {DataControlFieldComponent} field
     * @return {*}  {field is BoundFieldComponent}
     * @memberof GridViewComponent
     */
    isBoundFieldComponent(field) {
        return field instanceof BoundFieldComponent;
    }
    /**
     * Determines if the DataControlField is an instance of the TemplateField Component.
     *
     * @param {DataControlFieldComponent} field
     * @return {*}  {field is TemplateFieldComponent}
     * @memberof GridViewComponent
     */
    isTemplateFieldComponent(field) {
        return field instanceof TemplateFieldComponent;
    }
    /**
     * Method to apply the HeaderStyles from the model property and return the style object
     *
     * @return {*}  The style object
     * @memberof GridViewComponent
     */
    applyHeaderStylesFromModel() {
        const style = {};
        style['text-align'] = this.getHeaderStylePropFromModel('VerticalAlign');
        style['background-color'] = this.getHeaderStylePropFromModel('BackColor');
        return style;
    }
    /**
     * Sets the gridLines style to the cells of the grid
     * This is called on the getCellStyle method
     *
     * @param {*} columnStyle
     * @return {*}  the object of the style with the borders applied
     * @memberof GridViewComponent
     */
    setGridLinesBorder(columnStyle) {
        switch (this.gridLines) {
            case GridLines.None:
                columnStyle['border'] = 'none';
                break;
            case GridLines.Vertical:
                columnStyle['border-top'] = 'none';
                columnStyle['border-bottom'] = 'none';
                break;
            case GridLines.Horizontal:
                columnStyle['border-left'] = 'none';
                columnStyle['border-right'] = 'none';
                break;
            default:
                break;
        }
        return columnStyle;
    }
    /**
     * Sets the pager style
     *
     * @return {*}  {*}
     * @memberof GridViewComponent
     */
    /* c8 ignore start */
    setPagerStyle() {
        const style = new PagerStyleManager(this.pagerStyle).setPagerStyle();
        const pagerElem = this.elem.nativeElement.querySelector('kendo-pager');
        if (pagerElem && style) {
            this.render2.setStyle(pagerElem, 'background-color', style['background-color']);
            this.render2.setStyle(pagerElem, 'border-color', style['border-color']);
            this.render2.setStyle(pagerElem, 'border-width', style['border-width']);
            this.render2.setStyle(pagerElem, 'color', style.color);
            this.render2.setStyle(pagerElem, 'height', style.height);
            this.render2.setStyle(pagerElem, 'width', style.width);
        }
    } /* c8 ignore stop */
    /**
     * Sets the header style
     * Add e2e tests for this method
     * @param colName
     * @param {number} colIndex
     * @param headerStyle
     * @return {*}  {*}
     * @memberof GridViewComponent
     */
    setHeaderStyleSortable(colName, colIndex, headerStyle) {
        const style = headerStyle;
        if (this.isColumnSortable(colName, colIndex)) {
            style['text-decoration'] = 'underline';
            style['color'] = 'blue';
        }
        return style;
    }
    /**
     * Sets the inner pager style
     * Used to set the top property
     * @return {*}  {*}
     * @memberof GridViewComponent
     */
    setInnerPagerStyle() {
        this.setPagerStyle();
        return new PagerStyleManager(this.pagerStyle).setTop();
    }
    /**
     * Returns true if the pager horizontal align is center
     *
     * @return {*}  {boolean}
     * @memberof PagerStyleManager
     */
    isPagerCenteredHorizontaly() {
        return (this.pagerStyle?.HorizontalAlign != null &&
            this.pagerStyle?.HorizontalAlign === PagerHorizontalAlign.Center);
    }
    /**
     * Returns true if the pager horizontal align is right
     *
     * @return {*}  {boolean}
     * @memberof GridViewComponent
     */
    isPagerRightHorizontaly() {
        return (this.pagerStyle?.HorizontalAlign != null &&
            this.pagerStyle?.HorizontalAlign === PagerHorizontalAlign.Right);
    }
    /**
     * Returns true if the pager horizontal align is left
     *
     * @return {*}  {boolean}
     * @memberof GridViewComponent
     */
    isPagerLeftHorizontaly() {
        return (this.pagerStyle?.HorizontalAlign != null &&
            this.pagerStyle?.HorizontalAlign === PagerHorizontalAlign.Left);
    }
    /**
     * Gets the respective tooltip text for a given row
     * using the row id
     *
     * @param {string} rowId
     * @return {*}  {string}
     * @memberof GridViewComponent
     */
    getToolTipForRow(rowId) {
        const model = this.wmService.core?.getModel(rowId);
        let toolTipText = '';
        if (model && model.ToolTipText != null) {
            toolTipText = model.ToolTipText;
        }
        return toolTipText;
    }
    /**
     * Page Index Changing of gridview component
     *
     * @param {EventData} event
     * @memberof GridViewComponent
     */
    pageIndexChanging(event) {
        this.PageIndexChanging.emit(event);
    }
    /**
     * Normalize the row index to access the data collection of the grid
     *
     * @param {number} rowIndex
     * @return {*}  {number}
     * @memberof GridViewComponent
     */
    normalizeRowIndex(rowIndex) {
        return this.allowPaging ? rowIndex % this.pageSize : rowIndex;
    }
    /**
     * Handles the rowCommand event.
     *
     * @param {any} event
     * @memberof GridViewComponent
     */
    rowCommandHandler(event) {
        const eventData = new EventData(event, this.id, GridViewComponent_1.rowCommandMapperId);
        eventData['args'] = {
            CommandName: event.clientClickArgs.CommandName,
            CommandArgument: event.clientClickArgs.CommandArgument,
            CommandSource: event.id
        };
        this.triggerRowCommand(eventData);
    }
    /**
     * Handles the client click events raised by the gridview internal button controls.
     *
     * @memberof GridViewComponent
     */
    internalClickHandler() {
        this.internalEventHandler.onButtonClick.subscribe((event) => {
            this.rowCommandHandler(event);
        });
    }
    /**
     * Trigger the RowCommand Event on server side
     *
     * @param {*} event
     * @memberof GridViewComponent
     */
    triggerRowCommand(event) {
        this.OnRowCommand.emit({ source: this.model, e: event });
    }
};
/**
 * MapperId value for selected row event.
 *
 * @static
 * @memberof GridViewComponent
 */
GridViewComponent.selectedRowMapperId = 'grdsltd';
/**
 * MapperId value for sort event.
 *
 * @static
 * @memberof GridViewComponent
 */
GridViewComponent.sortMapperId = 'grdsrt';
/**
 * MapperId value for rowcommand event.
 *
 * @static
 * @memberof GridViewComponent
 */
GridViewComponent.rowCommandMapperId = 'grdcmmnd';
GridViewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GridViewComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i5.UntypedFormBuilder }, { token: InternalEventHandlerService }, { token: i2.WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
GridViewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: GridViewComponent, selector: "wm-gridview", inputs: { model: "model", allowPaging: "allowPaging", autoFitGridView: "autoFitGridView", hideHeader: "hideHeader", pageSize: "pageSize", allowSorting: "allowSorting", autoGenerateSelectButton: "autoGenerateSelectButton", pageIndex: "pageIndex", selectedIndex: "selectedIndex", autoGenerateColumns: "autoGenerateColumns", gridLines: "gridLines" }, outputs: { Sorting: "Sorting", PageIndexChanging: "PageIndexChanging", SelectedRowChange: "SelectedRowChange", DoubleClick: "DoubleClick", OnRowCommand: "OnRowCommand" }, providers: [InternalEventHandlerService], queries: [{ propertyName: "columnsChild", first: true, predicate: GridViewColumnsComponent, descendants: true }], viewQueries: [{ propertyName: "grid", first: true, predicate: GridComponent$1, descendants: true }], usesInheritance: true, ngImport: i0, template: "<kendo-grid *ngIf=\"model && (visible || emptyDataText)\" [data]=\"gridView\" [loading]=\"loading\" [pageable]=\"allowPaging\"\r\n  [pageSize]=\"pageSize\" [skip]=\"skip\" [sortable]=\"allowSorting\" (sortChange)=\"sortChange($event)\" [sort]=\"sort\"\r\n  [scrollable]=\"scrollMode()\" [rowHeight]=\"getRowHeight()\" [height]=\"height\" [selectable]=\"selectableSettings\"\r\n  (cellClick)=\"cellClickHandler($event)\" (dblclick)=\"doubleClick($event)\" kendoGridSelectBy [selectedKeys]=\"[selectedIndex]\" [ngClass]=\"class\"\r\n  [rowClass]=\"getRowClass\" [resizable]=\"true\" [style.width]=\"gridWidth()\" (pageChange)=\"pageChange($event)\" [hideHeader]=\"hideHeader\">\r\n  <ng-container *ngFor=\"let column of kendoColumns(); let i=index; trackBy: trackByColumn.bind(this)\">\r\n    <kendo-grid-column *ngIf=\"column.visible\" field=\"{{getColumnFieldName(column)}}\" title=\"{{column.caption}}\"\r\n      [width]=\"getColumnWidth(column)\" [headerStyle]=\"getHeaderStyle(column, i)\" [style]=\"getCellStyle(column)\"\r\n      format=\"{{getFormat(column)}}\" [sortable]=\"isColumnSortable(getColumnFieldName(column), i)\"\r\n      [headerClass]=\"headerCssClass(column)\">\r\n      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex=\"rowIndex\" let-columnIndex=\"columnIndex\">\r\n        <div kendoTooltip filter=\"span\" class=\"flex\">\r\n          <ng-container *ngIf=\"isHyperLinkColumn(dataItem.DataControlFields[i]?.ContainingFieldType)\">\r\n            <span #cellEl [title]=\"getToolTipForRow(dataItem.RowId)\"\r\n              [ngStyle]=\"getBasicItemStyle(dataItem,rowIndex,cellEl,i)\">\r\n              <a href=\"javascript:void(0)\" (click)=\"hyperLinkFieldClickHandler(dataItem, i, rowIndex)\">\r\n                {{getHyperLinkDisplayValue(rowIndex, i)}}\r\n              </a>\r\n            </span>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"isDefaultColumn(dataItem.DataControlFields[i]?.ContainingFieldType)\">\r\n            <span #cellEl [title]=\"getToolTipForRow(dataItem.RowId)\"\r\n              [innerHTML]=\"getDisplayValue(dataItem[getColumnFieldName(column)], rowIndex, i)\"\r\n              [ngStyle]=\"getBasicItemStyle(dataItem,rowIndex,cellEl,i)\"></span>\r\n          </ng-container>\r\n          <ng-container\r\n            *ngIf=\"isTemplateColumn(dataItem.DataControlFields[i]?.ContainingFieldType) && areItemTemplateModelsLoaded(i)\">\r\n            <div #cellEl [title]=\"getToolTipForRow(dataItem.RowId)\" class=\"ItemTemplateItems\" [ngStyle]=\"getAlternatingRowStyle(rowIndex,cellEl)\">\r\n              <ng-container\r\n                *ngTemplateOutlet='getItemTemplate(i); context:{$implicit: getItemTemplateModel(rowIndex, i)}'>\r\n              </ng-container>\r\n            </div>\r\n          </ng-container>\r\n        </div>\r\n      </ng-template>\r\n    </kendo-grid-column>\r\n    <ng-template kendoGridNoRecordsTemplate>{{emptyDataText}}</ng-template>\r\n  </ng-container>\r\n\r\n  <ng-template kendoPagerTemplate>\r\n    <kendo-grid-spacer *ngIf=\"isPagerCenteredHorizontaly() || isPagerRightHorizontaly()\"></kendo-grid-spacer>\r\n    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>\r\n    <kendo-pager-numeric-buttons [buttonCount]=\"10\" [ngStyle]=\"setInnerPagerStyle()\"></kendo-pager-numeric-buttons>\r\n    <kendo-pager-next-buttons></kendo-pager-next-buttons>\r\n    <kendo-grid-spacer *ngIf=\"isPagerCenteredHorizontaly() || isPagerLeftHorizontaly()\"></kendo-grid-spacer>\r\n  </ng-template>\r\n</kendo-grid>\r\n<ng-content></ng-content>\r\n", styles: ["::ng-deep .k-cell-inner>span.k-link{display:block}::ng-deep .k-grid td a{color:revert;-webkit-text-decoration:revert;text-decoration:revert}::ng-deep .ItemTemplateItems>*{display:inline-block;margin-right:.4em}::ng-deep .k-grid td{border-width:.1px!important;padding-left:10px}::ng-deep .k-grid tr{height:28px!important}::ng-deep .k-grid th{font-weight:700!important;height:28px!important;padding-left:10px!important;padding-bottom:10px!important}::ng-deep .k-pager-numbers .k-link.k-state-selected{background-color:#e1e6ed33!important;color:#d3d3d3!important}::ng-deep kendo-pager-numeric-buttons li{border-color:#d3d3d3!important;border-style:solid!important;border-width:.01px!important;margin:5px!important}::ng-deep .k-pager-numbers .k-link{color:#000!important}::ng-deep .k-grid-norecords{pointer-events:none}::ng-deep .k-grid-norecords td{text-align:left}::ng-deep .k-grid-content{overflow:hidden}\n"], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i4.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i7.GridComponent, selector: "kendo-grid", inputs: ["data", "pageSize", "height", "rowHeight", "detailRowHeight", "skip", "scrollable", "selectable", "sort", "size", "trackBy", "filter", "group", "virtualColumns", "filterable", "sortable", "pageable", "groupable", "navigable", "navigatable", "autoSize", "rowClass", "rowSticky", "rowSelected", "cellSelected", "resizable", "reorderable", "loading", "columnMenu", "hideHeader", "isDetailExpanded", "isGroupExpanded"], outputs: ["filterChange", "pageChange", "groupChange", "sortChange", "selectionChange", "dataStateChange", "groupExpand", "groupCollapse", "detailExpand", "detailCollapse", "edit", "cancel", "save", "remove", "add", "cellClose", "cellClick", "pdfExport", "excelExport", "columnResize", "columnReorder", "columnVisibilityChange", "columnLockedChange", "columnStickyChange", "scrollBottom", "contentScroll"], exportAs: ["kendoGrid"] }, { kind: "component", type: i7.GridSpacerComponent, selector: "kendo-grid-spacer, kendo-pager-spacer", inputs: ["width"] }, { kind: "directive", type: i7.SelectionDirective, selector: "[kendoGridSelectBy]" }, { kind: "component", type: i7.ColumnComponent, selector: "kendo-grid-column", inputs: ["field", "format", "sortable", "groupable", "editor", "filter", "filterable", "editable"] }, { kind: "directive", type: i7.CellTemplateDirective, selector: "[kendoGridCellTemplate]" }, { kind: "directive", type: i7.NoRecordsTemplateDirective, selector: "[kendoGridNoRecordsTemplate]" }, { kind: "component", type: i7.PagerPrevButtonsComponent, selector: "kendo-pager-prev-buttons" }, { kind: "component", type: i7.PagerNextButtonsComponent, selector: "kendo-pager-next-buttons" }, { kind: "component", type: i7.PagerNumericButtonsComponent, selector: "kendo-pager-numeric-buttons", inputs: ["buttonCount"] }, { kind: "directive", type: i7.PagerTemplateDirective, selector: "[kendoPagerTemplate]" }, { kind: "directive", type: i8.TooltipDirective, selector: "[kendoTooltip]", inputs: ["filter", "position", "titleTemplate", "showOn", "showAfter", "callout", "closable", "offset", "tooltipWidth", "tooltipHeight", "tooltipClass", "collision", "closeTitle", "tooltipTemplate"], exportAs: ["kendoTooltip"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    serverEvent('Sorting', GridViewComponent_1.SortExtractor)
], GridViewComponent.prototype, "gridViewSortEventHandler", null);
__decorate([
    serverEvent('SelectedIndexChanging', GridViewComponent_1.SelectedIndexChangingArgsExtractor)
], GridViewComponent.prototype, "triggerSelectedIndexChanging", null);
__decorate([
    serverEvent('PageIndexChanging', GridViewComponent_1.PageIndexChangingExtractor)
], GridViewComponent.prototype, "pageIndexChanging", null);
__decorate([
    serverEvent('RowCommand', GridViewComponent_1.RowCommandExtractor)
], GridViewComponent.prototype, "triggerRowCommand", null);
GridViewComponent = GridViewComponent_1 = __decorate([
    dataTransfer(['grdvw']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], GridViewComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GridViewComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-gridview', inputs: ['model'], providers: [InternalEventHandlerService], template: "<kendo-grid *ngIf=\"model && (visible || emptyDataText)\" [data]=\"gridView\" [loading]=\"loading\" [pageable]=\"allowPaging\"\r\n  [pageSize]=\"pageSize\" [skip]=\"skip\" [sortable]=\"allowSorting\" (sortChange)=\"sortChange($event)\" [sort]=\"sort\"\r\n  [scrollable]=\"scrollMode()\" [rowHeight]=\"getRowHeight()\" [height]=\"height\" [selectable]=\"selectableSettings\"\r\n  (cellClick)=\"cellClickHandler($event)\" (dblclick)=\"doubleClick($event)\" kendoGridSelectBy [selectedKeys]=\"[selectedIndex]\" [ngClass]=\"class\"\r\n  [rowClass]=\"getRowClass\" [resizable]=\"true\" [style.width]=\"gridWidth()\" (pageChange)=\"pageChange($event)\" [hideHeader]=\"hideHeader\">\r\n  <ng-container *ngFor=\"let column of kendoColumns(); let i=index; trackBy: trackByColumn.bind(this)\">\r\n    <kendo-grid-column *ngIf=\"column.visible\" field=\"{{getColumnFieldName(column)}}\" title=\"{{column.caption}}\"\r\n      [width]=\"getColumnWidth(column)\" [headerStyle]=\"getHeaderStyle(column, i)\" [style]=\"getCellStyle(column)\"\r\n      format=\"{{getFormat(column)}}\" [sortable]=\"isColumnSortable(getColumnFieldName(column), i)\"\r\n      [headerClass]=\"headerCssClass(column)\">\r\n      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex=\"rowIndex\" let-columnIndex=\"columnIndex\">\r\n        <div kendoTooltip filter=\"span\" class=\"flex\">\r\n          <ng-container *ngIf=\"isHyperLinkColumn(dataItem.DataControlFields[i]?.ContainingFieldType)\">\r\n            <span #cellEl [title]=\"getToolTipForRow(dataItem.RowId)\"\r\n              [ngStyle]=\"getBasicItemStyle(dataItem,rowIndex,cellEl,i)\">\r\n              <a href=\"javascript:void(0)\" (click)=\"hyperLinkFieldClickHandler(dataItem, i, rowIndex)\">\r\n                {{getHyperLinkDisplayValue(rowIndex, i)}}\r\n              </a>\r\n            </span>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"isDefaultColumn(dataItem.DataControlFields[i]?.ContainingFieldType)\">\r\n            <span #cellEl [title]=\"getToolTipForRow(dataItem.RowId)\"\r\n              [innerHTML]=\"getDisplayValue(dataItem[getColumnFieldName(column)], rowIndex, i)\"\r\n              [ngStyle]=\"getBasicItemStyle(dataItem,rowIndex,cellEl,i)\"></span>\r\n          </ng-container>\r\n          <ng-container\r\n            *ngIf=\"isTemplateColumn(dataItem.DataControlFields[i]?.ContainingFieldType) && areItemTemplateModelsLoaded(i)\">\r\n            <div #cellEl [title]=\"getToolTipForRow(dataItem.RowId)\" class=\"ItemTemplateItems\" [ngStyle]=\"getAlternatingRowStyle(rowIndex,cellEl)\">\r\n              <ng-container\r\n                *ngTemplateOutlet='getItemTemplate(i); context:{$implicit: getItemTemplateModel(rowIndex, i)}'>\r\n              </ng-container>\r\n            </div>\r\n          </ng-container>\r\n        </div>\r\n      </ng-template>\r\n    </kendo-grid-column>\r\n    <ng-template kendoGridNoRecordsTemplate>{{emptyDataText}}</ng-template>\r\n  </ng-container>\r\n\r\n  <ng-template kendoPagerTemplate>\r\n    <kendo-grid-spacer *ngIf=\"isPagerCenteredHorizontaly() || isPagerRightHorizontaly()\"></kendo-grid-spacer>\r\n    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>\r\n    <kendo-pager-numeric-buttons [buttonCount]=\"10\" [ngStyle]=\"setInnerPagerStyle()\"></kendo-pager-numeric-buttons>\r\n    <kendo-pager-next-buttons></kendo-pager-next-buttons>\r\n    <kendo-grid-spacer *ngIf=\"isPagerCenteredHorizontaly() || isPagerLeftHorizontaly()\"></kendo-grid-spacer>\r\n  </ng-template>\r\n</kendo-grid>\r\n<ng-content></ng-content>\r\n", styles: ["::ng-deep .k-cell-inner>span.k-link{display:block}::ng-deep .k-grid td a{color:revert;-webkit-text-decoration:revert;text-decoration:revert}::ng-deep .ItemTemplateItems>*{display:inline-block;margin-right:.4em}::ng-deep .k-grid td{border-width:.1px!important;padding-left:10px}::ng-deep .k-grid tr{height:28px!important}::ng-deep .k-grid th{font-weight:700!important;height:28px!important;padding-left:10px!important;padding-bottom:10px!important}::ng-deep .k-pager-numbers .k-link.k-state-selected{background-color:#e1e6ed33!important;color:#d3d3d3!important}::ng-deep kendo-pager-numeric-buttons li{border-color:#d3d3d3!important;border-style:solid!important;border-width:.01px!important;margin:5px!important}::ng-deep .k-pager-numbers .k-link{color:#000!important}::ng-deep .k-grid-norecords{pointer-events:none}::ng-deep .k-grid-norecords td{text-align:left}::ng-deep .k-grid-content{overflow:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i5.UntypedFormBuilder }, { type: InternalEventHandlerService }, { type: i2.WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { grid: [{
                type: ViewChild,
                args: [GridComponent$1, { static: false }]
            }], Sorting: [{
                type: Output
            }], PageIndexChanging: [{
                type: Output
            }], SelectedRowChange: [{
                type: Output
            }], DoubleClick: [{
                type: Output
            }], OnRowCommand: [{
                type: Output
            }], columnsChild: [{
                type: ContentChild,
                args: [GridViewColumnsComponent]
            }], allowPaging: [{
                type: Input
            }], autoFitGridView: [{
                type: Input
            }], hideHeader: [{
                type: Input
            }], pageSize: [{
                type: Input
            }], allowSorting: [{
                type: Input
            }], autoGenerateSelectButton: [{
                type: Input
            }], pageIndex: [{
                type: Input
            }], selectedIndex: [{
                type: Input
            }], autoGenerateColumns: [{
                type: Input
            }], gridLines: [{
                type: Input
            }], gridViewSortEventHandler: [], triggerSelectedIndexChanging: [], pageIndexChanging: [], triggerRowCommand: [] } });

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Angular Component for the Base Page Control.
 *
 * @export
 * @class PageComponent
 * @extends {ControlComponent}
 * @implements {AfterViewInit}
 */
class PageComponent extends ControlComponent {
    /**
     * Creates an instance of PageComponent.
     *
     * @param {WebMapService} wmService
     * @param {ChangeDetectorRef} refChange
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @memberof PageComponent
     */
    constructor(wmService, refChange, render2, elem) {
        super(refChange, render2, elem);
        this.wmService = wmService;
        this.refChange = refChange;
        this.render2 = render2;
        this.elem = elem;
        /**
         * Component is initialized event emitter.
         *
         * @type {EventEmitter<any>}
         * @memberof PageComponent
         */
        this.initializeEvent = new EventEmitter();
    }
    /**
     * AfterViewInit lifecycle hook.
     *
     * @memberof PageComponent
     */
    ngAfterViewInit() {
        setTimeout(() => {
            this.initializeEvent.emit(this);
        }, 0);
    }
}
PageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PageComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
PageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: PageComponent, selector: "ng-component", usesInheritance: true, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PageComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }]; } });

let BaseValidatorComponent = class BaseValidatorComponent extends ControlComponent {
    constructor(refChange, render2, elem, webComponents, validatorService, bringTopServ1) {
        super(refChange, render2, elem, webComponents, bringTopServ1);
        this.refChange = refChange;
        this.render2 = render2;
        this.elem = elem;
        this.validatorService = validatorService;
        this.bringTopServ1 = bringTopServ1;
        /**
         * Property with that indicates if the validation is passed.
         *
         * @memberof BaseValidatorComponent
         */
        this.validationSuccessInternal = false;
        /**
         * Property with the visibility of the component.
         *
         * @memberof BaseValidatorComponent
         */
        this.hiddenInternal = true;
        /**
         * Property with the Id of the control to validate.
         *
         * @memberof BaseValidatorComponent
         */
        this.controlToValidateInternal = '';
        /**
         * Property with the error message.
         *
         * @memberof BaseValidatorComponent
         */
        this.errorMessageInternal = '';
        /**
         * Property with the validationGroup
         *
         *  @memberof BaseValidatorComponent
         */
        this.validationGroupInternal = '';
        /**
         * Internal property for handle type of Display in component
         *
         * @private
         * @memberof RequiredFieldValidatorComponent
         */
        this.displayInternal = ValidatorDisplay.Static;
    }
    /**
     * OnInit lifecycle hook, adds itself to the service.
     *
     * @memberof BaseValidatorComponent
     */
    ngOnInit() {
        this.validatorService.addValidator(this);
    }
    /**
     * OnDestroy lifecycle hook, removes itself from the service.
     *
     * @memberof BaseValidatorComponent
     */
    ngOnDestroy() {
        this.validatorService.removeValidator(this);
    }
    /**
     * Gets/sets the Control to Validate and notify the service.
     *
     * @memberof BaseValidatorComponent
     */
    set controlToValidate(elementToValidate) {
        this.validatorService.removeValidator(this);
        this.controlToValidateInternal = elementToValidate;
        this.validatorService.addValidator(this);
    }
    get controlToValidate() {
        return this.model?.ControlToValidate ?? this.controlToValidateInternal;
    }
    /**
     * Gets/sets the error message.
     *
     * @memberof BaseValidatorComponent
     */
    set errorMessage(errorMessage) {
        this.errorMessageInternal = errorMessage;
    }
    get errorMessage() {
        return this.model?.ErrorMessage ?? this.errorMessageInternal;
    }
    /**
     * Gets/sets the hidden state.
     *
     * @memberof BaseValidatorComponent
     */
    set hidden(state) {
        this.hiddenInternal = state;
    }
    get hidden() {
        return this.hiddenInternal;
    }
    /**
     * Gets the validation state.
     *
     * @memberof BaseValidatorComponent
     */
    get validationSuccess() {
        return this.validationSuccessInternal;
    }
    /**
     * Gets/sets the validationGroup.
     *
     * @memberof BaseValidatorComponent
     */
    set validationGroup(value) {
        this.validationGroupInternal = value;
    }
    get validationGroup() {
        return this.model?.ValidationGroup ?? this.validationGroupInternal;
    }
    /**
     * Display property from model or input if exists
     *
     * @readonly
     * @type {string}
     * @memberof GridViewComponent
     */
    set Display(value) {
        this.displayInternal = value;
    }
    get Display() {
        return (this.model && this.model.Display) ?? this.displayInternal;
    }
    /**
     * Execute the validation, has to be overridden by sub-classes.
     *
     * @param expressionToValidate
     * @memberof BaseValidatorComponent
     * @returns the results of the validation.
     */
    validateControl(controlToValidate, validationExpression) {
        return false;
    }
    /**
     * If the text property is defined, it has to be shown instead of the error message
     *
     * @memberof BaseValidatorComponent
     * @returns The property to display
     */
    displayMessage() {
        return this.text && this.text != '' ? this.text : this.errorMessage;
    }
};
BaseValidatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BaseValidatorComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i2.BaseValidatorService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
BaseValidatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BaseValidatorComponent, selector: "ng-component", inputs: { model: "model", controlToValidate: "controlToValidate", errorMessage: "errorMessage" }, providers: [
        { provide: BaseValidatorService, useExisting: WebFormsBaseValidatorService }
    ], usesInheritance: true, ngImport: i0, template: "<span [hidden]=\"hidden\" [ngClass]=\"class\">{{displayMessage()}}</span>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
BaseValidatorComponent = __decorate([
    ExceptionHandlerClass(ErrorCodes.Winforms)
], BaseValidatorComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BaseValidatorComponent, decorators: [{
            type: Component,
            args: [{ inputs: ['model'], providers: [
                        { provide: BaseValidatorService, useExisting: WebFormsBaseValidatorService }
                    ], template: "<span [hidden]=\"hidden\" [ngClass]=\"class\">{{displayMessage()}}</span>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i2.BaseValidatorService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { controlToValidate: [{
                type: Input
            }], errorMessage: [{
                type: Input
            }] } });

/**
 * Angular Component for the Regular Expression Validator Control.
 *
 * @export
 * @class RegularExpressionValidatorComponent
 * @extends {ControlComponent}
 */
let RegularExpressionValidatorComponent = class RegularExpressionValidatorComponent extends BaseValidatorComponent {
    /**
     * Creates an instance of RegularExpressionValidatorComponent.
     *
     * @param {WebMapService} wmService
     * @param {ChangeDetectorRef} refChange
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @memberof RegularExpressionValidatorComponent
     */
    constructor(wmService, refChange, render2, elem, webComponents, validatorService, bringTopServ1) {
        super(refChange, render2, elem, webComponents, validatorService, bringTopServ1);
        this.wmService = wmService;
        /**
         * Property with the REGEX to match.
         *
         * @memberof RegularExpressionValidatorComponent
         */
        this.validationExpressionInternal = '';
        this.validationSuccessInternal = true;
    }
    /**
     * Gets/sets the validation expression.
     *
     * @memberof RegularExpressionValidatorComponent
     */
    set validationExpression(regularExpression) {
        this.validationExpressionInternal = regularExpression;
    }
    get validationExpression() {
        return this.model.ValidationExpression ?? this.validationExpressionInternal;
    }
    /**
     * Match the regular expression with the expressionToValidate
     *
     * @param expressionToValidate
     * @returns if the validation expression match the regular expression
     * @memberof RegularExpressionValidatorComponent
     */
    validateControl(controlToValidate, expressionToValidate) {
        const matches = expressionToValidate.match(this.validationExpression);
        this.validationSuccessInternal =
            (matches != null && matches[0] === expressionToValidate) ||
                expressionToValidate === '';
        if (this.Display !== ValidatorDisplay.None) {
            this.hidden = this.validationSuccessInternal;
        }
        else {
            this.hidden = true;
        }
        return this.validationSuccessInternal;
    }
};
RegularExpressionValidatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RegularExpressionValidatorComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i2.BaseValidatorService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
RegularExpressionValidatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: RegularExpressionValidatorComponent, selector: "wm-regular-expression-validator", inputs: { model: "model", validationExpression: "validationExpression" }, providers: [
        { provide: BaseValidatorService, useExisting: WebFormsBaseValidatorService }
    ], usesInheritance: true, ngImport: i0, template: "<span [hidden]=\"hidden\" [ngClass]=\"class\">{{displayMessage()}}</span>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
RegularExpressionValidatorComponent = __decorate([
    dataTransfer(['regexVal']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], RegularExpressionValidatorComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RegularExpressionValidatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-regular-expression-validator', inputs: ['model'], providers: [
                        { provide: BaseValidatorService, useExisting: WebFormsBaseValidatorService }
                    ], template: "<span [hidden]=\"hidden\" [ngClass]=\"class\">{{displayMessage()}}</span>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i2.BaseValidatorService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { validationExpression: [{
                type: Input
            }] } });

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Angular Component for the MasterPage Control.
 *
 * @export
 * @class MasterPageComponent
 * @extends {ControlComponent}
 * @implements {AfterViewInit}
 */
class MasterPageComponent extends ControlComponent {
    /**
     * Creates an instance of MasterPageComponent.
     * @param {WebMapService} wmService
     * @param {ChangeDetectorRef} refChange
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {PagesRendererService} pRendererService
     * @memberof MasterPageComponent
     */
    constructor(wmService, refChange, render2, elem, pRendererService) {
        super(refChange, render2, elem);
        this.wmService = wmService;
        this.refChange = refChange;
        this.render2 = render2;
        this.elem = elem;
        this.pRendererService = pRendererService;
        /**
         * Component is initialized event emitter.
         *
         * @type {EventEmitter<any>}
         * @memberof MasterPageComponent
         */
        this.initializeEvent = new EventEmitter();
    }
    /**
     * Method to be overwritten with the container initialization.
     *
     * @param {*} page
     * @memberof MasterPageComponent
     */
    /* c8 ignore next 3 */
    initializeContainers(page) {
        this.setContext();
    }
    /**
     * Sets the context for the child page if available.
     *
     * @memberof MasterPageComponent
     */
    setContext() {
        /* c8 ignore else */
        if (this.model?.Parent) {
            this.childModel = this.wmService.core.getModel(this.model.Parent);
        }
    }
    /**
     * AfterViewInit lifecycle hook.
     *
     * @memberof MasterPageComponent
     */
    ngAfterViewInit() {
        this.pRendererService.loadPages(this.container, this);
        setTimeout(() => {
            this.initializeEvent.emit(this);
        }, 0);
    }
}
MasterPageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MasterPageComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: PagesRendererService }], target: i0.ɵɵFactoryTarget.Component });
MasterPageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: MasterPageComponent, selector: "ng-component", viewQueries: [{ propertyName: "container", first: true, predicate: ContainerComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MasterPageComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: PagesRendererService }]; }, propDecorators: { container: [{
                type: ViewChild,
                args: [ContainerComponent]
            }] } });

let RequiredFieldValidatorComponent = class RequiredFieldValidatorComponent extends BaseValidatorComponent {
    /**
     * Creates an instance of RequiredFieldValidatorComponent.
     *
     * @param {WebMapService} wmService
     * @param {ChangeDetectorRef} refChange
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @memberof RequiredFieldValidatorComponent
     */
    constructor(wmService, refChange, render2, elem, webComponents, validatorService, bringTopServ1) {
        super(refChange, render2, elem, webComponents, validatorService, bringTopServ1);
        this.wmService = wmService;
        /**
         * Property with the initial value to validate against
         *
         * @memberof RequiredFieldValidatorComponent
         */
        this.initialValueInternal = '';
    }
    /**
     * Gets/sets the initial value.
     *
     * @memberof RequiredFieldValidatorComponent
     */
    set initialValue(initialValue) {
        this.initialValueInternal = initialValue;
    }
    get initialValue() {
        return this.model.InitialValue ?? this.initialValueInternal;
    }
    /**
     * Compare the expressionToValidate against the initial value
     * to validate that they are different.
     *
     * @param expressionToValidate
     * @returns if the expressionToValidate is different from the initial value.
     * @memberof RequiredFieldValidatorComponent
     */
    validateControl(controlToValidate, expressionToValidate) {
        this.validationSuccessInternal = expressionToValidate !== this.initialValue;
        if (this.Display !== ValidatorDisplay.None) {
            this.hidden = this.validationSuccessInternal;
        }
        else {
            this.hidden = true;
        }
        return this.validationSuccessInternal;
    }
};
RequiredFieldValidatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RequiredFieldValidatorComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i2.BaseValidatorService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
RequiredFieldValidatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: RequiredFieldValidatorComponent, selector: "wm-required-field-validator", inputs: { model: "model", initialValue: "initialValue" }, providers: [
        { provide: BaseValidatorService, useExisting: WebFormsBaseValidatorService }
    ], usesInheritance: true, ngImport: i0, template: "<span [hidden]=\"hidden\" [ngClass]=\"class\">{{displayMessage()}}</span>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
RequiredFieldValidatorComponent = __decorate([
    dataTransfer(['requiredVal']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], RequiredFieldValidatorComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RequiredFieldValidatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-required-field-validator', inputs: ['model'], providers: [
                        { provide: BaseValidatorService, useExisting: WebFormsBaseValidatorService }
                    ], template: "<span [hidden]=\"hidden\" [ngClass]=\"class\">{{displayMessage()}}</span>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i2.BaseValidatorService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { initialValue: [{
                type: Input
            }] } });

let ValidationSummaryComponent = class ValidationSummaryComponent extends ControlComponent {
    /**
     * Base constructor of the component.
     *
     * @param wmService
     * @param refChange
     * @param render2
     * @param elem
     * @param webComponents
     * @param validatorService
     * @param bringTopServ1
     * @memberof ValidationSummaryComponent
     */
    constructor(wmService, refChange, render2, elem, webComponents, validatorService, bringTopServ1) {
        super(refChange, render2, elem, webComponents, bringTopServ1);
        this.wmService = wmService;
        this.refChange = refChange;
        this.render2 = render2;
        this.elem = elem;
        this.validatorService = validatorService;
        this.bringTopServ1 = bringTopServ1;
        /**
         * Property with the errorMessages to be shown.
         *
         * @memberof ValidationSummaryComponent
         */
        this.errorMessagesInternal = [];
        /**
         * Property with the header text.
         *
         * @memberof ValidationSummaryComponent
         */
        this.headerTextInternal = '';
        /**
         * Property with the error message's display mode.
         *
         * @memberof ValidationSummaryComponent
         */
        this.displayModeInternal = ValidationSummaryDisplayMode.BulletList;
        /**
         * Property with the option to create an alert with the error list.
         *
         * @memberof ValidationSummaryComponent
         */
        this.showMessageBoxInternal = false;
        /**
         * Property with the option to show the error messages.
         *
         * @memberof ValidationSummaryComponent
         */
        this.showValidationErrorsInternal = true;
        /**
         * Property with validationGroup.
         *
         * @memberof ValidationSummaryComponent
         */
        this.validationGroupInternal = '';
    }
    /**
     * angular ngOnInit lifehook.
     * Retrieves the error messages from the validator service.
     *
     * @memberof ValidationSummaryComponent
     */
    ngOnInit() {
        this.updateErrorMessages();
        this.validatorService.addValidationSummary(this);
    }
    /**
     * Gets/sets the headerText property.
     *
     * @memberof ValidationSummaryComponent
     */
    set headerText(text) {
        this.headerTextInternal = text;
    }
    get headerText() {
        return this.model.HeaderText ?? this.headerTextInternal;
    }
    /**
     * Gets/sets the showValidationErrors property.
     *
     * @memberof ValidationSummaryComponent
     */
    set showValidationErrors(value) {
        this.showValidationErrorsInternal = value;
    }
    get showValidationErrors() {
        return this.model.ShowValidationErrors ?? this.showValidationErrorsInternal;
    }
    /**
     * Gets/sets the displayMode property.
     *
     * @memberof ValidationSummaryComponent
     */
    set displayMode(value) {
        this.displayModeInternal = value;
    }
    get displayMode() {
        return this.model.DisplayMode ?? this.displayModeInternal;
    }
    /**
     * Gets the ValidationSummaryDisplayMode enum.
     *
     * @readonly
     * @type {typeof ValidationSummaryDisplayMode}
     * @memberof ValidationSummaryComponent
     */
    get validationSummaryDisplayMode() {
        return ValidationSummaryDisplayMode;
    }
    /**
     * Gets/sets the validationGroup.
     *
     * @memberof ValidationSummaryComponent
     */
    set validationGroup(value) {
        this.validationGroupInternal = value;
    }
    get validationGroup() {
        return this.model.ValidationGroup ?? this.validationGroupInternal;
    }
    /**
     * Gets/sets the showMessageBox property.
     *
     * @memberof ValidationSummaryComponent
     */
    set showMessageBox(value) {
        this.showMessageBoxInternal = value;
    }
    get showMessageBox() {
        return this.model.ShowMessageBox ?? this.showMessageBoxInternal;
    }
    /**
     * Gets/sets the visible property.
     *
     * @memberof ValidationSummaryComponent
     */
    set visible(value) {
        super.visible = value;
        if (this.showMessageBox && this.visible) {
            switch (this.displayMode) {
                case ValidationSummaryDisplayMode.List:
                    alert(`${this.headerText}\n${this.formatErrorMessages('\n')}`);
                    break;
                case ValidationSummaryDisplayMode.SingleParagraph:
                    alert(`${this.headerText}\n${this.formatErrorMessages(', ')}`);
                    break;
                default:
                    alert(`${this.headerText}\n- ${this.formatErrorMessages('\n- ')}`);
                    break;
            }
        }
    }
    get visible() {
        return this.model.Visible ?? super.visible;
    }
    /**
     * Gets the error messages property
     *
     * @memberof ValidationSummaryComponent
     */
    get errorMessages() {
        return this.errorMessagesInternal;
    }
    /**
     * Gets the hidden property
     * Should be hidden if either the visible or the showValidationErrors are set to false.
     *
     * @memberof ValidationSummaryComponent
     */
    get hidden() {
        return !this.visible || !this.showValidationErrors;
    }
    /**
     * join the error messages with the given separator.
     *
     * @memberof ValidationSummaryComponent
     * @returns a string with the error messages
     */
    formatErrorMessages(separator) {
        return this.errorMessagesInternal.join(separator);
    }
    /**
     * Updates the array of error messages.
     *
     * @memberof ValidationSummaryComponent
     */
    updateErrorMessages() {
        this.errorMessagesInternal = this.validatorService.getActiveErrorMessages(this.validationGroup);
    }
};
ValidationSummaryComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ValidationSummaryComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i2.BaseValidatorService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ValidationSummaryComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ValidationSummaryComponent, selector: "wm-validation-summary", inputs: { model: "model", headerText: "headerText", showValidationErrors: "showValidationErrors", displayMode: "displayMode", validationGroup: "validationGroup", showMessageBox: "showMessageBox", visible: "visible" }, providers: [
        { provide: BaseValidatorService, useExisting: WebFormsBaseValidatorService }
    ], usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"displayMode == validationSummaryDisplayMode.BulletList && !hidden\" [ngClass]=\"class\">\r\n    {{headerText}}\r\n    <ul>\r\n        <li *ngFor=\"let errorMessage of errorMessages\">\r\n            {{errorMessage}}\r\n        </li>\r\n    </ul>\r\n</div>\r\n\r\n<div *ngIf=\"displayMode == validationSummaryDisplayMode.List && !hidden\" [ngClass]=\"class\">\r\n    {{headerText}}\r\n    <div *ngFor=\"let errorMessage of errorMessages\">\r\n        {{errorMessage}}\r\n        <br>\r\n    </div>\r\n</div>\r\n\r\n\r\n<div *ngIf=\"displayMode == validationSummaryDisplayMode.SingleParagraph && !hidden\" [ngClass]=\"class\">\r\n    {{headerText}} {{formatErrorMessages(', ')}}\r\n</div>", styles: [""], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
ValidationSummaryComponent = __decorate([
    dataTransfer(['valSummary']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], ValidationSummaryComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ValidationSummaryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-validation-summary', inputs: ['model'], providers: [
                        { provide: BaseValidatorService, useExisting: WebFormsBaseValidatorService }
                    ], template: "<div *ngIf=\"displayMode == validationSummaryDisplayMode.BulletList && !hidden\" [ngClass]=\"class\">\r\n    {{headerText}}\r\n    <ul>\r\n        <li *ngFor=\"let errorMessage of errorMessages\">\r\n            {{errorMessage}}\r\n        </li>\r\n    </ul>\r\n</div>\r\n\r\n<div *ngIf=\"displayMode == validationSummaryDisplayMode.List && !hidden\" [ngClass]=\"class\">\r\n    {{headerText}}\r\n    <div *ngFor=\"let errorMessage of errorMessages\">\r\n        {{errorMessage}}\r\n        <br>\r\n    </div>\r\n</div>\r\n\r\n\r\n<div *ngIf=\"displayMode == validationSummaryDisplayMode.SingleParagraph && !hidden\" [ngClass]=\"class\">\r\n    {{headerText}} {{formatErrorMessages(', ')}}\r\n</div>" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i2.BaseValidatorService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { headerText: [{
                type: Input
            }], showValidationErrors: [{
                type: Input
            }], displayMode: [{
                type: Input
            }], validationGroup: [{
                type: Input
            }], showMessageBox: [{
                type: Input
            }], visible: [{
                type: Input
            }] } });

/**
 * Angular Component for the LinkButton Component.
 *
 * @export
 * @class LinkButtonComponent
 * @extends {ControlComponent}
 */
let LinkButtonComponent = class LinkButtonComponent extends ControlComponent {
    /**
     * Creates an instance of LinkButtonComponent.
     * @param {WebMapService} wmService
     * @param {ChangeDetectorRef} refChange
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @param {WebFormsBaseValidatorService} baseValidatorService
     * @param {DefaultButtonService} defaultButtonService
     * @memberof LinkButtonComponent
     */
    constructor(wmService, refChange, render2, elem, webComponents, bringTopServ1, baseValidatorService, defaultButtonService) {
        super(refChange, render2, elem, webComponents, bringTopServ1);
        this.wmService = wmService;
        this.refChange = refChange;
        this.render2 = render2;
        this.elem = elem;
        this.bringTopServ1 = bringTopServ1;
        this.baseValidatorService = baseValidatorService;
        this.defaultButtonService = defaultButtonService;
        /**
         * Property that indicates if the control causes a validation.
         *
         * @memberof LinkButtonComponent
         */
        this.causesValidationInternal = true;
        /**
         * Property with the validation group.
         *
         * @memberof LinkButtonComponent
         */
        this.validationGroupInternal = '';
        /**
         * Property that triggers the webForms validation.
         *
         * @private
         * @memberof LinkButtonComponent
         */
        this.webFormsIntercepted = false;
        /**
         * Property that permit trigger onClick event.
         */
        this.isClickStopped = false;
        /**
         * Emitter of the OnClick event.
         *
         * @memberof LinkButtonComponent
         */
        this.OnClick = new EventEmitter();
    }
    /**
     * ngOnInit of AjaxModalPopUpExtenderComponent
     *
     * @memberof AjaxModalPopUpExtenderComponent
     */
    ngOnInit() {
        super.ngOnInit();
        /* c8 ignore start */
        this.defaultButtonService?.ClickEmittedNotification.subscribe((event) => {
            if (event.args === this.id && this.displayElement !== undefined) {
                this.displayElement.focus();
                this.displayElement.click();
            }
        }); /* c8 ignore stop */
    }
    /**
     * Sets the displayElement
     *
     * @memberof DropdownListComponent
     */
    set displayElementPanel(value) {
        this.displayElement = value != null ? value.nativeElement : null;
    }
    /**
     * Triggers the OnClientClick and OnClick emitters.
     *
     * @memberof LinkButtonComponent
     */
    click(event) {
        this.webFormsIntercepted = this.causesValidation;
        /* c8 ignore else */
        if (!this.isClickStopped) {
            this.OnClick.emit(new EventData(event, this.id));
        }
    }
    /**
     * Sets/gets the validationGroup property
     *
     * @memberof LinkButtonComponent
     */
    set validationGroup(value) {
        this.validationGroupInternal = value;
    }
    get validationGroup() {
        return this.model.ValidationGroup ?? this.validationGroupInternal;
    }
    /**
     * Sets/gets the causesValidation property
     *
     * @memberof LinkButtonComponent
     */
    set causesValidation(value) {
        this.causesValidationInternal = value;
    }
    get causesValidation() {
        return this.model.CausesValidation ?? this.causesValidationInternal;
    }
};
LinkButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LinkButtonComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: WebFormsBaseValidatorService }, { token: DefaultButtonService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
LinkButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: LinkButtonComponent, selector: "wm-link-button", inputs: { model: "model", validationGroup: "validationGroup", causesValidation: "causesValidation" }, outputs: { OnClick: "OnClick" }, providers: [
        {
            provide: BaseValidatorService,
            useExisting: WebFormsBaseValidatorService
        }
    ], viewQueries: [{ propertyName: "displayElementPanel", first: true, predicate: ["displayElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<a #displayElement (click)='click($event)' href='javascript:window.scrollTo(0, 0)' *ngIf='model && visible'\r\n   [ngClass]='class' wmControls [hostComponent]='this'> {{text}} </a>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ControlsDirective, selector: "[wmControls]" }] });
__decorate([
    serverEvent('Click')
], LinkButtonComponent.prototype, "click", null);
LinkButtonComponent = __decorate([
    dataTransfer(['lnkBtn']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], LinkButtonComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LinkButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-link-button', inputs: ['model'], providers: [
                        {
                            provide: BaseValidatorService,
                            useExisting: WebFormsBaseValidatorService
                        }
                    ], template: "<a #displayElement (click)='click($event)' href='javascript:window.scrollTo(0, 0)' *ngIf='model && visible'\r\n   [ngClass]='class' wmControls [hostComponent]='this'> {{text}} </a>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: WebFormsBaseValidatorService }, { type: DefaultButtonService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { displayElementPanel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }], OnClick: [{
                type: Output
            }], click: [], validationGroup: [{
                type: Input
            }], causesValidation: [{
                type: Input
            }] } });

/**
 * Angular directive to set properties, styles and attributes to HTML Controls.
 *
 * @export
 * @class HtmlControlDirective
 * @implements {OnInit}
 */
class HtmlControlDirective {
    /**
     * Creates an instance of HtmlControlDirective.
     *
     * @param {ElementRef} element
     * @param {Renderer2} renderer
     * @param {WebMapService} wmService
     * @memberof HtmlControlDirective
     */
    constructor(element, renderer, wmService) {
        this.element = element;
        this.renderer = renderer;
        this.wmService = wmService;
        /**
         * OnClick event emitter.
         *
         * @type {EventEmitter<EventData>}
         * @memberof HtmlControlDirective
         */
        this.OnClick = new EventEmitter();
        /**
         * Url to upload the file.
         *
         * @memberof HtmlControlDirective
         */
        this.uploadFileUrl = 'api/inputfile/UploadFile';
    }
    /**
     * OnInit lifecycle hook.
     *
     * @memberof HtmlControlDirective
     */
    ngOnInit() {
        this.applyProperties();
        this.applyAtributes();
    }
    /**
     * Gets the Id property.
     *
     * @readonly
     * @type {string}
     * @memberof HtmlControlDirective
     */
    get id() {
        return this.model?.id ?? '';
    }
    /**
     * Gets the name property.
     *
     * @readonly
     * @type {string}
     * @memberof HtmlControlDirective
     */
    get name() {
        return this.model?.Name ?? '';
    }
    /**
     * Apply WebForms properties.
     *
     * @memberof HtmlControlDirective
     */
    applyProperties() {
        /* c8 ignore else*/
        if (this.model) {
            /* c8 ignore else*/
            if (this.model.InnerText) {
                this.renderer.setProperty(this.element.nativeElement, 'innerText', this.model.InnerText);
            }
            if (this.model.Visible === false) {
                this.renderer.setStyle(this.element.nativeElement, 'display', 'none');
            }
            else {
                this.renderer.setStyle(this.element.nativeElement, 'display', '');
            }
        }
    }
    /**
     * Apply WebForms HTML attributes.
     *
     * @memberof HtmlControlDirective
     */
    applyAtributes() {
        /* c8 ignore else*/
        if (this.model?.Attributes) {
            for (const entry of Object.entries(this.model.Attributes)) {
                const attribute = entry[0];
                const value = entry[1];
                this.renderer.setAttribute(this.element.nativeElement, attribute, value);
            }
        }
    }
    /**
     * Indicates if an event is binded in the server or not.
     * Added in the directive to validate and use the events mechanism.
     *
     * @param {string} event
     * @return {*}  {boolean}
     * @memberof HtmlControlDirective
     */
    isBindedEvent(event) {
        return this.model?.events && this.model.events[event];
    }
    /**
     * Empty detectChanges method.
     * Added in the directive to use the events mechanism.
     *
     * @memberof HtmlControlDirective
     */
    detectChanges() { }
    /**
     * Listener for the click event.
     *
     * @param {*} event
     * @memberof HtmlControlDirective
     */
    clickListener(event) {
        this.click(event);
    }
    /**
     * Triggers the OnClick emitter.
     *
     * @param {*} event
     * @memberof HtmlControlDirective
     */
    click(event) {
        this.OnClick.emit(new EventData(event, this.id));
    }
    /**
     * Listener for the change event.
     *
     * @param {*} event
     * @memberof HtmlControlDirective
     */
    changeListener(event) {
        /* c8 ignore else*/
        if (this.isInputFile(event)) {
            this.changeInputFileHandler(event);
        }
    }
    /**
     * Validates if the event is coming from an input file element.
     *
     * @param {*} event
     * @return {*}  {boolean}
     * @memberof HtmlControlDirective
     */
    isInputFile(event) {
        return (event?.currentTarget?.localName === 'input' &&
            event.currentTarget.type === 'file');
    }
    /**
     * Handles the change event for the input file.
     * Posts the selected file to the server.
     *
     * @param {*} event
     * @memberof HtmlControlDirective
     */
    changeInputFileHandler(event) {
        const fileList = event.target.files;
        const formData = new FormData();
        const url = `${this.uploadFileUrl}?id=${this.id}`;
        /* c8 ignore else*/
        if (fileList?.length > 0) {
            formData.append('fileKey', fileList[0], fileList[0].name);
            this.wmService.post(url, formData).subscribe();
        }
    }
}
HtmlControlDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HtmlControlDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i1.WebMapService }], target: i0.ɵɵFactoryTarget.Directive });
HtmlControlDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: HtmlControlDirective, selector: "[wmHtmlControl]", inputs: { model: "model" }, outputs: { OnClick: "OnClick" }, host: { listeners: { "click": "clickListener($event)", "change": "changeListener($event)" } }, ngImport: i0 });
__decorate([
    serverEvent('Click')
], HtmlControlDirective.prototype, "click", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HtmlControlDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[wmHtmlControl]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1.WebMapService }]; }, propDecorators: { model: [{
                type: Input
            }], OnClick: [{
                type: Output
            }], clickListener: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], click: [], changeListener: [{
                type: HostListener,
                args: ['change', ['$event']]
            }] } });

/**
 * Angular Component for the CompareValidator Control.
 *
 * @export
 * @class CompareValidatorComponent
 * @extends {BaseValidatorComponent}
 */
let CompareValidatorComponent = class CompareValidatorComponent extends BaseValidatorComponent {
    /**
     * Creates an instance of CompareValidatorComponent.
     *
     * @param {WebMapService} wmService
     * @param {ChangeDetectorRef} refChange
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @memberof CompareValidatorComponent
     */
    constructor(wmService, refChange, render2, elem, webComponents, validatorService, bringTopServ1) {
        super(refChange, render2, elem, webComponents, validatorService, bringTopServ1);
        this.wmService = wmService;
        /**
         * Property with the controlToCompare id.
         *
         * @private
         * @type {string}
         * @memberof CompareValidatorComponent
         */
        this.controlToCompareInternal = '';
        /**
         * Property with the controlToValidateValue.
         *
         * @private
         * @type {(string | number | Date)}
         * @memberof CompareValidatorComponent
         */
        this.controlToValidateValue = '';
        /**
         * Property with the controlToCompareValue.
         *
         * @private
         * @type {(string | number | Date)}
         * @memberof CompareValidatorComponent
         */
        this.controlToCompareValue = '';
        /**
         *Property with the operator
         *
         * @private
         * @memberof CompareValidatorComponent
         */
        this.operatorInternal = 'Equal';
        this.validationSuccessInternal = true;
    }
    /**
     * OnInit lifecycle hook, adds itself to the service.
     *
     * @memberof CompareValidatorComponent
     */
    ngOnInit() {
        this.validatorService.addCompareValidator(this.controlToCompare, this);
    }
    /**
     *Set/Gets the controlToCompare property.
     *
     * @memberof CompareValidatorComponent
     */
    set controlToCompare(value) {
        this.controlToCompareInternal = value;
    }
    get controlToCompare() {
        return this.model.ControlToCompare ?? this.controlToCompareInternal;
    }
    /**
     *Set/Gets the operator property.
     *
     * @memberof CompareValidatorComponent
     */
    set operator(value) {
        this.operatorInternal = value;
    }
    get operator() {
        return this.model.Operator ?? this.operatorInternal;
    }
    /**
     * Compare the two controls attached.
     *
     * @param {string} controlToValidate
     * @param {string} expressionToValidate
     * @return the result of the validation.
     * @memberof CompareValidatorComponent
     */
    validateControl(controlToValidate, expressionToValidate) {
        if (controlToValidate === this.controlToValidate) {
            this.controlToValidateValue = expressionToValidate;
        }
        else {
            this.controlToCompareValue = expressionToValidate;
        }
        this.validationSuccessInternal = this.applyComparation();
        if (this.Display !== ValidatorDisplay.None) {
            this.hidden = this.validationSuccessInternal;
        }
        else {
            this.hidden = true;
        }
        return this.validationSuccessInternal;
    }
    /**
     * Compare the attached controls.
     *
     * @return {*}  {boolean}
     * @memberof CompareValidatorComponent
     */
    applyComparation() {
        let validation;
        switch (this.operator) {
            case 'NotEqual':
                validation = this.controlToValidateValue !== this.controlToCompareValue;
                break;
            case 'GreaterThan':
                validation = this.controlToValidateValue > this.controlToCompareValue;
                break;
            case 'GreaterThanEqual':
                validation = this.controlToValidateValue >= this.controlToCompareValue;
                break;
            case 'LessThan':
                validation = this.controlToValidateValue < this.controlToCompareValue;
                break;
            case 'LessThanEqual':
                validation = this.controlToValidateValue <= this.controlToCompareValue;
                break;
            default:
                validation = this.controlToValidateValue === this.controlToCompareValue;
                break;
        }
        return validation;
    }
};
CompareValidatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CompareValidatorComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i2.BaseValidatorService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
CompareValidatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: CompareValidatorComponent, selector: "wm-compare-validator", inputs: { model: "model", controlToCompare: "controlToCompare", operator: "operator" }, providers: [
        { provide: BaseValidatorService, useExisting: WebFormsBaseValidatorService }
    ], usesInheritance: true, ngImport: i0, template: "<span [hidden]=\"hidden\" [ngClass]=\"class\">{{displayMessage()}}</span>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
CompareValidatorComponent = __decorate([
    dataTransfer(['compVal']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], CompareValidatorComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CompareValidatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-compare-validator', inputs: ['model'], providers: [
                        { provide: BaseValidatorService, useExisting: WebFormsBaseValidatorService }
                    ], template: "<span [hidden]=\"hidden\" [ngClass]=\"class\">{{displayMessage()}}</span>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i2.BaseValidatorService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { controlToCompare: [{
                type: Input
            }], operator: [{
                type: Input
            }] } });

/**
 * Angular Component for the CustomValidator Control.
 *
 * @export
 * @class CustomValidatorComponent
 * @extends {BaseValidatorComponent}
 */
let CustomValidatorComponent = class CustomValidatorComponent extends BaseValidatorComponent {
    /**
     * Creates an instance of CustomValidatorComponent.
     *
     * @param {WebMapService} wmService
     * @param {ChangeDetectorRef} refChange
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @memberof CustomValidatorComponent
     */
    constructor(wmService, refChange, render2, elem, webComponents, validatorService, bringTopServ1) {
        super(refChange, render2, elem, webComponents, validatorService, bringTopServ1);
        this.wmService = wmService;
        /**
         * Arrow function to evaluate the expression of the attached component.
         *
         * @private
         * @param {string} expression
         * @memberof CustomValidatorComponent
         */
        this.clientValidationFunction = (expression) => {
            return true;
        };
    }
    /**
     * Executes the clientValidationFunction to validate the component attached.
     *
     * @param {string} controlToValidateId
     * @param {string} expression
     * @return {*}  {boolean}
     * @memberof CustomValidatorComponent
     */
    validateControl(controlToValidateId, expression) {
        this.validationSuccessInternal = this.clientValidationFunction(expression);
        if (this.Display !== ValidatorDisplay.None) {
            this.hidden = this.validationSuccessInternal;
        }
        else {
            this.hidden = true;
        }
        return this.validationSuccessInternal;
    }
};
CustomValidatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CustomValidatorComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i2.BaseValidatorService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
CustomValidatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: CustomValidatorComponent, selector: "wm-custom-validator", inputs: { model: "model", clientValidationFunction: "clientValidationFunction" }, providers: [
        { provide: BaseValidatorService, useExisting: WebFormsBaseValidatorService }
    ], usesInheritance: true, ngImport: i0, template: "<span [hidden]=\"hidden\" [ngClass]=\"class\">{{displayMessage()}}</span>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
CustomValidatorComponent = __decorate([
    dataTransfer(['customVal']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], CustomValidatorComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CustomValidatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-custom-validator', inputs: ['model'], providers: [
                        { provide: BaseValidatorService, useExisting: WebFormsBaseValidatorService }
                    ], template: "<span [hidden]=\"hidden\" [ngClass]=\"class\">{{displayMessage()}}</span>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i2.BaseValidatorService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { clientValidationFunction: [{
                type: Input
            }] } });

var DataListComponent_1;
let DataListComponent = DataListComponent_1 = class DataListComponent extends GridComponent {
    /**
     * ItemCommand extractor.
     *
     * @static
     * @param {*} event
     * @param {DataListComponent} component
     * @return {*}  {*}
     * @memberof DataListComponent
     */
    static ItemCommandExtractor(event, component) {
        return [
            { Id: event.Id, MapperId: event.mapperId },
            {
                MapperId: DataListComponent_1.itemCommandMapperId,
                ControlSourceId: event.args.CommandSource?.id
            }
        ];
    }
    /**
     * Creates an instance of DataListComponent.
     *
     * @param {WebMapService} wmService
     * @param {ChangeDetectorRef} refChange
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {FormBuilder} formBuilderRef
     * @param {InternalEventHandlerService} internalEventHandler
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @memberof DataListComponent
     */
    constructor(wmService, refChange, render2, elem, formBuilderRef, internalEventHandler, containerTabOService, webComponents, bringTopServ1, containerInteraction) {
        super(wmService, refChange, render2, elem, formBuilderRef, webComponents, bringTopServ1);
        this.wmService = wmService;
        this.refChange = refChange;
        this.render2 = render2;
        this.elem = elem;
        this.formBuilderRef = formBuilderRef;
        this.internalEventHandler = internalEventHandler;
        this.containerTabOService = containerTabOService;
        this.bringTopServ1 = bringTopServ1;
        this.containerInteraction = containerInteraction;
        /**
         * Controls in the dataList
         *
         * @type {any[]}
         * @memberof DataListComponent
         */
        this.controls = [];
        /**
         * Base url value.
         *
         * @memberof DataListComponent
         */
        this.defaultDataUrl = 'api/dataList';
        /**
         * Url for the ids of the controls.
         *
         * @memberof DataListComponent
         */
        this.getControlIdsUrl = `${this.defaultDataUrl}/GetControlsId`;
        /**
         * Emitter for the onItemCommand Event.
         *
         * @type {EventEmitter<{ source: any; e: any }>}
         * @memberof DataListComponent
         */
        this.OnItemCommand = new EventEmitter();
        this.isContainer = true;
    }
    /**
     * OnInit lifecycle hook.
     *
     * @memberof DataListComponent
     */
    ngOnInit() {
        super.ngOnInit();
        this.refresh = this.refresh ? false : this.refresh;
        this.loadControlsById();
        this.setSelectableSettings();
        this.internalClickHandler();
    }
    /**
     * DoCheck lifecycle hook
     *
     * @memberof DataListComponent
     */
    ngDoCheck() {
        if (this.model && this.refresh) {
            this.loadControlsById();
            this.refresh = false;
        }
    }
    /**
     * Applies focus to first inner element by tab index
     */
    applyFocus() {
        this.containerTabOService.enterContainer(false, null, false);
    }
    /**
     * Loads the dataList components by its id.
     *
     * @memberof DataListComponent
     */
    loadControlsById() {
        this.wmService
            .fetch(this.getControlIdsUrl, this.id)
            .subscribe((controlIds) => {
            // This to allow the server reassign of the dataSource controls collection
            this.controls = [];
            controlIds.forEach((templateIteration) => {
                const controlKeys = Object.keys(templateIteration);
                const iterationControls = {};
                controlKeys.forEach((controlKey) => {
                    iterationControls[controlKey] = this.wmService.core.getModel(templateIteration[controlKey]);
                });
                this.controls.push(iterationControls);
            });
            this.refChange.detectChanges();
        });
    }
    /**
     * Gets the ItemStyle property.
     *
     * @readonly
     * @memberof DataListComponent
     */
    get itemStyle() {
        return this.model?.ItemStyle;
    }
    /**
     * gets the AlternatingItemStyle property.
     *
     * @readonly
     * @memberof DataListComponent
     */
    get alternatingItemStyle() {
        return this.model?.AlternatingItemStyle;
    }
    /**
     *Overrides visible property for setting up true if model doesn't have visible property exist model
     *
     * @readonly
     * @type {boolean}
     * @memberof DataListComponent
     */
    get visible() {
        return this.model?.Visible != null ? this.model.Visible : true;
    }
    /**
     * Returns the css class name to be used in the template iteration.
     *
     * @param {number} index
     * @return {*} {string}
     * @memberof DataListComponent
     */
    templateClass(index) {
        return this.alternatingItemStyle !== undefined && index % 2 === 1
            ? this.alternatingItemStyle.CssClass
            : this.itemStyle?.CssClass;
    }
    /**
     * Handles the client click events raised by the dataList internal button controls.
     *
     * @memberof DataListComponent
     */
    internalClickHandler() {
        this.internalEventHandler.onButtonClick.subscribe((event) => {
            const eventData = new EventData(event, this.id, DataListComponent_1.itemCommandMapperId);
            eventData.args = event.clientClickArgs;
            this.onItemCommandEventHandler(eventData);
        });
    }
    /**
     * Triggers the onItemdCommand emitter.
     *
     * @param {*} event
     * @memberof DataListComponent
     */
    onItemCommandEventHandler(event) {
        this.OnItemCommand.emit({ source: this.model, e: event?.args });
    }
    /**
     * Returns the controls for a specific item iteration.
     *
     * @param {string} itemId
     * @return {*}  {any[]}
     * @memberof DataListComponent
     */
    getItemControls(itemId) {
        const itemControls = [];
        for (const controlItem of this.controls) {
            const keys = Object.keys(controlItem);
            for (const key of keys) {
                /* c8 ignore else*/
                if (controlItem[key].id === itemId) {
                    return Object.keys(controlItem).map((itemKey) => controlItem[itemKey]);
                }
            }
        }
        return itemControls;
    }
};
/**
 * MapperId value for ItemCommand event.
 *
 * @static
 * @memberof DataListComponent
 */
DataListComponent.itemCommandMapperId = 'dlcmmnd';
DataListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DataListComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i5.UntypedFormBuilder }, { token: InternalEventHandlerService }, { token: i2.ContainerTabOrderService, optional: true }, { token: i2.WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: i2.ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DataListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: DataListComponent, selector: "wm-data-list", inputs: { model: "model" }, outputs: { OnItemCommand: "OnItemCommand" }, providers: [
        InternalEventHandlerService,
        ContainerTabOrderService,
        ContainerInteractionService
    ], queries: [{ propertyName: "ItemTemplate", first: true, predicate: ["ItemTemplate"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div [ngClass]=\"class\" *ngIf=\"model && visible\" wmControls [hostComponent]=\"this\">\r\n  <ng-container *ngFor=\"let row of controls; let i = index;\">\r\n    <ng-container *ngTemplateOutlet=\"ItemTemplate; context: {$implicit: row, index: i, templateClass: templateClass(i)}\">\r\n    </ng-container>\r\n  </ng-container>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.ControlsDirective, selector: "[wmControls]" }] });
__decorate([
    serverEvent('ItemCommand', DataListComponent_1.ItemCommandExtractor)
], DataListComponent.prototype, "onItemCommandEventHandler", null);
DataListComponent = DataListComponent_1 = __decorate([
    dataTransfer(['dtlst']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], DataListComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DataListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-data-list', inputs: ['model'], providers: [
                        InternalEventHandlerService,
                        ContainerTabOrderService,
                        ContainerInteractionService
                    ], template: "<div [ngClass]=\"class\" *ngIf=\"model && visible\" wmControls [hostComponent]=\"this\">\r\n  <ng-container *ngFor=\"let row of controls; let i = index;\">\r\n    <ng-container *ngTemplateOutlet=\"ItemTemplate; context: {$implicit: row, index: i, templateClass: templateClass(i)}\">\r\n    </ng-container>\r\n  </ng-container>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i5.UntypedFormBuilder }, { type: InternalEventHandlerService }, { type: i2.ContainerTabOrderService, decorators: [{
                    type: Optional
                }] }, { type: i2.WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: i2.ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { ItemTemplate: [{
                type: ContentChild,
                args: ['ItemTemplate']
            }], OnItemCommand: [{
                type: Output
            }], onItemCommandEventHandler: [] } });

/**
 * Angular Component for the DropdownList Control.
 *
 * @export
 * @class DropdownListComponent
 * @extends {ControlComponent}
 */
let DropdownListComponent = class DropdownListComponent extends ControlComponent {
    /**
     * Creates an instance of DropdownListComponent.
     * @param {WebMapService} serviceRef
     * @param {ChangeDetectorRef} changeDetectorRef
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @param {ContainerInteractionService} [containerInteraction]
     * @memberof DropdownListComponent
     */
    constructor(serviceRef, changeDetectorRef, render2, elem, webComponents, baseValidatorService, bringTopServ1, containerInteraction) {
        super(changeDetectorRef, render2, elem, webComponents, bringTopServ1, containerInteraction);
        this.serviceRef = serviceRef;
        this.changeDetectorRef = changeDetectorRef;
        this.render2 = render2;
        this.elem = elem;
        this.baseValidatorService = baseValidatorService;
        this.bringTopServ1 = bringTopServ1;
        this.containerInteraction = containerInteraction;
        /**
         *default variable to set autoposback in false in case autoposback doesn't exists from model
         *
         * @type {boolean}
         * @memberof DropdownListComponent
         */
        this.autoPostBackInternal = false;
        /**
         * default API to get Dropdownlist data
         *
         * @memberof DropdownListComponent
         */
        this.defaultDataUrl = 'api/DropDownList/GetItems';
        /**
         * SelectedIndexChanged event emitter.
         * @type {EventEmitter<EventData>}
         * @memberof DropdownListComponent
         */
        this.SelectedIndexChanged = new EventEmitter();
    }
    /**
     * Sets the displayElement
     *
     * @memberof DropdownListComponent
     */
    set displayElementPanel(value) {
        this.displayElement = value != null ? value.wrapper?.nativeElement : null;
    }
    /**
     * Returns the data source URL of this component.
     *
     * @readonly
     * @type {string}
     * @memberof DropdownListComponent
     */
    get url() {
        return this.defaultDataUrl;
    }
    /**
     * Optional input parameter to specify autopostback property setter and getter.
     *
     * @memberof DropdownListComponent
     */
    set autoPostBack(autoPostBack) {
        this.model.AutoPostBack = autoPostBack;
    }
    get autoPostBack() {
        return this.model.AutoPostBack ?? this.autoPostBackInternal;
    }
    /**
     * Refresh property flag to identify
     * when to reload data in a dropdownlist
     *
     * @memberof DropdownListComponent
     */
    set refresh(value) {
        this.model.Refresh = value;
    }
    get refresh() {
        return this.model.Refresh;
    }
    /**
     * Gets visible property
     *
     * For this control the default is true
     *
     * @readonly
     * @type {boolean}
     * @memberof DropdownListComponent
     */
    get visible() {
        return this.model.Visible ?? true;
    }
    /**
     * Trigger the selectedValueChanged Event on server side
     *
     * @param {*} event
     * @memberof DropdownListComponent
     */
    triggerIndexChange(event) {
        this.SelectedIndexChanged.emit(new EventData(event, this.id));
    }
    /**
     *Handle trigger server even in only if autoposback is true
     *
     * @param {*} event
     * @memberof DropdownListComponent
     */
    valueChangeHandler(event) {
        /* c8 ignore else */
        if (this.baseValidatorService != undefined) {
            this.baseValidatorService.validate(this.id, event.Value);
        }
        if (this.autoPostBack) {
            this.triggerIndexChange(event);
        }
        else {
            this.SelectedIndexChanged.emit(new EventData(event, this.id));
        }
    }
    /**
     * Fetchs items
     *
     * @property items
     */
    fetchItems() {
        this.serviceRef.fetch(this.url, this.id).subscribe((data) => {
            this.items = data;
            this.detectChanges();
            this.validateFirsTimeValue();
        });
    }
    /**
     * Initialize component and load data to Dropdownlist
     *
     * @memberof DropdownListComponent
     */
    ngOnInit() {
        super.ngOnInit();
        /* c8 ignore else */
        if (this.model) {
            this.refresh = false;
            this.fetchItems();
        }
    }
    /**
     * Gets the enabled property.
     *
     * @readonly
     * @type {boolean}
     * @memberof DropdownListComponent
     */
    get enabled() {
        return this.model?.Enabled ?? true;
    }
    /**
     * Get Selected Item
     * @readonly
     * @type {*}
     * @memberof DropdownListComponent
     */
    get selectedItem() {
        /* c8 ignore else */
        if (this.model) {
            /* c8 ignore else */
            if (this.model.SelectedIndex > -1 &&
                this.items != null &&
                this.items.length > this.model.SelectedIndex) {
                return this.items[this.model.SelectedIndex];
            }
        }
        return null;
    }
    /**
     * Notify selectedIndex change on server side
     *
     * @memberof DropdownListComponent
     */
    set selectedItem(value) {
        const currentValue = value;
        this.model.SelectedIndex = this.items
            ? this.items.indexOf(currentValue)
            : -1;
    }
    /**
     *Docheck lifecycle hook
     *
     * @memberof DropdownListComponent
     */
    ngDoCheck() {
        super.ngDoCheck();
        if (this.model && this.refresh) {
            this.fetchItems();
            this.refresh = false;
        }
    }
    /**
     * Validates the first time
     *
     * @memberof DropdownListComponent
     */
    validateFirsTimeValue() {
        if (this.selectedItem != null && this.baseValidatorService) {
            this.baseValidatorService.validate(this.id, this.selectedItem.Value);
        }
    }
};
DropdownListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DropdownListComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i2.BaseValidatorService, optional: true }, { token: i3.BringTopService, optional: true }, { token: i2.ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
DropdownListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: DropdownListComponent, selector: "wm-dropdown-list", inputs: { model: "model", autoPostBack: "autoPostBack" }, outputs: { SelectedIndexChanged: "SelectedIndexChanged" }, viewQueries: [{ propertyName: "displayElementPanel", first: true, predicate: ["displayElement"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\">\r\n  <kendo-dropdownlist #displayElement [data]=\"items\" [(ngModel)]=\"selectedItem\" textField=\"Text\" valueField=\"Value\"\r\n    (valueChange)=\"valueChangeHandler($event)\" [disabled]=\"!enabled\" [ngClass]=\"class\" wmControls\r\n    [hostComponent]=\"this\">\r\n  </kendo-dropdownlist>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i2.ControlsDirective, selector: "[wmControls]" }, { kind: "component", type: i6.DropDownListComponent, selector: "kendo-dropdownlist", inputs: ["iconClass", "loading", "data", "value", "textField", "valueField", "popupSettings", "listHeight", "defaultItem", "disabled", "itemDisabled", "readonly", "filterable", "virtual", "ignoreCase", "delay", "valuePrimitive", "tabindex", "tabIndex", "size", "rounded", "fillMode", "id"], outputs: ["valueChange", "filterChange", "selectionChange", "open", "opened", "close", "closed", "focus", "blur"], exportAs: ["kendoDropDownList"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    serverEvent('SelectedIndexChanged')
], DropdownListComponent.prototype, "triggerIndexChange", null);
__decorate([
    MarkForCheck(),
    NotifyChange('SelectedIndex')
], DropdownListComponent.prototype, "selectedItem", null);
DropdownListComponent = __decorate([
    dataTransfer(['ddwnlst']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], DropdownListComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DropdownListComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-dropdown-list', inputs: ['model'], template: "<div *ngIf=\"model\">\r\n  <kendo-dropdownlist #displayElement [data]=\"items\" [(ngModel)]=\"selectedItem\" textField=\"Text\" valueField=\"Value\"\r\n    (valueChange)=\"valueChangeHandler($event)\" [disabled]=\"!enabled\" [ngClass]=\"class\" wmControls\r\n    [hostComponent]=\"this\">\r\n  </kendo-dropdownlist>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i2.BaseValidatorService, decorators: [{
                    type: Optional
                }] }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: i2.ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { displayElementPanel: [{
                type: ViewChild,
                args: ['displayElement', { static: false }]
            }], autoPostBack: [{
                type: Input
            }], SelectedIndexChanged: [{
                type: Output
            }], triggerIndexChange: [], selectedItem: [] } });

/**
 * Angular Component for the TableCell Control.
 *
 * @export
 * @class TableCellComponent
 * @extends {ControlComponent}
 */
let TableCellComponent = class TableCellComponent extends ControlComponent {
    /**
     * Creates an instance of TableCellComponent.
     *
     * @param {WebMapService} wmService
     * @param {ChangeDetectorRef} refCh
     * @param {Renderer2} renderer2
     * @param {ElementRef} element
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ
     * @memberof TableCellComponent
     */
    constructor(wmService, refCh, renderer2, element, webComponents, bringTopServ) {
        super(refCh, renderer2, element, webComponents, bringTopServ);
        this.wmService = wmService;
        this.refCh = refCh;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
    }
    /**
     * Returns the models of the controls inside the cell.
     *
     * @return {*}  {*}
     * @memberof TableCellComponent
     */
    getModels() {
        const models = {};
        /* c8 ignore else*/
        if (this.model?.Controls) {
            Object.keys(this.model.Controls).forEach((key) => {
                const model = this.wmService.core.getModel(key);
                const name = model?.Name;
                /* c8 ignore else*/
                if (name) {
                    models[name] = model;
                }
            });
        }
        return models;
    }
};
TableCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TableCellComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
TableCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TableCellComponent, selector: "wm-tablecell", inputs: { model: "model" }, queries: [{ propertyName: "controlsTemplate", first: true, predicate: ["ControlsTemplate"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-content></ng-content>", styles: [""], changeDetection: i0.ChangeDetectionStrategy.OnPush });
TableCellComponent = __decorate([
    dataTransfer(['tblcll']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], TableCellComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TableCellComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-tablecell', inputs: ['model'], template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { controlsTemplate: [{
                type: ContentChild,
                args: ['ControlsTemplate']
            }] } });

/**
 * Angular Component for the TableRow Control.
 *
 * @export
 * @class TableRowComponent
 * @extends {ControlComponent}
 */
let TableRowComponent = class TableRowComponent extends ControlComponent {
    /**
     * Creates an instance of TableRowComponent.
     *
     * @param {ChangeDetectorRef} refCh
     * @param {Renderer2} renderer2
     * @param {ElementRef} element
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ
     * @memberof TableRowComponent
     */
    constructor(refCh, renderer2, element, webComponents, bringTopServ) {
        super(refCh, renderer2, element, webComponents, bringTopServ);
        this.refCh = refCh;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        /**
         * List of TableCell components.
         *
         * @private
         * @type {QueryList<TableCellComponent>}
         * @memberof TableRowComponent
         */
        this.tableCellChildren = new QueryList();
    }
    /**
     * Gets the table cells array.
     *
     * @readonly
     * @type {any[]}
     * @memberof TableRowComponent
     */
    get tableCells() {
        return this.tableCellChildren.toArray();
    }
};
TableRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TableRowComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
TableRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TableRowComponent, selector: "wm-tablerow", inputs: { model: "model" }, queries: [{ propertyName: "tableCellChildren", predicate: TableCellComponent }], usesInheritance: true, ngImport: i0, template: "<ng-content></ng-content>", styles: [""], changeDetection: i0.ChangeDetectionStrategy.OnPush });
TableRowComponent = __decorate([
    dataTransfer(['tblrw']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], TableRowComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TableRowComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-tablerow', inputs: ['model'], template: "<ng-content></ng-content>" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { tableCellChildren: [{
                type: ContentChildren,
                args: [TableCellComponent]
            }] } });

/**
 * Angular Component for the Table Controls.
 *
 * @export
 * @class TableComponent
 * @extends {ControlComponent}
 */
let TableComponent = class TableComponent extends ControlContainerComponent {
    /**
     * Creates an instance of TableComponent.
     *
     * @param {WebMapService} wmService
     * @param {ChangeDetectorRef} refCh
     * @param {Renderer2} renderer2
     * @param {ElementRef} element
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ
     * @memberof TableComponent
     */
    constructor(wmService, refCh, renderer2, element, webComponents, bringTopServ) {
        super(wmService, refCh, renderer2, element, webComponents, bringTopServ);
        this.wmService = wmService;
        this.refCh = refCh;
        this.renderer2 = renderer2;
        this.element = element;
        this.bringTopServ = bringTopServ;
        /**
         * Property to save the the width value.
         *
         * @private
         * @type {number}
         * @memberof TableComponent
         */
        this.widthInternal = Number.NaN;
        /**
         * Property to save the dynamic cells models.
         *
         * @private
         * @type {any[]}
         * @memberof TableComponent
         */
        this.dynamicCellsModels = [];
        /**
         * List of TableRow components.
         *
         * @type {QueryList<TableRowComponent>}
         * @memberof TableComponent
         */
        this.tableRowChildren = new QueryList();
    }
    /**
     * OnInit lifecycle hook.
     *
     * @memberof TableComponent
     */
    ngOnInit() {
        this.loadDynamicCells();
    }
    /**
     * Gets/sets the width.
     *
     * @memberof TableComponent
     */
    set width(value) {
        this.widthInternal = value;
    }
    get width() {
        return this.model.Width ?? this.widthInternal;
    }
    /**
     * Gets the tableRows array.
     *
     * @readonly
     * @type {any[]}
     * @memberof TableComponent
     */
    get tableRows() {
        return this.tableRowChildren.toArray();
    }
    /**
     * Returns the tableCells for a specific row.
     *
     * @param {number} rowIndex
     * @return {*}  {any[]}
     * @memberof TableComponent
     */
    getTableCells(rowIndex) {
        return this.tableRows.length > rowIndex
            ? this.tableRows[rowIndex].tableCells
            : [];
    }
    /**
     * Return the controls template for a specific row and cell.
     *
     * @param {number} rowIndex
     * @param {number} columnIndex
     * @return {*}  {*}
     * @memberof TableComponent
     */
    getControlsTemplate(rowIndex, columnIndex) {
        return this.getTableCells(rowIndex)[columnIndex]?.controlsTemplate;
    }
    /**
     * Returns the controls template models for a specific row and cell.
     *
     * @param {number} rowIndex
     * @param {number} columnIndex
     * @return {*}  {*}
     * @memberof TableComponent
     */
    getControlsTemplateModel(rowIndex, columnIndex) {
        return this.getTableCells(rowIndex)[columnIndex]?.getModels();
    }
    /**
     * Verifies if the table has rows.
     *
     * @return {*}  {boolean}
     * @memberof TableComponent
     */
    hasTableRows() {
        return this.tableRows.length > 0;
    }
    /**
     * Returns the dynamic table rows IDs.
     *
     * @return {*}  {string[]}
     * @memberof TableComponent
     */
    getDynamicTableRows() {
        return this.model?.Controls ? Object.keys(this.model.Controls) : [];
    }
    /**
     * Returns the dynamic table cells IDs.
     *
     * @param {number} rowIndex
     * @return {*}  {string[]}
     * @memberof TableComponent
     */
    getDynamicTableCells(rowIndex) {
        const dynamicTableRows = this.getDynamicTableRows();
        let tableCells = [];
        /* c8 ignore else */
        if (rowIndex < dynamicTableRows.length) {
            const rowId = dynamicTableRows[rowIndex];
            /* c8 ignore else */
            if (rowId) {
                const rowModel = this.wmService.core.getModel(rowId);
                /* c8 ignore else */
                if (rowModel?.Controls) {
                    tableCells = Object.keys(rowModel.Controls);
                }
            }
        }
        return tableCells;
    }
    /**
     * Load the dynamic cells.
     *
     * @memberof TableComponent
     */
    loadDynamicCells() {
        for (let r = 0; r < this.getDynamicTableRows().length; r++) {
            this.dynamicCellsModels.push([]);
            for (let c = 0; c < this.getDynamicTableCells(r).length; c++) {
                const cellId = this.getDynamicTableCellId(r, c);
                const cellModel = this.wmService.core.getModel(cellId);
                this.dynamicCellsModels[r].push(cellModel);
            }
        }
    }
    /**
     * Returns the controls object for a specific dynamic cell.
     *
     * @param {number} rowIndex
     * @param {number} columnIndex
     * @return {*}  {*}
     * @memberof TableComponent
     */
    getControlsIdsContainer(rowIndex, columnIndex) {
        let controlsIds = {};
        /* c8 ignore else */
        if (this.isDynamicCellAvailable(rowIndex, columnIndex)) {
            controlsIds = this.dynamicCellsModels[rowIndex][columnIndex].Controls;
        }
        return controlsIds;
    }
    /**
     * Returns the Id for the specified dynamic cell.
     *
     * @param {number} rowIndex
     * @param {number} columnIndex
     * @return {*}  {string}
     * @memberof TableComponent
     */
    getDynamicTableCellId(rowIndex, columnIndex) {
        let cellId = '';
        const dynamicCellsIds = this.getDynamicTableCells(rowIndex);
        /* c8 ignore else */
        if (dynamicCellsIds.length > columnIndex) {
            cellId = dynamicCellsIds[columnIndex];
        }
        return cellId;
    }
    /**
     * Verifies if the specified cell has dynamic controls.
     *
     * @param {number} rowIndex
     * @param {number} columnIndex
     * @return {*}  {boolean}
     * @memberof TableComponent
     */
    hasDynamicControls(rowIndex, columnIndex) {
        /* c8 ignore else */
        if (this.isDynamicCellAvailable(rowIndex, columnIndex)) {
            const controlsIds = this.dynamicCellsModels[rowIndex][columnIndex].Controls;
            /* c8 ignore else */
            if (controlsIds) {
                return Object.keys(controlsIds).length > 0;
            }
        }
        return false;
    }
    /**
     * Verifies if the specified cell exists.
     *
     * @param {number} rowIndex
     * @param {number} columnIndex
     * @return {*}  {boolean}
     * @memberof TableComponent
     */
    isDynamicCellAvailable(rowIndex, columnIndex) {
        return (this.dynamicCellsModels &&
            this.dynamicCellsModels.length > rowIndex &&
            this.dynamicCellsModels[rowIndex].length > columnIndex);
    }
    /**
     * Returns the model attributes object for the specified cell.
     *
     * @param {number} rowIndex
     * @param {number} columnIndex
     * @return {*}  {*}
     * @memberof TableComponent
     */
    getTableCellAttributes(rowIndex, columnIndex) {
        const cellAttrsObj = {};
        /* c8 ignore else */
        if (this.isDynamicCellAvailable(rowIndex, columnIndex)) {
            cellAttrsObj['Attributes'] =
                this.dynamicCellsModels[rowIndex][columnIndex].Attributes;
        }
        return cellAttrsObj;
    }
    /**
     * Returns the model text for the specified cell.
     *
     * @param {number} rowIndex
     * @param {number} columnIndex
     * @return {*}  {string}
     * @memberof TableComponent
     */
    getTableCellText(rowIndex, columnIndex) {
        let cellText = '';
        /* c8 ignore else */
        if (this.isDynamicCellAvailable(rowIndex, columnIndex)) {
            cellText = this.dynamicCellsModels[rowIndex][columnIndex]?.Text;
        }
        return cellText;
    }
};
TableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TableComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
TableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TableComponent, selector: "wm-table", inputs: { model: "model", width: "width" }, queries: [{ propertyName: "tableRowChildren", predicate: TableRowComponent }], usesInheritance: true, ngImport: i0, template: "<table *ngIf=\"model && visible\" [ngClass]=\"class\">\r\n    <ng-container *ngIf=\"hasTableRows()\">\r\n        <tr *ngFor=\"let row of tableRows let i=index\">\r\n            <td *ngFor=\"let col of getTableCells(i) let j=index\">\r\n                <ng-container\r\n                    *ngTemplateOutlet=\"getControlsTemplate(i, j); context:{$implicit: getControlsTemplateModel(i, j)}\">\r\n                </ng-container>\r\n            </td>\r\n        </tr>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"!hasTableRows()\">\r\n        <tr *ngFor=\"let row of getDynamicTableRows() let i=index\">\r\n            <td *ngFor=\"let col of getDynamicTableCells(i) let j=index\" wmHtmlControl\r\n                [model]=\"getTableCellAttributes(i, j)\">\r\n                <ng-container *ngIf=\"!hasDynamicControls(i, j)\">\r\n                    {{getTableCellText(i, j)}}\r\n                </ng-container>\r\n                <wm-custom-control-container *ngIf=\"hasDynamicControls(i, j)\"\r\n                    (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"getControlsIdsContainer(i, j)\">\r\n                </wm-custom-control-container>\r\n            </td>\r\n        </tr>\r\n    </ng-container>\r\n</table>\r\n", styles: ["::ng-deep wm-custom-control-container>*{display:inline-block}\n"], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i2.CustomControlContainerComponent, selector: "wm-custom-control-container", inputs: ["controls", "containerParent", "windowModel", "controlType"] }, { kind: "directive", type: HtmlControlDirective, selector: "[wmHtmlControl]", inputs: ["model"], outputs: ["OnClick"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
TableComponent = __decorate([
    dataTransfer(['tbl']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], TableComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TableComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-table', inputs: ['model'], template: "<table *ngIf=\"model && visible\" [ngClass]=\"class\">\r\n    <ng-container *ngIf=\"hasTableRows()\">\r\n        <tr *ngFor=\"let row of tableRows let i=index\">\r\n            <td *ngFor=\"let col of getTableCells(i) let j=index\">\r\n                <ng-container\r\n                    *ngTemplateOutlet=\"getControlsTemplate(i, j); context:{$implicit: getControlsTemplateModel(i, j)}\">\r\n                </ng-container>\r\n            </td>\r\n        </tr>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"!hasTableRows()\">\r\n        <tr *ngFor=\"let row of getDynamicTableRows() let i=index\">\r\n            <td *ngFor=\"let col of getDynamicTableCells(i) let j=index\" wmHtmlControl\r\n                [model]=\"getTableCellAttributes(i, j)\">\r\n                <ng-container *ngIf=\"!hasDynamicControls(i, j)\">\r\n                    {{getTableCellText(i, j)}}\r\n                </ng-container>\r\n                <wm-custom-control-container *ngIf=\"hasDynamicControls(i, j)\"\r\n                    (RemoveControl)=\"removeControlHandler($event)\" [controls]=\"getControlsIdsContainer(i, j)\">\r\n                </wm-custom-control-container>\r\n            </td>\r\n        </tr>\r\n    </ng-container>\r\n</table>\r\n", styles: ["::ng-deep wm-custom-control-container>*{display:inline-block}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { tableRowChildren: [{
                type: ContentChildren,
                args: [TableRowComponent]
            }], width: [{
                type: Input
            }] } });

/**
 * Angular Component for the Hyperlink Control.
 *
 * @export
 * @class HyperlinkComponent
 * @extends {ControlComponent}
 */
let HyperlinkComponent = class HyperlinkComponent extends ControlComponent {
    /**
     * Creates an instance of HyperlinkComponent.
     *
     * @param {ChangeDetectorRef} refChange
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @memberof HyperlinkComponent
     */
    constructor(refChange, render2, elem, webComponents, bringTopServ1) {
        super(refChange, render2, elem, webComponents, bringTopServ1);
        this.refChange = refChange;
        this.render2 = render2;
        this.elem = elem;
        this.bringTopServ1 = bringTopServ1;
        /**
         * Property to save the text value.
         *
         * @private
         * @memberof HyperlinkComponent
         */
        this.textInternal = '';
        /**
         * Property to save the navigateUrl value.
         *
         * @private
         * @memberof HyperlinkComponent
         */
        this.navigateUrlInternal = '';
        /**
         * Property to save the enabled value.
         *
         * @private
         * @memberof HyperlinkComponent
         */
        this.enabledInternal = true;
        /**
         * Property to save the cssClass value.
         *
         * @private
         * @memberof HyperlinkComponent
         */
        this.cssClassInternal = '';
        /**
         * NavigateToUrl event emitter.
         *
         * @type {EventEmitter<EventData>}
         * @memberof HyperlinkComponent
         */
        this.NavigateToUrl = new EventEmitter();
    }
    /**
     * Gets/sets the text property.
     *
     * @memberof HyperlinkComponent
     */
    set text(value) {
        this.textInternal = value;
    }
    get text() {
        return this.model?.Text ?? this.textInternal;
    }
    /**
     * Gets/sets the navigateUrl property.
     *
     * @memberof HyperlinkComponent
     */
    set navigateUrl(value) {
        this.navigateUrlInternal = value;
    }
    get navigateUrl() {
        return this.model?.NavigateUrl ?? this.navigateUrlInternal;
    }
    /**
     * Gets/sets the enabled property.
     *
     * @memberof HyperlinkComponent
     */
    set enabled(value) {
        this.enabledInternal = value;
    }
    get enabled() {
        return this.model?.Enabled ?? this.enabledInternal;
    }
    /**
     * Gets/sets the cssClass property.
     *
     * @memberof HyperlinkComponent
     */
    set cssClass(value) {
        this.cssClassInternal = value;
    }
    get cssClass() {
        return this.model?.CssClass ?? this.cssClassInternal;
    }
    /**
     * Gets the visible property.
     *
     * @readonly
     * @type {boolean}
     * @memberof HyperlinkComponent
     */
    get visible() {
        return this.model?.Visible != null ? this.model.Visible : true;
    }
    /**
     * Returns the attributes object from the model.
     *
     * @return {*}  {*}
     * @memberof HyperlinkComponent
     */
    getAttributesObject() {
        return {
            Attributes: this.model?.Attributes
        };
    }
    /**
     * Returns the css classes to be applied.
     *
     * @return {*}  {string}
     * @memberof HyperlinkComponent
     */
    getClasses() {
        let classes = '';
        classes = this.class ? `${this.class} ${this.cssClass}` : this.cssClass;
        /* c8 ignore else */
        if (!this.enabled) {
            return classes.concat(' disabled');
        }
        return classes;
    }
    /**
     * Handler for the click.
     *
     * @param {*} event
     * @memberof HyperlinkComponent
     */
    clickHandler(event) {
        /* c8 ignore else */
        if (this.enabled) {
            this.triggerNavigateToPage(event);
        }
    }
    /**
     * Triggers the NavigateToUrl emitter.
     *
     * @param {*} event
     * @memberof HyperlinkComponent
     */
    triggerNavigateToPage(event) {
        this.NavigateToUrl.emit(new EventData(event, this.id));
    }
};
HyperlinkComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HyperlinkComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
HyperlinkComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: HyperlinkComponent, selector: "wm-hyperlink", inputs: { model: "model", text: "text", navigateUrl: "navigateUrl", enabled: "enabled", cssClass: "cssClass" }, outputs: { NavigateToUrl: "NavigateToUrl" }, usesInheritance: true, ngImport: i0, template: "<a *ngIf=\"model && visible\" href=\"javascript:void(0)\" (click)=\"clickHandler($event)\" [ngClass]=\"getClasses()\"\r\n  [model]=\"getAttributesObject()\" wmHtmlControl wmControls [hostComponent]=\"this\">\r\n  {{text}}\r\n  <ng-content></ng-content>\r\n</a>\r\n", styles: ["a.disabled{cursor:text}\n"], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ControlsDirective, selector: "[wmControls]" }, { kind: "directive", type: HtmlControlDirective, selector: "[wmHtmlControl]", inputs: ["model"], outputs: ["OnClick"] }] });
__decorate([
    serverEvent('NavigateToUrl')
], HyperlinkComponent.prototype, "triggerNavigateToPage", null);
HyperlinkComponent = __decorate([
    dataTransfer(['hyprlnk']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], HyperlinkComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HyperlinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-hyperlink', inputs: ['model'], template: "<a *ngIf=\"model && visible\" href=\"javascript:void(0)\" (click)=\"clickHandler($event)\" [ngClass]=\"getClasses()\"\r\n  [model]=\"getAttributesObject()\" wmHtmlControl wmControls [hostComponent]=\"this\">\r\n  {{text}}\r\n  <ng-content></ng-content>\r\n</a>\r\n", styles: ["a.disabled{cursor:text}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { NavigateToUrl: [{
                type: Output
            }], text: [{
                type: Input
            }], navigateUrl: [{
                type: Input
            }], enabled: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], triggerNavigateToPage: [] } });

/**
 * ImageComponent
 *
 * @export
 * @class ImageComponent
 * @extends {ControlComponent}
 * @implements {OnInit}
 */
let ImageComponent = class ImageComponent extends ControlComponent {
    /**
     * Creates an instance of ImageComponent.
     * @param {WebMapService} serviceRef
     * @param {ChangeDetectorRef} changeDetectorRef
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @param {ContainerInteractionService} [containerInteraction]
     * @memberof ImageComponent
     */
    constructor(serviceRef, changeDetectorRef, render2, elem, webComponents, bringTopServ1, containerInteraction) {
        super(changeDetectorRef, render2, elem, webComponents, bringTopServ1, containerInteraction);
        this.serviceRef = serviceRef;
        this.changeDetectorRef = changeDetectorRef;
        this.render2 = render2;
        this.elem = elem;
        this.bringTopServ1 = bringTopServ1;
        this.containerInteraction = containerInteraction;
        /**
         * Click emitter
         *
         * @type {EventEmitter<EventData>}
         * @memberof ImageComponent
         */
        this.Click = new EventEmitter();
    }
    /**
     * Get the image url from the model
     *
     * @readonly
     * @type {(string | null)}
     * @memberof ImageComponent
     */
    get imageUrl() {
        return this.model?.ImageUrl;
    }
    /**
     * Get the cssStyle from the model
     *
     * @readonly
     * @type {(string | null)}
     * @memberof ImageComponent
     */
    get cssStyle() {
        return this.model?.CssStyle;
    }
    /**
     * Get the tabOrder
     * This is to override and avoid to give focus to image component because is not focucable by tab
     * But its needed the wmcontrols directive
     *
     * @readonly
     * @type {number}
     * @memberof ImageComponent
     */
    calculateTabOrder() {
        return -1;
    }
    /**
     * Apply styles to component based on model CssStyle properties
     *
     * @param {*} element
     * @memberof ImageComponent
     */
    getCssStyle(element) {
        const styles = this.cssStyle;
        /* c8 ignore else*/
        if (styles != null) {
            const properties = Object.keys(this.model.CssStyle);
            /* c8 ignore else*/
            if (properties.length > 0) {
                properties.forEach((key) => {
                    const value = styles[key];
                    this.render2.setStyle(element, key, value);
                });
            }
        }
    }
    /**
     * Click handler method
     *
     * @param {*} event
     * @memberof ImageComponent
     */
    clickHandler(event) {
        const eventData = new EventData(event, this.id);
        this.Click.emit(eventData);
    }
};
ImageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ImageComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: i2.ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ImageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ImageComponent, selector: "wm-image", usesInheritance: true, ngImport: i0, template: "<img #displayElement *ngIf=\"model && visible\" [ngClass]=\"class\" [ngStyle]=\"getCssStyle(displayElement)\"  src=\"{{imageUrl}}\" (click)=\"clickHandler($event)\"\r\n  wmControls  [hostComponent]=\"this\" />\r\n", styles: [""], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i2.ControlsDirective, selector: "[wmControls]" }] });
__decorate([
    serverEvent('Click')
], ImageComponent.prototype, "clickHandler", null);
ImageComponent = __decorate([
    dataTransfer(['img'])
], ImageComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ImageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-image', template: "<img #displayElement *ngIf=\"model && visible\" [ngClass]=\"class\" [ngStyle]=\"getCssStyle(displayElement)\"  src=\"{{imageUrl}}\" (click)=\"clickHandler($event)\"\r\n  wmControls  [hostComponent]=\"this\" />\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: i2.ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { clickHandler: [] } });

/***********************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 ***********************************************************************/
/**
 * AjaxInteractionService used to communicate any control with the AjaxComponents
 *
 * @export
 * @class AjaxInteractionService
 */
class AjaxInteractionService extends AjaxInteractionBaseService {
    constructor() {
        super(...arguments);
        /**
         * The click emitted subject
         *
         * @private
         * @type {Subject<EventData>}
         * @memberof AjaxInteractionService
         */
        this.clickEmitted = new Subject();
    }
    /**
     * Gets the notification for the click emit
     *
     * @readonly
     * @type {Observable<EventData>}
     * @memberof AjaxInteractionService
     */
    get ClickEmittedNotification() {
        return this.clickEmitted.asObservable();
    }
    /**
     * Notifies the click to the subscribed control
     *
     * @param {EventData} event
     * @memberof AjaxInteractionService
     */
    notifyClick(event) {
        this.clickEmitted.next(event);
    }
}
AjaxInteractionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AjaxInteractionService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
AjaxInteractionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AjaxInteractionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AjaxInteractionService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
/**
 * Angular directive to handle the OnClientClick script and the Click event when a button is clicked.
 *
 * @export
 * @class ClientClickDirective
 * @implements {OnInit}
 */
class ClientClickDirective {
    /**
     * Gets/sets the commandName property.
     *
     * @memberof ClientClickDirective
     */
    set commandName(value) {
        this.commandNameInternal = value;
    }
    get commandName() {
        return this.model.CommandName ?? this.commandNameInternal;
    }
    /**
     * Gets/sets the commandArgument property.
     *
     * @memberof ClientClickDirective
     */
    set commandArgument(value) {
        this.commandArgumentInternal = value;
    }
    get commandArgument() {
        return this.model.CommandArgument ?? this.commandArgumentInternal;
    }
    /**
     * Gets/sets the onClientClick property.
     *
     * @memberof ClientClickDirective
     */
    set onClientClick(value) {
        this.onClientClickInternal = value;
    }
    get onClientClick() {
        return this.model.OnClientClick ?? this.onClientClickInternal;
    }
    /**
     * Creates an instance of ClientClickDirective.
     *
     * @param {InternalEventHandlerService} internalEventHandler
     * @param {LinkButtonComponent} linkbuttonComponent
     * @param {ButtonComponent} buttonComponent
     * @memberof ClientClickDirective
     */
    constructor(internalEventHandler, linkbuttonComponent, buttonComponent) {
        this.internalEventHandler = internalEventHandler;
        this.linkbuttonComponent = linkbuttonComponent;
        this.buttonComponent = buttonComponent;
        /**
         * Property to save the onClientClick value.
         *
         * @private
         * @memberof ClientClickDirective
         */
        this.onClientClickInternal = '';
        /**
         * Property used to save the commandName value.
         *
         * @private
         * @memberof ClientClickDirective
         */
        this.commandNameInternal = '';
        /**
         * Property used to save the commandArgument value.
         *
         * @memberof ClientClickDirective
         */
        this.commandArgumentInternal = '';
    }
    /**
     * OnInit lifecycle hook.
     *
     * @memberof ClientClickDirective
     */
    ngOnInit() {
        this.setButtonServerClick(false);
        this.setControlOutputEvents(false);
    }
    /**
     * Enables/disables the serverEvent for the button's click.
     *
     * @param {boolean} clickEnabled
     * @memberof ClientClickDirective
     */
    setButtonServerClick(clickEnabled) {
        /* c8 ignore else */
        if (this.model?.events?.Click != null) {
            this.model.events.Click = clickEnabled;
        }
    }
    /**
     * Enables/disables the emitter for the button's click.
     *
     * @param {boolean} clickOutputEnabled
     * @memberof ClientClickDirective
     */
    setControlOutputEvents(clickOutputEnabled) {
        /* c8 ignore else*/
        if (this.linkbuttonComponent) {
            this.linkbuttonComponent.isClickStopped = !clickOutputEnabled;
        }
        else if (this.buttonComponent) {
            this.buttonComponent.isClickStopped = !clickOutputEnabled;
        }
    }
    /**
     * Listener for the click event.
     *
     * @param {*} event
     * @memberof ClientClickDirective
     */
    clickListener(event) {
        this.onClientClickHandler(event);
    }
    /**
     * Handles the OnClientClick.
     * Validates the scenarios to execute the script correctly and triggers the click if necessary.
     *
     * @param {*} event
     * @return {*}  {boolean}
     * @memberof ClientClickDirective
     */
    onClientClickHandler(event) {
        const functionCompleteName = this.getOnClientClickFunctionCompleteName();
        const functionName = this.getOnClientClickFunctionName(functionCompleteName);
        let response;
        if (functionCompleteName) {
            if (this.eventsContext && this.eventsContext[functionName]) {
                const eventFunction = this.getClientClickFunction(event);
                response = eventFunction.call(this);
            }
            else {
                response = this.executeAsJSCode(this.onClientClick);
            }
        }
        else {
            this.executeAsJSCode(this.onClientClick);
        }
        /* c8 ignore else */
        if ((this.onClientClickHasReturn() && response) ||
            !this.onClientClickHasReturn()) {
            this.triggerClickMechanism(event);
        }
        return true;
    }
    /**
     * Returns the arrow function to be called and execute the function in the right context.
     *
     * @param {*} event
     * @return {*}  {*}
     * @memberof ClientClickDirective
     */
    getClientClickFunction(event) {
        const functionCompleteName = this.getOnClientClickFunctionCompleteName();
        const functionName = this.getOnClientClickFunctionName(functionCompleteName);
        /* c8 ignore start */
        return () => {
            let params = this.getFunctionParams(functionCompleteName);
            params = this.setThisContext(params, event.target);
            return this.eventsContext[functionName].call(this.eventsContext, ...params);
        }; /* c8 ignore stop */
    }
    /**
     * Triggers the click mechanism.
     *
     * @param {*} event
     * @memberof ClientClickDirective
     */
    triggerClickMechanism(event) {
        this.setButtonServerClick(true);
        this.setControlOutputEvents(true);
        this.triggerClick(event);
        this.setButtonServerClick(false);
        this.setControlOutputEvents(false);
        this.triggerClickedInternal();
    }
    /**
     * Runs JS code that is not calling an external function.
     * Example: `console.log(''); return true;`
     *
     * @param {string} jsCode
     * @return {*}  {boolean}
     * @memberof ClientClickDirective
     */
    executeAsJSCode(jsCode) {
        /* c8 ignore else */
        if (this.eventsContext) {
            return new Function(jsCode).call(this.eventsContext);
        }
        return true;
    }
    /**
     * Returns the complete function name from JS code.
     * Example:
     * `'return function()'` => `'function()'`.
     *
     * @return {*}  {string}
     * @memberof ClientClickDirective
     */
    getOnClientClickFunctionCompleteName() {
        let funcName = '';
        /* c8 ignore else */
        if (this.onClientClick) {
            if (this.onClientClickHasReturn()) {
                const init = this.onClientClick.toLowerCase().indexOf('return ') + 6;
                const end = this.onClientClick.indexOf(')') + 2;
                funcName = this.onClientClick.substring(init, end).trim();
            }
            else if (
            /* c8 ignore else */
            !this.onClientClickHasReturn() &&
                this.onClientClick.includes('(') &&
                this.onClientClick.includes(')')) {
                return this.onClientClick;
            }
        }
        return funcName;
    }
    /**
     * Returns the function name without parentheses.
     *
     * @param {string} functionCompleteName
     * @return {*}  {string}
     * @memberof ClientClickDirective
     */
    getOnClientClickFunctionName(functionCompleteName) {
        return functionCompleteName
            .slice(0, functionCompleteName.indexOf('('))
            .trim();
    }
    /**
     * Validates if the onClientClick function has a 'return'.
     *
     * @return {*}  {boolean}
     * @memberof ClientClickDirective
     */
    onClientClickHasReturn() {
        return this.onClientClick?.trim().toLowerCase().includes('return');
    }
    /**
     * Returns a params collection based on the function name.
     *
     * @param {string} func
     * @return {*}  {string[]}
     * @memberof ClientClickDirective
     */
    getFunctionParams(func) {
        let params = [];
        /* c8 ignore else */
        if (func.includes('(') && func.includes(')')) {
            params = func
                .slice(func.indexOf('(') + 1, func.indexOf(')'))
                .split(',')
                .map((param) => {
                return param.trim().replace(/'/, '');
            });
            return params;
        }
        return params;
    }
    /**
     * Changes 'this' to the correct context if it is defined in the function params.
     *
     * @param {string[]} params
     * @param {*} context
     * @return {*}  {any[]}
     * @memberof ClientClickDirective
     */
    setThisContext(params, context) {
        return params.map((param) => {
            /* c8 ignore else */
            if (param === 'this') {
                return context;
            }
            return param;
        });
    }
    /**
     * Triggers the internal Click event mechanism.
     * This mechanism allows the Button to trigger the DataList's OnItemCommand and the Grid's OnRowCommand events.
     *
     * @memberof ClientClickDirective
     */
    triggerClickedInternal() {
        const clientClickArgs = {
            CommandName: this.commandName,
            CommandArgument: this.commandArgument,
            CommandSource: this.model
        };
        this.internalEventHandler.onButtonClickEmit({
            clientClickArgs,
            id: this.model.id
        });
    }
    /**
     * Triggers the Click depending on the host component (Button/LinkButton).
     *
     * @param {*} event
     * @memberof ClientClickDirective
     */
    triggerClick(event) {
        /* c8 ignore else */
        if (this.linkbuttonComponent) {
            this.linkbuttonComponent.click(event);
        }
        else if (this.buttonComponent) {
            this.buttonComponent.click(event);
        }
    }
}
ClientClickDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ClientClickDirective, deps: [{ token: InternalEventHandlerService }, { token: LinkButtonComponent, optional: true }, { token: i2.ButtonComponent, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
ClientClickDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: ClientClickDirective, selector: "[wmClientClick]", inputs: { model: "model", eventsContext: "eventsContext", commandName: "commandName", commandArgument: "commandArgument", onClientClick: "onClientClick" }, host: { listeners: { "click": "clickListener($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ClientClickDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[wmClientClick]'
                }]
        }], ctorParameters: function () { return [{ type: InternalEventHandlerService }, { type: LinkButtonComponent, decorators: [{
                    type: Optional
                }] }, { type: i2.ButtonComponent, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { model: [{
                type: Input
            }], eventsContext: [{
                type: Input
            }], commandName: [{
                type: Input
            }], commandArgument: [{
                type: Input
            }], onClientClick: [{
                type: Input
            }], clickListener: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

/**
 * Angular Component for the AspTextBox Control.
 *
 * @export
 * @class AspTextBoxComponentComponent
 * @extends {TextBoxComponent}
 * <example-url>https://webforms-livedemos.azurewebsites.net/assets/live-demos/asp-text-box/asp_text_box.html</example-url>
 */
let AspTextBoxComponentComponent = class AspTextBoxComponentComponent extends TextBoxComponent {
    constructor(wmService, changeDetectorRef, render2, elem, webComponentsServ, baseValidator, bringTop, containerInteractionServ) {
        super(wmService, changeDetectorRef, render2, elem, webComponentsServ, baseValidator, bringTop, containerInteractionServ);
        this.wmService = wmService;
        this.changeDetectorRef = changeDetectorRef;
        this.render2 = render2;
        this.elem = elem;
        this.baseValidator = baseValidator;
        this.containerInteractionServ = containerInteractionServ;
        /**
         * This is to validate the validator service execute only once when the control loads the text property
         * from the model
         *
         * @memberof TextBoxComponent
         */
        this.textValidatedFirstTime = false;
    }
    /**
     * OnInit method of AspTextBoxComponent
     *
     * @memberof AspTextBoxComponentComponent
     */
    ngOnInit() {
        // This is for the cases when the change of the text is coming from the Backend, and then, we need
        // to check and execute the validate of the validation service
        /* c8 ignore start */
        this.syncComplete = this.wmService.core
            .getEvent()
            .subscribe('SyncCompleted', () => {
            if (this.baseValidator &&
                this.textValidatedFirstTime &&
                this.text.length > 0) {
                this.baseValidator.validate(this.id, this.text);
            }
            // This should happen every time a change is coming from server
            // even is text is empty
            this.detectChanges();
        }); /* c8 ignore stop */
    }
    /**
     * After View Checked of AsPTextBoxComponent
     *
     * @memberof AspTextBoxComponentComponent
     */
    ngAfterViewChecked() {
        if (!this.textValidatedFirstTime &&
            this.text.length > 0 &&
            this.baseValidator) {
            this.baseValidator.validate(this.id, this.text);
        }
        this.textValidatedFirstTime = true;
    }
    /**
     * OnDestroy of AspTextBoxComponent
     *
     * @memberof AspTextBoxComponentComponent
     */
    ngOnDestroy() {
        /* c8 ignore next 3 */
        if (this.syncComplete) {
            this.wmService.core.getEvent().unSubscribe(this.syncComplete);
        }
    }
    /**
     * Detect changes of the AspTextBox
     *
     * @memberof AspTextBoxComponentComponent
     */
    detectChanges() {
        super.detectChanges();
        this.changeDetectorRef.detectChanges();
    }
    /**
     * Gets/sets the columns property.
     *
     * @readonly
     * @type {number}
     * @memberof TextBoxComponent
     */
    get cols() {
        return this.model.Columns ?? null;
    }
    set cols(value) {
        this.model.Columns = value;
    }
    /**
     * Gets/sets the rows property.
     *
     * @readonly
     * @type {number}
     * @memberof TextBoxComponent
     */
    get rows() {
        return this.model.Rows ?? null;
    }
    set rows(value) {
        this.model.Rows = value;
    }
    /**
     * Gets the CssStyle from the model
     *
     * @readonly
     * @type {*}
     * @memberof AspTextBoxComponentComponent
     */
    get cssStyle() {
        return this.model?.CssStyle;
    }
    /**
     * lost focus validation utilized in WebForms.
     */
    changeValidationHandler() {
        /* c8 ignore else */
        if (this.baseValidator != undefined) {
            this.baseValidator.validate(this.id, this.text);
        }
    }
    /**
     * This is to override the display to prevent the controlsDirective
     * HostBinding
     *
     * @return {*}  {string}
     * @memberof AspTextBoxComponentComponent
     */
    getStyleDisplay() {
        return this.cssStyle?.display
            ? this.cssStyle.display
            : super.getStyleDisplay();
    }
    /**
     * Override setMyStyle to use cssStyle property
     *
     * @return {*}  {*}
     * @memberof AspTextBoxComponentComponent
     */
    setMyStyle() {
        const setMyStyle = super.setMyStyle();
        const style = setMyStyle ? setMyStyle : {};
        /* c8 ignore else */
        if (this.cssStyle != null) {
            const cssStyleProps = Object.keys(this.cssStyle);
            cssStyleProps.forEach((key) => {
                style[key] = this.cssStyle[key];
            });
        }
        return style;
    }
};
AspTextBoxComponentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AspTextBoxComponentComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i2.BaseValidatorService, optional: true }, { token: i3.BringTopService, optional: true }, { token: i2.ContainerInteractionService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
AspTextBoxComponentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: AspTextBoxComponentComponent, selector: "wm-asp-textbox", inputs: { model: "model" }, usesInheritance: true, ngImport: i0, template: "<div>\r\n  <input #displayElement *ngIf=\"model && !multiline\" wmControls kendoTextBox [type]=\"getTextBoxType()\"\r\n    class=\"k-form-field\" [(ngModel)]=\"text\" [readonly]=\"readOnly\" [disabled]=\"disabled\"\r\n    [ngClass]=\"class\" [maxlength]=\"maxLength\" [ngStyle]=\"setMyStyle()\" (click)=\"click($event)\" [hostComponent]=\"this\"\r\n    (change)=\"changeValidationHandler()\"/>\r\n  <textarea *ngIf=\"model && multiline\" [ngClass]=\"class\" [ngStyle]=\"setMyStyle()\" #displayElement wmControls\r\n    [(ngModel)]=\"text\" [readonly]=\"readOnly\" [disabled]=\"disabled\" [maxlength]=\"maxLength\" [cols]=\"cols\" [rows]=\"rows\"\r\n    (click)=\"click($event)\" [hostComponent]=\"this\" (keydown)=\"keyDownHandler($event)\"\r\n    (change)=\"changeValidationHandler()\"></textarea>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i5.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i6$1.TextBoxDirective, selector: "input[kendoTextBox]", inputs: ["value"] }, { kind: "directive", type: i2.ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('Columns')
], AspTextBoxComponentComponent.prototype, "cols", null);
__decorate([
    MarkForCheck(),
    NotifyChange('Rows')
], AspTextBoxComponentComponent.prototype, "rows", null);
AspTextBoxComponentComponent = __decorate([
    dataTransfer(['txtBx'])
], AspTextBoxComponentComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AspTextBoxComponentComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-asp-textbox', inputs: ['model'], template: "<div>\r\n  <input #displayElement *ngIf=\"model && !multiline\" wmControls kendoTextBox [type]=\"getTextBoxType()\"\r\n    class=\"k-form-field\" [(ngModel)]=\"text\" [readonly]=\"readOnly\" [disabled]=\"disabled\"\r\n    [ngClass]=\"class\" [maxlength]=\"maxLength\" [ngStyle]=\"setMyStyle()\" (click)=\"click($event)\" [hostComponent]=\"this\"\r\n    (change)=\"changeValidationHandler()\"/>\r\n  <textarea *ngIf=\"model && multiline\" [ngClass]=\"class\" [ngStyle]=\"setMyStyle()\" #displayElement wmControls\r\n    [(ngModel)]=\"text\" [readonly]=\"readOnly\" [disabled]=\"disabled\" [maxlength]=\"maxLength\" [cols]=\"cols\" [rows]=\"rows\"\r\n    (click)=\"click($event)\" [hostComponent]=\"this\" (keydown)=\"keyDownHandler($event)\"\r\n    (change)=\"changeValidationHandler()\"></textarea>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i2.BaseValidatorService, decorators: [{
                    type: Optional
                }] }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: i2.ContainerInteractionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { cols: [], rows: [] } });

/**
 * Validation data type
 */
var ValidationDataType;
(function (ValidationDataType) {
    /// <summary>
    /// The currency.
    /// </summary>
    ValidationDataType[ValidationDataType["Currency"] = 4] = "Currency";
    /// <summary>
    /// The date.
    /// </summary>
    ValidationDataType[ValidationDataType["Date"] = 3] = "Date";
    /// <summary>
    /// The double.
    /// </summary>
    ValidationDataType[ValidationDataType["Double"] = 2] = "Double";
    /// <summary>
    /// The integer.
    /// </summary>
    ValidationDataType[ValidationDataType["Integer"] = 1] = "Integer";
    /// <summary>
    /// The string.
    /// </summary>
    ValidationDataType[ValidationDataType["String"] = 0] = "String";
})(ValidationDataType || (ValidationDataType = {}));

/**
 * Angular Component for the RangeValidator Control.
 *
 * @export
 * @class RangeValidatorComponent
 * @extends {BaseValidatorComponent}
 */
let RangeValidatorComponent = class RangeValidatorComponent extends BaseValidatorComponent {
    /**
     * Creates an instance of RangeValidatorComponent.
     *
     * @param {WebMapService} wmService
     * @param {ChangeDetectorRef} refChange
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @memberof RangeValidatorComponent
     */
    constructor(wmService, refChange, render2, elem, webComponents, validatorService, bringTopServ1) {
        super(refChange, render2, elem, webComponents, validatorService, bringTopServ1);
        this.wmService = wmService;
        this.validationSuccessInternal = true;
    }
    /**
     * Gets minimun value.
     */
    /* c8 ignore next 3 */
    get minimumValue() {
        return this.model.MinimumValue;
    }
    /**
     * Sets minimun value.
     */
    /* c8 ignore next 3 */
    set minimumValue(value) {
        this.model.MinimumValue = value;
    }
    /**
     * Gets minimun value.
     */
    /* c8 ignore next 3 */
    get maximumValue() {
        return this.model.MaximumValue;
    }
    /**
     * Sets minimun value.
     */
    /* c8 ignore next 3 */
    set maximumValue(value) {
        this.model.MaximumValue = value;
    }
    /**
     * Gets type.
     */
    /* c8 ignore next 3 */
    get type() {
        return this.model.Type;
    }
    /**
     * Sets type.
     */
    /* c8 ignore next 3 */
    set type(value) {
        this.model.Type = value;
    }
    /**
     * Validates control.
     * @param controlToValidate The control to validate.
     * @param validationExpression The current expression.
     * @returns true if control passes the validation
     */
    validateControl(controlToValidate, validationExpression) {
        const target = this.convertToCurrentType(validationExpression);
        const minimun = this.convertToCurrentType(this.minimumValue);
        const maximum = this.convertToCurrentType(this.maximumValue);
        if (this.IsValidValue(target) &&
            this.IsValidValue(minimun) &&
            this.IsValidValue(maximum) &&
            this.between(target, minimun, maximum)) {
            this.hidden = true;
            this.validationSuccessInternal = true;
        }
        else {
            this.hidden = false;
            this.validationSuccessInternal = false;
        }
        return this.hidden;
    }
    /**
     * Determines whether value is valid according the data type.
     * @param value The value to validate.
     * @returns true if valid value.
     */
    IsValidValue(value) {
        switch (this.type) {
            case ValidationDataType.Currency:
            case ValidationDataType.Double:
            case ValidationDataType.Integer:
                return !isNaN(value);
            default:
                return value != undefined;
        }
    }
    /**
     * Between range the current target.
     * @param target The target value to validate.
     * @param min The minimun value.
     * @param max The maximun value.
     * @returns true if between.
     */
    between(target, min, max) {
        return target >= min && target <= max;
    }
    /**
     * Converts the current value to current type.
     * @param value The value to convert.
     * @returns  The converted value.
     */
    convertToCurrentType(value) {
        switch (this.type) {
            case ValidationDataType.Currency:
            case ValidationDataType.Double:
                return parseFloat(value);
            case ValidationDataType.Integer:
                return parseInt(value);
            case ValidationDataType.Date:
                return new Date(value);
            default:
                return value;
        }
    }
};
RangeValidatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RangeValidatorComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i2.BaseValidatorService }, { token: i3.BringTopService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
RangeValidatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: RangeValidatorComponent, selector: "wm-range-validator", inputs: { model: "model" }, providers: [
        {
            provide: BaseValidatorService,
            useExisting: WebFormsBaseValidatorService
        }
    ], usesInheritance: true, ngImport: i0, template: "<span [hidden]=\"hidden\" [ngClass]=\"class\">{{displayMessage()}}</span>", styles: [""], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
RangeValidatorComponent = __decorate([
    dataTransfer(['rngval'])
], RangeValidatorComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RangeValidatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'wm-range-validator', inputs: ['model'], providers: [
                        {
                            provide: BaseValidatorService,
                            useExisting: WebFormsBaseValidatorService
                        }
                    ], template: "<span [hidden]=\"hidden\" [ngClass]=\"class\">{{displayMessage()}}</span>" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i2.BaseValidatorService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }]; } });

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
class WebFormsModule {
    constructor(webMapSevice) {
        this.webMapSevice = webMapSevice;
        this.webMapSevice.config.wmSourceVersion =
            WMConstants.sourceVersionWebForms;
    }
}
WebFormsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebFormsModule, deps: [{ token: i1.WebMapService }], target: i0.ɵɵFactoryTarget.NgModule });
WebFormsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: WebFormsModule, bootstrap: [AlinkComponent,
        AspPanelComponent,
        GridViewComponent,
        PageComponent,
        MasterPageComponent,
        RegularExpressionValidatorComponent,
        RequiredFieldValidatorComponent,
        BaseValidatorComponent,
        ValidationSummaryComponent,
        LinkButtonComponent,
        CompareValidatorComponent,
        CustomValidatorComponent,
        DataListComponent,
        DropdownListComponent,
        GridViewColumnsComponent,
        BoundFieldComponent,
        HyperlinkFieldComponent,
        DataControlFieldComponent,
        TemplateFieldComponent,
        TableComponent,
        TableRowComponent,
        TableCellComponent,
        HyperlinkComponent,
        ImageComponent,
        AspTextBoxComponentComponent,
        RangeValidatorComponent], declarations: [AlinkComponent,
        AspPanelComponent,
        GridViewComponent,
        PageComponent,
        MasterPageComponent,
        RegularExpressionValidatorComponent,
        RequiredFieldValidatorComponent,
        BaseValidatorComponent,
        ValidationSummaryComponent,
        LinkButtonComponent,
        HtmlControlDirective,
        CompareValidatorComponent,
        CustomValidatorComponent,
        DataListComponent,
        DropdownListComponent,
        GridViewColumnsComponent,
        BoundFieldComponent,
        HyperlinkFieldComponent,
        DataControlFieldComponent,
        TemplateFieldComponent,
        TableComponent,
        TableRowComponent,
        TableCellComponent,
        HyperlinkComponent,
        ImageComponent,
        ClientClickDirective,
        AspTextBoxComponentComponent,
        RangeValidatorComponent], imports: [BrowserModule,
        WebMapModule,
        LayoutModule,
        BrowserAnimationsModule,
        CommonModule,
        GridModule,
        FormsModule,
        ReactiveFormsModule,
        InputsModule,
        TreeViewModule,
        WebMapKendoModule,
        ToolBarModule,
        MenusModule,
        ButtonsModule,
        DropDownsModule,
        PopupModule,
        ExcelModule,
        PDFModule,
        MenuModule,
        DropDownListModule,
        TooltipModule,
        BaseComponentsModule,
        LabelModule], exports: [AlinkComponent,
        AspPanelComponent,
        GridViewComponent,
        PageComponent,
        MasterPageComponent,
        RegularExpressionValidatorComponent,
        RequiredFieldValidatorComponent,
        BaseValidatorComponent,
        ValidationSummaryComponent,
        LinkButtonComponent,
        HtmlControlDirective,
        CompareValidatorComponent,
        CustomValidatorComponent,
        DataListComponent,
        DropdownListComponent,
        GridViewColumnsComponent,
        BoundFieldComponent,
        HyperlinkFieldComponent,
        DataControlFieldComponent,
        TemplateFieldComponent,
        TableComponent,
        TableRowComponent,
        TableCellComponent,
        HyperlinkComponent,
        ImageComponent,
        ClientClickDirective,
        AspTextBoxComponentComponent,
        RangeValidatorComponent] });
WebFormsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebFormsModule, providers: [
        { provide: BaseValidatorService, useClass: WebFormsBaseValidatorService },
        { provide: AjaxInteractionBaseService, useClass: AjaxInteractionService },
        { provide: MainTabOrderService, useClass: WebFormsMainTabOrderService },
        InternalEventHandlerService
    ], imports: [BrowserModule,
        WebMapModule,
        LayoutModule,
        BrowserAnimationsModule,
        CommonModule,
        GridModule,
        FormsModule,
        ReactiveFormsModule,
        InputsModule,
        TreeViewModule,
        WebMapKendoModule,
        ToolBarModule,
        MenusModule,
        ButtonsModule,
        DropDownsModule,
        PopupModule,
        ExcelModule,
        PDFModule,
        MenuModule,
        DropDownListModule,
        TooltipModule,
        BaseComponentsModule,
        LabelModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: WebFormsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AlinkComponent,
                        AspPanelComponent,
                        GridViewComponent,
                        PageComponent,
                        MasterPageComponent,
                        RegularExpressionValidatorComponent,
                        RequiredFieldValidatorComponent,
                        BaseValidatorComponent,
                        ValidationSummaryComponent,
                        LinkButtonComponent,
                        HtmlControlDirective,
                        CompareValidatorComponent,
                        CustomValidatorComponent,
                        DataListComponent,
                        DropdownListComponent,
                        GridViewColumnsComponent,
                        BoundFieldComponent,
                        HyperlinkFieldComponent,
                        DataControlFieldComponent,
                        TemplateFieldComponent,
                        TableComponent,
                        TableRowComponent,
                        TableCellComponent,
                        HyperlinkComponent,
                        ImageComponent,
                        ClientClickDirective,
                        AspTextBoxComponentComponent,
                        RangeValidatorComponent
                    ],
                    imports: [
                        BrowserModule,
                        WebMapModule,
                        LayoutModule,
                        BrowserAnimationsModule,
                        CommonModule,
                        GridModule,
                        FormsModule,
                        ReactiveFormsModule,
                        InputsModule,
                        TreeViewModule,
                        WebMapKendoModule,
                        ToolBarModule,
                        MenusModule,
                        ButtonsModule,
                        DropDownsModule,
                        PopupModule,
                        ExcelModule,
                        PDFModule,
                        MenuModule,
                        DropDownListModule,
                        TooltipModule,
                        BaseComponentsModule,
                        LabelModule
                    ],
                    exports: [
                        AlinkComponent,
                        AspPanelComponent,
                        GridViewComponent,
                        PageComponent,
                        MasterPageComponent,
                        RegularExpressionValidatorComponent,
                        RequiredFieldValidatorComponent,
                        BaseValidatorComponent,
                        ValidationSummaryComponent,
                        LinkButtonComponent,
                        HtmlControlDirective,
                        CompareValidatorComponent,
                        CustomValidatorComponent,
                        DataListComponent,
                        DropdownListComponent,
                        GridViewColumnsComponent,
                        BoundFieldComponent,
                        HyperlinkFieldComponent,
                        DataControlFieldComponent,
                        TemplateFieldComponent,
                        TableComponent,
                        TableRowComponent,
                        TableCellComponent,
                        HyperlinkComponent,
                        ImageComponent,
                        ClientClickDirective,
                        AspTextBoxComponentComponent,
                        RangeValidatorComponent
                    ],
                    bootstrap: [
                        AlinkComponent,
                        AspPanelComponent,
                        GridViewComponent,
                        PageComponent,
                        MasterPageComponent,
                        RegularExpressionValidatorComponent,
                        RequiredFieldValidatorComponent,
                        BaseValidatorComponent,
                        ValidationSummaryComponent,
                        LinkButtonComponent,
                        CompareValidatorComponent,
                        CustomValidatorComponent,
                        DataListComponent,
                        DropdownListComponent,
                        GridViewColumnsComponent,
                        BoundFieldComponent,
                        HyperlinkFieldComponent,
                        DataControlFieldComponent,
                        TemplateFieldComponent,
                        TableComponent,
                        TableRowComponent,
                        TableCellComponent,
                        HyperlinkComponent,
                        ImageComponent,
                        AspTextBoxComponentComponent,
                        RangeValidatorComponent
                    ],
                    providers: [
                        { provide: BaseValidatorService, useClass: WebFormsBaseValidatorService },
                        { provide: AjaxInteractionBaseService, useClass: AjaxInteractionService },
                        { provide: MainTabOrderService, useClass: WebFormsMainTabOrderService },
                        InternalEventHandlerService
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }]; } });

/**
 * Angular Component for AjaxCalendarComponent Control.
 *
 * @export
 * @class AjaxCalendarComponent
 * @extends {ControlComponent}
 */
let AjaxCalendarComponent = class AjaxCalendarComponent extends ControlComponent {
    /**
     * Creates an instance of AjaxCalendarComponent.
     * @param {WebMapService} serviceRef
     * @param {ChangeDetectorRef} changeDetectorRef
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @param {ContainerInteractionService} [containerInteraction]
     * @memberof AjaxCalendarComponent
     */
    constructor(serviceRef, changeDetectorRef, render2, elem, webComponents, bringTopServ1, containerInteraction, ajaxCalendarService) {
        super(changeDetectorRef, render2, elem, webComponents, bringTopServ1, containerInteraction);
        this.serviceRef = serviceRef;
        this.changeDetectorRef = changeDetectorRef;
        this.render2 = render2;
        this.elem = elem;
        this.bringTopServ1 = bringTopServ1;
        this.containerInteraction = containerInteraction;
        this.ajaxCalendarService = ajaxCalendarService;
        /**
         * ValueChanged event emitter.
         * @type {EventEmitter<EventData>}
         * @memberof DropdownListComponent
         */
        this.ValueChanged = new EventEmitter();
        /**
         * default valiable to set calendarType property
         *
         * @type {string}
         * @memberof AjaxCalendarComponent
         */
        this.calendarTypeInternal = 'classic';
        /**
         * variable to set default name of targetControlID property
         *
         * @type {string}
         * @memberof AjaxCalendarComponent
         */
        this.targetControlIDInternal = '';
        /**
         * variable to set default name of popupButtonID property
         *
         * @type {string}
         * @memberof AjaxCalendarComponent
         */
        this.popupButtonIDInternal = '';
        /**
         * default valiable to set selectedDate property
         *
         * @type {string}
         * @memberof AjaxCalendarComponent
         */
        this.selectedDateInternal = '';
    }
    /**
     * Initialize component
     *
     * @memberof AjaxCalendarComponent
     */
    ngOnInit() {
        super.ngOnInit();
        /* c8 ignore start */
        this.ajaxCalendarService?.ClickEmittedNotification.subscribe((evt) => {
            if (evt.Id === this.popupButtonID) {
                this.toggle(evt);
            }
        }); /* c8 ignore stop */
    }
    /**
     * After Initialize view component
     *
     * @memberof AjaxCalendarComponent
     */
    ngAfterViewInit() {
        super.ngAfterViewInit();
        /* c8 ignore next 3 */
        if (this.datePicker != undefined) {
            this.datePicker.calendarType = this.calendarType;
        }
    }
    /**
     * Get PopupButtonID Name of control  which will show calendar
     *
     * @readonly
     * @type {string}
     * @memberof AjaxCalendarComponent
     */
    get popupButtonID() {
        return this.model?.PopupButtonID ?? this.popupButtonIDInternal;
    }
    /**
     * Get TargetControl ID Name which calendar will assign selected value
     *
     * @readonly
     * @type {string}
     * @memberof AjaxCalendarComponent
     */
    get targetControlID() {
        return this.model?.TargetControlID ?? this.targetControlIDInternal;
    }
    /**
     * Optional input parameter to specify calendarType property setter and getter.
     *
     * @memberof AjaxCalendarComponent
     */
    set calendarType(calendarType) {
        this.calendarTypeInternal = calendarType;
    }
    get calendarType() {
        return this.calendarTypeInternal;
    }
    /**
     * store string selected date from calendar, property setter and getter.
     *
     * @memberof AjaxCalendarComponent
     */
    set selectedDate(selectedDate) {
        this.selectedDateInternal = selectedDate;
    }
    get selectedDate() {
        return this.selectedDateInternal;
    }
    /**
     * Notify value change on server side
     *
     * @memberof AjaxCalendarComponent
     */
    set value(value) {
        const tempDate = DatesUtils.normalizeDateFromClient(value);
        this.model.Value = tempDate.toISOString();
    }
    /**
     * Return date for set in calendar
     *
     * @readonly
     * @type {Date}
     * @memberof AjaxCalendarComponent
     */
    get value() {
        return this.model.Value
            ? DatesUtils.normalizeDateFromServer(new Date(this.model.Value))
            : undefined;
    }
    /**
     * Return format to show date in calendar
     *
     * @memberof AjaxCalendarComponent
     */
    get format() {
        return this.model?.Format ?? 'd';
    }
    /**
     *Get the tabOrder
     * This is to override and avoid to give focus to image component because is not focucable by tab
     * But its needed the wmcntrols directive
     * @readonly
     * @type {number}
     * @memberof AjaxCalendarComponent
     */
    calculateTabOrder() {
        return -1;
    }
    /**
     * Trigger the ValueChanged Event on server side
     *
     * @param {Date} selectedValue
     * @memberof AjaxCalendarComponent
     */
    onChange(event) {
        this.selectedDate = event.toLocaleString();
        this.value = event;
        this.ValueChanged.emit(new EventData(event, this.id));
    }
    /**
     * Method allows to show or hide calendar in datepicker programmatically
     *
     * @memberof AjaxCalendarComponent
     */
    toggle(event) {
        event.event.stopPropagation();
        event.event.preventDefault();
        this.datePicker.toggle();
    }
    /**
     * Close the datepicker after the use click outside the popup
     * @param event
     */
    documentClick(event) {
        if (!this.contains(event.target)) {
            this.datePicker.toggle(false);
        }
    }
    /**
     * Check if target element is inside the container of the popup
     * @param target
     * @returns
     */
    contains(target) {
        return this.datePicker.popupRef?.popupElement.contains(target);
    }
};
AjaxCalendarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AjaxCalendarComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: i2.ContainerInteractionService, optional: true }, { token: i2.AjaxInteractionBaseService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
AjaxCalendarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: AjaxCalendarComponent, selector: "wm-ajax-calendar", inputs: { model: "model", calendarType: "calendarType" }, outputs: { ValueChanged: "ValueChanged" }, host: { listeners: { "document:click": "documentClick($event)" } }, viewQueries: [{ propertyName: "datePicker", first: true, predicate: ["datepicker"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\" class=\"datePickerWrapper\">\r\n    <kendo-datepicker #datepicker *ngIf=\"model && visible\"\r\n    calendarType=\"calendarType\" [value]=\"value\" (valueChange)=\"onChange($event)\" [ngClass]=\"class\" [format]=\"format\" \r\n    wmControls [hostComponent]=\"this\">\r\n    </kendo-datepicker>\r\n</div>\r\n", styles: [".k-datepicker{position:absolute;opacity:0;height:0;max-height:0;width:0;max-width:0;padding:0;border:0;margin:0}.k-input,.datePickerWrapper{opacity:0;height:0;max-height:0;width:0;max-width:0;padding:0;border:0;margin:0}.k-select{visibility:hidden}\n"], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5$1.DatePickerComponent, selector: "kendo-datepicker", inputs: ["focusableId", "cellTemplate", "monthCellTemplate", "yearCellTemplate", "decadeCellTemplate", "centuryCellTemplate", "weekNumberTemplate", "headerTitleTemplate", "navigationItemTemplate", "activeView", "bottomView", "topView", "calendarType", "animateCalendarNavigation", "disabled", "readonly", "readOnlyInput", "popupSettings", "navigation", "min", "max", "incompleteDateValidation", "focusedDate", "value", "format", "twoDigitYearMax", "formatPlaceholder", "placeholder", "tabindex", "tabIndex", "disabledDates", "title", "subtitle", "rangeValidation", "disabledDatesValidation", "weekNumber", "size", "rounded", "fillMode", "adaptiveMode"], outputs: ["valueChange", "focus", "blur", "open", "close"], exportAs: ["kendo-datepicker"] }, { kind: "directive", type: i2.ControlsDirective, selector: "[wmControls]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    MarkForCheck(),
    NotifyChange('Value')
], AjaxCalendarComponent.prototype, "value", null);
__decorate([
    serverEvent('ValueChanged')
], AjaxCalendarComponent.prototype, "onChange", null);
AjaxCalendarComponent = __decorate([
    dataTransfer(['ajxCal']),
    ExceptionHandlerClass(ErrorCodes.Winforms)
], AjaxCalendarComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AjaxCalendarComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-ajax-calendar', inputs: ['model'], template: "<div *ngIf=\"model\" class=\"datePickerWrapper\">\r\n    <kendo-datepicker #datepicker *ngIf=\"model && visible\"\r\n    calendarType=\"calendarType\" [value]=\"value\" (valueChange)=\"onChange($event)\" [ngClass]=\"class\" [format]=\"format\" \r\n    wmControls [hostComponent]=\"this\">\r\n    </kendo-datepicker>\r\n</div>\r\n", styles: [".k-datepicker{position:absolute;opacity:0;height:0;max-height:0;width:0;max-width:0;padding:0;border:0;margin:0}.k-input,.datePickerWrapper{opacity:0;height:0;max-height:0;width:0;max-width:0;padding:0;border:0;margin:0}.k-select{visibility:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: i2.ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: i2.AjaxInteractionBaseService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { datePicker: [{
                type: ViewChild,
                args: ['datepicker', { static: false }]
            }], ValueChanged: [{
                type: Output
            }], calendarType: [{
                type: Input
            }], value: [], onChange: [], documentClick: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

/**
 * Angular Component for AjaxModalPopUpExtender Control.
 *
 *
 * @export
 * @class AjaxModalPopUpExtender
 * @extends {ControlComponent}
 */
let AjaxModalPopUpExtenderComponent = class AjaxModalPopUpExtenderComponent extends ControlComponent {
    /**
     * Creates an instance of AjaxCalendarComponent.
     * @param {WebMapService} serviceRef
     * @param {ChangeDetectorRef} changeDetectorRef
     * @param {Renderer2} render2
     * @param {ElementRef} elem
     * @param {WebComponentsService} webComponents
     * @param {BringTopService} bringTopServ1
     * @param {ContainerInteractionService} [containerInteraction]
     * @memberof AjaxCalendarComponent
     */
    constructor(serviceRef, changeDetectorRef, render2, elem, webComponents, bringTopServ1, containerInteraction, ajaxInteractionService) {
        super(changeDetectorRef, render2, elem, webComponents, bringTopServ1, containerInteraction);
        this.serviceRef = serviceRef;
        this.changeDetectorRef = changeDetectorRef;
        this.render2 = render2;
        this.elem = elem;
        this.bringTopServ1 = bringTopServ1;
        this.containerInteraction = containerInteraction;
        this.ajaxInteractionService = ajaxInteractionService;
        /**
         * Opened state of the popup dialog
         *
         * @memberof AjaxModalPopUpExtender
         */
        this.opened = false;
    }
    /**
     * ngOnInit of AjaxModalPopUpExtenderComponent
     *
     * @memberof AjaxModalPopUpExtenderComponent
     */
    ngOnInit() {
        super.ngOnInit();
        /* c8 ignore start */
        this.ajaxInteractionService?.ClickEmittedNotification.subscribe((evt) => {
            if (evt.Id === this.targetControlID) {
                this.open();
            }
            if (evt.Id === this.cancelControlID) {
                this.close();
            }
        }); /* c8 ignore stop */
    }
    /**
     * ngOnDestroy of AjaxModalPopUpExtenderComponent
     *
     * @memberof AjaxModalPopUpExtenderComponent
     */
    ngOnDestroy() {
        this.applyStylesToCloseContent();
    }
    /**
     * Gets the BackgroundCSSClass from the model
     *
     * @readonly
     * @type {string}
     * @memberof AjaxModalPopUpExtender
     */
    get backgroundCSSClass() {
        return this.model?.BackgroundCssClass;
    }
    /**
     * Gets the CancelControlID from the model
     *
     * @readonly
     * @type {string}
     * @memberof AjaxModalPopUpExtender
     */
    get cancelControlID() {
        return this.model?.CancelControlID;
    }
    /**
     * Gets the PopUpControlID
     *
     * @readonly
     * @type {string}
     * @memberof AjaxModalPopUpExtender
     */
    get popupControlID() {
        return this.model?.PopupControlID;
    }
    /**
     * Gets the TargetControlID from the model
     *
     * @readonly
     * @type {string}
     * @memberof AjaxModalPopUpExtender
     */
    get targetControlID() {
        return this.model?.TargetControlID;
    }
    /**
     * Method to open the dialog
     *
     * @memberof AjaxModalPopUpExtender
     */
    open() {
        this.opened = true;
        this.detectChanges();
        this.applyStylesToShowContent();
        this.applyBackGroundCSSClass();
    }
    /**
     * Method to close the dialog
     *
     * @memberof AjaxModalPopUpExtender
     */
    close() {
        this.opened = false;
        this.detectChanges();
        this.applyStylesToCloseContent();
    }
    /**
     * Applies the background css class
     *
     * @memberof AjaxModalPopUpExtenderComponent
     */
    /* c8 ignore start */
    applyBackGroundCSSClass() {
        const backgroundElement = this.elem?.nativeElement?.querySelector('kendo-dialog > div.k-overlay');
        if (backgroundElement && this.backgroundCSSClass) {
            this.render2.addClass(backgroundElement, this.backgroundCSSClass);
        }
    } /* c8 ignore stop */
    /**
     * Applies the styles when the modal is opened
     *
     * @memberof AjaxModalPopUpExtenderComponent
     */
    /* c8 ignore start */
    applyStylesToShowContent() {
        const appBackground = document.querySelector('app-root');
        if (appBackground) {
            this.render2.setStyle(appBackground, 'pointer-events', 'none');
        }
        const element = document.querySelector(`#${this.popupControlID}`);
        if (element) {
            this.render2.setStyle(element, 'pointer-events', 'auto');
            this.render2.removeStyle(element, 'display');
            this.render2.setStyle(element, 'display', 'fixed');
            this.render2.addClass(element, 'k-window');
            this.render2.addClass(element, 'k-k-dialog');
            this.render2.setStyle(element, 'top', '50%');
            this.render2.setStyle(element, 'left', '40%');
        }
    } /* c8 ignore stop */
    /**
     * Applies the styles when the modal is closed
     *
     * @memberof AjaxModalPopUpExtenderComponent
     */
    /* c8 ignore start */
    applyStylesToCloseContent() {
        const appBackground = document.querySelector('app-root');
        if (appBackground) {
            this.render2.removeStyle(appBackground, 'pointer-events');
        }
        const element = document.querySelector(`#${this.popupControlID}`);
        if (element) {
            this.render2.removeClass(element, 'k-window');
            this.render2.removeClass(element, 'k-k-dialog');
            this.render2.removeStyle(element, 'display');
            this.render2.setStyle(element, 'display', 'none');
            this.render2.removeStyle(element, 'top');
            this.render2.removeStyle(element, 'left');
        }
    } /* c8 ignore stop */
};
AjaxModalPopUpExtenderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AjaxModalPopUpExtenderComponent, deps: [{ token: i1.WebMapService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.WebComponentsService }, { token: i3.BringTopService, optional: true }, { token: i2.ContainerInteractionService, optional: true }, { token: i2.AjaxInteractionBaseService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
AjaxModalPopUpExtenderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: AjaxModalPopUpExtenderComponent, selector: "wm-modalpopup-extender", inputs: { model: "model" }, usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"model\">\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
AjaxModalPopUpExtenderComponent = __decorate([
    dataTransfer(['mdlpppxtndr'])
], AjaxModalPopUpExtenderComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AjaxModalPopUpExtenderComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'wm-modalpopup-extender', inputs: ['model'], template: "<div *ngIf=\"model\">\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.WebMapService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.WebComponentsService }, { type: i3.BringTopService, decorators: [{
                    type: Optional
                }] }, { type: i2.ContainerInteractionService, decorators: [{
                    type: Optional
                }] }, { type: i2.AjaxInteractionBaseService, decorators: [{
                    type: Optional
                }] }]; } });

/*****************************************************************************
 * Copyright (C) Mobilize.Net <info@mobilize.net> - All Rights Reserved
 *
 * This file is part of the Mobilize Frameworks, which is
 * proprietary and confidential.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobilize.Net Corporation.
 * The intellectual and technical concepts contained herein are
 * proprietary to Mobilize.Net Corporation and may be covered
 * by U.S. Patents, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobilize.Net Corporation.
 ******************************************************************************/
class AjaxModule {
}
AjaxModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AjaxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AjaxModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: AjaxModule, bootstrap: [AjaxCalendarComponent, AjaxModalPopUpExtenderComponent], declarations: [AjaxCalendarComponent, AjaxModalPopUpExtenderComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        LabelModule,
        DateInputsModule,
        WebMapModule,
        FormsModule,
        ReactiveFormsModule,
        InputsModule,
        WebMapKendoModule,
        BaseComponentsModule,
        DialogsModule], exports: [AjaxCalendarComponent, AjaxModalPopUpExtenderComponent] });
AjaxModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AjaxModule, imports: [BrowserModule,
        BrowserAnimationsModule,
        LabelModule,
        DateInputsModule,
        WebMapModule,
        FormsModule,
        ReactiveFormsModule,
        InputsModule,
        WebMapKendoModule,
        BaseComponentsModule,
        DialogsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AjaxModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AjaxCalendarComponent, AjaxModalPopUpExtenderComponent],
                    imports: [
                        BrowserModule,
                        BrowserAnimationsModule,
                        LabelModule,
                        DateInputsModule,
                        WebMapModule,
                        FormsModule,
                        ReactiveFormsModule,
                        InputsModule,
                        WebMapKendoModule,
                        BaseComponentsModule,
                        DialogsModule
                    ],
                    exports: [AjaxCalendarComponent, AjaxModalPopUpExtenderComponent],
                    bootstrap: [AjaxCalendarComponent, AjaxModalPopUpExtenderComponent]
                }]
        }] });

/*
 * Public API Surface of WebForms
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AjaxCalendarComponent, AjaxModalPopUpExtenderComponent, AjaxModule, AlinkComponent, AspPanelComponent, AspTextBoxComponentComponent, BaseValidatorComponent, BoundFieldComponent, ClientClickDirective, CompareValidatorComponent, CustomValidatorComponent, DataControlFieldComponent, DataListComponent, DefaultButtonService, DropdownListComponent, GridLines, GridViewColumnsComponent, GridViewComponent, HtmlControlDirective, HyperlinkComponent, HyperlinkFieldComponent, ImageComponent, InternalEventHandlerService, LinkButtonComponent, MasterPageComponent, PageComponent, PagerVerticalAlign, PagesRendererService, RangeValidatorComponent, RegularExpressionValidatorComponent, RequiredFieldValidatorComponent, TableCellComponent, TableComponent, TableRowComponent, TemplateFieldComponent, UnitType, ValidationSummaryComponent, ValidationSummaryDisplayMode, ValidatorDisplay, WebFormsBaseValidatorService, WebFormsMainTabOrderService, WebFormsModule };
